"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6638],{

/***/ 54180:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ BottomSections; }
});

// EXTERNAL MODULE: ../../shared/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(14140);
// EXTERNAL MODULE: ../../shared/node_modules/react/index.js
var react = __webpack_require__(89736);
// EXTERNAL MODULE: ./helpers/i18n.ts + 7 modules
var i18n = __webpack_require__(95925);
// EXTERNAL MODULE: ../../shared/node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(31969);
// EXTERNAL MODULE: ../../shared/node_modules/react-loading-skeleton/dist/index.mjs
var dist = __webpack_require__(91932);
;// CONCATENATED MODULE: ./components/Skeletons/FooterSkeleton.tsx



function FooterSkeleton(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "text-center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
            height: (props === null || props === void 0 ? void 0 : props.height) ? props.height : 250,
            className: "col-12"
        })
    });
}

// EXTERNAL MODULE: ./components/Contact.tsx + 4 modules
var Contact = __webpack_require__(46465);
// EXTERNAL MODULE: ../../shared/node_modules/next/image.js
var next_image = __webpack_require__(53429);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./helpers/class/Consts.ts
var Consts = __webpack_require__(92288);
// EXTERNAL MODULE: ./helpers/class/Checkers.ts
var Checkers = __webpack_require__(83974);
// EXTERNAL MODULE: ./helpers/MethodHelper.ts
var MethodHelper = __webpack_require__(23158);
;// CONCATENATED MODULE: ./components/footer/menu/FooterMenu.tsx





function FooterMenu(props) {
    var localeBase = (0,i18n/* useLocalePrefix */._X)();
    var showMenuItems = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_header_show_menu_items");
    });
    var referer =  true ? window.location.origin + localeBase + "/" : 0;
    var topLevelHref = function(menu, loggiaUrl) {
        if (menu.hasOwnProperty("redirectUrl")) {
            return menu.redirectUrl;
        }
        var slug = Checkers/* default.isValidString */.Z.isValidString(loggiaUrl) ? loggiaUrl : menu.urlSlug != null ? menu.urlSlug : null;
        if (slug == null) {
            return "#";
        }
        return referer + (slug.startsWith("/") ? slug.substring(1) : slug);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: showMenuItems == "1" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "d-flex flex-wrap justify-content-center justify-content-lg-start no-style no-padding font-arial fs-11",
                style: {
                    marginLeft: -10
                },
                children: Checkers/* default.isValidArray */.Z.isValidArray(props.menu) && props.menu.map(function(menu, key) {
                    var loggiaUrl = menu.loggiaUrl;
                    if (Checkers/* default.isValidString */.Z.isValidString(loggiaUrl) && loggiaUrl.startsWith("/")) {
                    // loggiaUrl = loggiaUrl.substring(1);
                    }
                    return menu.title != null ? // eslint-disable-next-line react/jsx-key
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "inline",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            // href={menu.hasOwnProperty('redirectUrl') && Checkers.isValidString(menu.redirectUrl) ? menu.redirectUrl : (loggiaUrl != null ? referer + loggiaUrl : menu.urlSlug != null ? referer + menu.urlSlug : '#')}
                            href: topLevelHref(menu, loggiaUrl),
                            className: "p-l-10 p-r-10 ".concat(props.hasOwnProperty("apps") && props.apps == true ? "opacity-60" : ""),
                            children: menu.title
                        })
                    }, key) : "";
                })
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
        })
    });
}

;// CONCATENATED MODULE: ./components/footer/partials/PolicyNotice.tsx


// Same notice as the Lodge footer (theme_1 footer.html.twig): only when the site has a privacy policy and/or terms of use.
// The sentence is translated as a whole ({privacy} / {terms} mark where the links go) because word order and articles
// differ per language.
function PolicyNotice(props) {
    var localizePath = (0,i18n/* useLocalizePath */.Wb)();
    var t = (0,i18n/* useT */.NT)();
    if (!props.hasPrivacyPolicy && !props.hasTermsAndConditions) {
        return null;
    }
    var linkStyle = {
        color: "inherit",
        textDecoration: "underline"
    };
    var links = {
        "{privacy}": /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: localizePath("/privacy-policy"),
            target: "_self",
            style: linkStyle,
            children: t("footer.privacyPolicy")
        }),
        "{terms}": /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: localizePath("/terms-and-conditions"),
            target: "_self",
            style: linkStyle,
            children: t("footer.termsOfUse")
        })
    };
    var key = props.hasPrivacyPolicy && props.hasTermsAndConditions ? "footer.policyNoticeBoth" : props.hasPrivacyPolicy ? "footer.policyNoticePrivacy" : "footer.policyNoticeTerms";
    var _part;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
        className: "fs-11 muted",
        children: t(key).split(/(\{privacy\}|\{terms\})/).map(function(part, i) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: (_part = links[part]) !== null && _part !== void 0 ? _part : part
            }, i);
        })
    });
}

;// CONCATENATED MODULE: ./components/footer/partials/LoggiaSVGNew.tsx

function LoggiaSVG(props) {
    var footerClass = props.footerClass;
    var logoModeHandler = function() {
        if (footerClass === "light-mode") {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                width: "119",
                height: "16",
                viewBox: "0 0 400 54",
                role: "img",
                "aria-label": "Powered by revplus",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                        clipPath: "url(#clip0_7747_4617)",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M15.8746 26.4735C14.3635 25.5192 12.67 25.042 10.7982 25.042C9.27105 25.042 7.8822 25.3682 6.62962 26.0185C5.51934 26.5963 4.61148 27.3775 3.88599 28.3419V25.4769H0V54H3.88799V43.2427C4.59945 44.201 5.49128 44.9761 6.58754 45.5479C7.84011 46.1983 9.245 46.5244 10.8002 46.5244C12.672 46.5244 14.3635 46.0553 15.8766 45.1131C17.3877 44.1728 18.5762 42.8923 19.4399 41.2736C20.3037 39.6549 20.7366 37.8308 20.7366 35.8053C20.7366 33.7799 20.3057 31.9578 19.4399 30.3371C18.5762 28.7164 17.3877 27.4298 15.8766 26.4755L15.8746 26.4735ZM15.8967 39.4274C15.3195 40.4844 14.5439 41.3159 13.5639 41.9219C12.5839 42.5299 11.4475 42.8339 10.1509 42.8339C8.8542 42.8339 7.75393 42.5299 6.75989 41.9219C5.76585 41.3139 5.00228 40.4824 4.47119 39.4274C3.93809 38.3724 3.67154 37.1644 3.67154 35.8033C3.67154 34.4423 3.94411 33.186 4.49323 32.1149C5.04036 31.0438 5.80393 30.2123 6.78194 29.6203C7.75995 29.0284 8.89829 28.7304 10.195 28.7304C11.4916 28.7304 12.5839 29.0284 13.5639 29.6203C14.5419 30.2143 15.3195 31.0458 15.8967 32.1149C16.4718 33.186 16.7604 34.4 16.7604 35.759C16.7604 37.1181 16.4718 38.3704 15.8967 39.4254V39.4274Z",
                                fill: "#1D1D1B"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M39.2867 26.4514C37.6594 25.5112 35.8517 25.04 33.8656 25.04C31.8795 25.04 30.0357 25.5172 28.4224 26.4715C26.8091 27.4259 25.5285 28.7063 24.5785 30.311C23.6286 31.9176 23.1536 33.7176 23.1536 35.7148C23.1536 37.7121 23.6286 39.5704 24.5785 41.2052C25.5285 42.84 26.8091 44.1346 28.4224 45.089C30.0357 46.0433 31.8495 46.5204 33.8656 46.5204C35.8817 46.5204 37.6594 46.0433 39.2867 45.089C40.9141 44.1346 42.2027 42.84 43.1527 41.2052C44.1026 39.5704 44.5776 37.7402 44.5776 35.7148C44.5776 33.6894 44.1026 31.9116 43.1527 30.2908C42.2027 28.6701 40.9141 27.3916 39.2867 26.4514ZM39.6976 39.3409C39.1204 40.3979 38.3288 41.2294 37.3227 41.8354C36.3146 42.4434 35.1623 42.7474 33.8656 42.7474C32.5689 42.7474 31.4186 42.4434 30.4105 41.8354C29.4024 41.2274 28.6108 40.3958 28.0356 39.3409C27.4584 38.2859 27.1718 37.0778 27.1718 35.7168C27.1718 34.3558 27.4604 33.2001 28.0356 32.1592C28.6108 31.1183 29.4024 30.3009 30.4105 29.707C31.4186 29.113 32.5709 28.8171 33.8656 28.8171C35.1603 28.8171 36.3066 29.113 37.3007 29.707C38.2947 30.3009 39.0863 31.1163 39.6775 32.1592C40.2667 33.2001 40.5634 34.388 40.5634 35.7168C40.5634 37.0456 40.2748 38.2859 39.6996 39.3409H39.6976Z",
                                fill: "#1D1D1B"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M67.3464 39.7535L62.1597 25.4749H59.9131L54.7285 39.7535L49.5037 25.4749H45.4434L53.5641 46.0895H55.8107L61.0555 32.3786L66.2642 46.0895H68.5529L76.6315 25.4749H72.5711L67.3464 39.7535Z",
                                fill: "#1D1D1B"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M93.1114 26.3426C91.6564 25.4749 89.9789 25.042 88.079 25.042C86.1791 25.042 84.2992 25.5131 82.7 26.4533C81.1007 27.3936 79.8341 28.6741 78.8981 30.2928C77.9622 31.9135 77.4933 33.7356 77.4933 35.7611C77.4933 37.7865 77.9682 39.6529 78.9182 41.2716C79.8681 42.8923 81.1648 44.1728 82.8062 45.111C84.4475 46.0513 86.2913 46.5224 88.3355 46.5224C89.9468 46.5224 91.468 46.2184 92.8929 45.6104C94.3178 45.0023 95.5203 44.1205 96.5003 42.9628L93.9952 40.4018C93.3037 41.2112 92.476 41.8192 91.5121 42.2239C90.5461 42.6286 89.4879 42.8319 88.3375 42.8319C86.9547 42.8319 85.7302 42.536 84.666 41.942C83.5998 41.3501 82.7801 40.5105 82.2029 39.4253C81.8502 38.763 81.6077 38.0321 81.4714 37.2328H97.5384C97.6246 36.7999 97.6827 36.4154 97.7108 36.0832C97.7389 35.751 97.7529 35.4389 97.7529 35.151C97.7529 33.2122 97.342 31.4766 96.5224 29.9445C95.7007 28.4103 94.5643 27.2104 93.1093 26.3426H93.1114ZM84.4936 29.5116C85.5017 28.9338 86.6681 28.6439 87.9928 28.6439C89.3176 28.6439 90.3397 28.9116 91.2335 29.4472C92.1253 29.9827 92.8167 30.7357 93.3057 31.7042C93.6384 32.3645 93.8489 33.1276 93.9551 33.9813H81.4895C81.6217 33.2383 81.8382 32.5538 82.1588 31.9417C82.706 30.9008 83.4836 30.0915 84.4916 29.5116H84.4936Z",
                                fill: "#1D1D1B"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M113.609 25.5836C112.774 25.2232 111.838 25.042 110.802 25.042C108.527 25.042 106.783 25.8232 105.575 27.3855C105.453 27.5446 105.34 27.7117 105.228 27.8828V25.4769H101.34V46.0895H105.228V34.3296C105.228 32.4491 105.689 31.0458 106.611 30.1197C107.533 29.1935 108.713 28.7304 110.152 28.7304C110.844 28.7304 111.447 28.8331 111.966 29.0345C112.485 29.2378 112.96 29.57 113.391 30.0331L115.94 27.3855C115.221 26.548 114.443 25.946 113.607 25.5856L113.609 25.5836Z",
                                fill: "#1D1D1B"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M131.643 26.3426C130.188 25.4749 128.51 25.042 126.61 25.042C124.71 25.042 122.83 25.5131 121.231 26.4533C119.632 27.3936 118.365 28.6741 117.429 30.2928C116.493 31.9135 116.024 33.7356 116.024 35.7611C116.024 37.7865 116.499 39.6529 117.449 41.2716C118.399 42.8923 119.696 44.1728 121.337 45.111C122.979 46.0513 124.823 46.5224 126.867 46.5224C128.478 46.5224 129.999 46.2184 131.424 45.6104C132.849 45.0023 134.051 44.1205 135.031 42.9628L132.526 40.4018C131.835 41.2112 131.007 41.8192 130.043 42.2239C129.079 42.6286 128.019 42.8319 126.869 42.8319C125.486 42.8319 124.261 42.536 123.197 41.942C122.131 41.3501 121.311 40.5105 120.734 39.4253C120.381 38.763 120.139 38.0321 120.003 37.2328H136.07C136.156 36.7999 136.214 36.4154 136.242 36.0832C136.27 35.751 136.286 35.4389 136.286 35.151C136.286 33.2122 135.875 31.4766 135.056 29.9445C134.236 28.4103 133.098 27.2104 131.643 26.3426ZM123.025 29.5116C124.033 28.9338 125.199 28.6439 126.524 28.6439C127.849 28.6439 128.871 28.9116 129.765 29.4472C130.656 29.9827 131.348 30.7357 131.839 31.7042C132.172 32.3645 132.382 33.1276 132.488 33.9813H120.023C120.155 33.2383 120.371 32.5538 120.692 31.9417C121.239 30.9008 122.017 30.0915 123.025 29.5116Z",
                                fill: "#1D1D1B"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M155.423 28.34C154.7 27.3776 153.798 26.5964 152.702 26.0186C151.463 25.3683 150.08 25.0421 148.555 25.0421C146.653 25.0421 144.956 25.5193 143.459 26.4736C141.962 27.4279 140.773 28.7164 139.895 30.3352C139.016 31.9559 138.579 33.778 138.579 35.8034C138.579 37.8289 139.018 39.6509 139.895 41.2717C140.773 42.8924 141.962 44.1729 143.459 45.1111C144.956 46.0514 146.655 46.5225 148.555 46.5225C150.11 46.5225 151.507 46.1963 152.746 45.546C153.83 44.9762 154.714 44.2011 155.423 43.2428V46.0896H159.355V17.5665H155.423V28.3379V28.34ZM152.594 41.922C151.63 42.53 150.499 42.834 149.203 42.834C147.906 42.834 146.762 42.53 145.768 41.922C144.774 41.314 143.996 40.4825 143.435 39.4275C142.874 38.3725 142.593 37.1504 142.593 35.7612C142.593 34.3719 142.874 33.1941 143.435 32.1371C143.996 31.0821 144.765 30.2486 145.745 29.6426C146.724 29.0346 147.862 28.7305 149.159 28.7305C150.455 28.7305 151.585 29.0346 152.549 29.6426C153.513 30.2506 154.277 31.0741 154.838 32.117C155.399 33.1579 155.68 34.388 155.68 35.8054C155.68 37.2228 155.405 38.3725 154.858 39.4295C154.311 40.4865 153.556 41.318 152.59 41.924L152.594 41.922Z",
                                fill: "#1D1D1B"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M188.578 26.4736C187.064 25.5193 185.373 25.0421 183.501 25.0421C181.974 25.0421 180.585 25.3683 179.333 26.0186C178.222 26.5964 177.314 27.3776 176.589 28.34V17.5665H172.701V46.0876H176.589V43.2407C177.3 44.1991 178.192 44.9742 179.288 45.546C180.541 46.1963 181.944 46.5225 183.499 46.5225C185.371 46.5225 187.062 46.0534 188.576 45.1111C190.087 44.1709 191.275 42.8904 192.139 41.2717C193.003 39.653 193.434 37.8289 193.434 35.8034C193.434 33.778 193.003 31.9559 192.139 30.3352C191.275 28.7144 190.087 27.4279 188.576 26.4736H188.578ZM188.598 39.4275C188.02 40.4845 187.243 41.316 186.265 41.922C185.285 42.53 184.148 42.834 182.852 42.834C181.555 42.834 180.455 42.53 179.461 41.922C178.467 41.314 177.703 40.4825 177.172 39.4275C176.639 38.3725 176.372 37.1645 176.372 35.8034C176.372 34.4424 176.645 33.1861 177.194 32.115C177.741 31.0439 178.505 30.2124 179.483 29.6204C180.461 29.0285 181.599 28.7305 182.896 28.7305C184.193 28.7305 185.285 29.0285 186.265 29.6204C187.243 30.2144 188.02 31.0459 188.598 32.115C189.173 33.1861 189.461 34.4001 189.461 35.7591C189.461 37.1181 189.173 38.3705 188.598 39.4254V39.4275Z",
                                fill: "#1D1D1B"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M210.757 25.4749L204.512 40.0897L198.576 25.4749H194.257L202.328 44.3299L197.63 53.998H201.931L205.488 46.2627L215.078 25.4749H210.757Z",
                                fill: "#1D1D1B"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M398.497 0H391.931C391.101 0 390.428 0.676055 390.428 1.51001V8.10574C390.428 8.93969 391.101 9.61575 391.931 9.61575H398.497C399.327 9.61575 400 8.93969 400 8.10574V1.51001C400 0.676055 399.327 0 398.497 0Z",
                                fill: "#4966F2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M244.146 19.3141C243.182 18.9114 242.086 18.7141 240.877 18.7141C238.081 18.7141 235.931 19.6101 234.444 21.3999C234.428 21.4241 234.412 21.4482 234.396 21.4664V19.2416H227.604V44.4105H234.396V30.5003C234.396 28.6278 234.853 27.2245 235.769 26.3044C236.684 25.3843 237.869 24.9253 239.324 24.9253C240.019 24.9253 240.633 25.032 241.164 25.2374C241.695 25.4427 242.162 25.7628 242.536 26.1736L246.795 21.2791C246.002 20.3751 245.12 19.7268 244.148 19.3242V19.3161L244.146 19.3141Z",
                                fill: "#464849"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M265.652 20.2985C263.804 19.2073 261.664 18.6556 259.243 18.6556C256.822 18.6556 254.559 19.2395 252.549 20.3972C250.539 21.5549 248.96 23.1233 247.799 25.0863C246.639 27.0493 246.066 29.2821 246.066 31.7786C246.066 34.2752 246.663 36.5744 247.855 38.5536C249.048 40.5327 250.667 42.085 252.711 43.2185C254.747 44.352 257.084 44.9097 259.716 44.9097C261.752 44.9097 263.648 44.5493 265.397 43.8185C267.147 43.0876 268.618 42.0125 269.837 40.5911L265.848 36.5845C265.089 37.4543 264.189 38.1046 263.151 38.5395C262.113 38.9743 260.952 39.1878 259.678 39.1878C258.255 39.1878 257.012 38.8837 255.942 38.2757C254.872 37.6677 254.046 36.7979 253.481 35.6644C253.252 35.2134 253.072 34.7362 252.942 34.2269L271.251 34.1786C271.39 33.5866 271.488 33.0531 271.538 32.586C271.586 32.1189 271.612 31.6578 271.612 31.2068C271.612 28.809 271.081 26.6667 270.027 24.7682C268.973 22.8716 267.518 21.3777 265.67 20.2844L265.654 20.3005L265.652 20.2985ZM255.711 25.2514C256.718 24.6433 257.894 24.3393 259.235 24.3393C260.575 24.3393 261.598 24.6111 262.479 25.1447C263.361 25.6782 264.033 26.4594 264.498 27.4681C264.726 27.9533 264.898 28.4949 265.029 29.0948L252.898 29.1271C253.02 28.66 253.184 28.215 253.389 27.8043C253.92 26.7131 254.697 25.8574 255.701 25.2514H255.709H255.711Z",
                                fill: "#464849"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M285.26 35.1792L279.156 19.2314H271.692L282.735 44.4003H287.615L298.61 19.2314H291.399L285.26 35.1792Z",
                                fill: "#464849"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M321.072 20.4315C319.24 19.2899 317.164 18.7061 314.843 18.7061C313.045 18.7061 311.426 19.0846 309.987 19.8476C309.137 20.2986 308.386 20.8503 307.73 21.4905V19.2154H300.938V54H307.682V42.1595C308.336 42.7917 309.097 43.3414 309.963 43.7863C311.418 44.5333 313.045 44.9118 314.835 44.9118C317.148 44.9118 319.224 44.336 321.064 43.1863C322.896 42.0448 324.343 40.4764 325.397 38.4973C326.451 36.5181 326.982 34.2934 326.982 31.8291C326.982 29.3647 326.451 27.0836 325.397 25.1045C324.343 23.1254 322.896 21.565 321.064 20.4154L321.072 20.4315ZM319.232 35.3605C318.693 36.3873 317.941 37.1825 316.975 37.7584C316.011 38.3342 314.899 38.6201 313.657 38.6201C312.414 38.6201 311.31 38.3322 310.362 37.7584C309.414 37.1825 308.67 36.3873 308.131 35.3605C307.592 34.3417 307.33 33.1438 307.33 31.7888C307.33 30.4338 307.6 29.2922 308.131 28.2735C308.662 27.2547 309.422 26.4514 310.388 25.8756C311.352 25.2998 312.448 25.0139 313.657 25.0139C314.865 25.0139 316.011 25.3018 316.975 25.8756C317.939 26.4494 318.693 27.2467 319.232 28.2735C319.763 29.3003 320.034 30.4741 320.034 31.7888C320.034 33.1035 319.763 34.3337 319.232 35.3605Z",
                                fill: "#4966F2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M337.459 9.61572H330.668V44.4003H337.459V9.61572Z",
                                fill: "#4966F2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M357.903 33.6672C357.903 35.2276 357.503 36.4517 356.711 37.3134C355.917 38.1831 354.807 38.62 353.392 38.62C352.46 38.62 351.643 38.4308 350.957 38.0442C350.27 37.6577 349.747 37.1 349.404 36.353C349.053 35.6061 348.881 34.7101 348.881 33.6672V19.2315H342.031V33.8242C342.031 36.0168 342.514 37.9375 343.486 39.6046C344.458 41.2716 345.799 42.5763 347.508 43.5125C349.226 44.4487 351.186 44.9158 353.394 44.9158C355.603 44.9158 357.571 44.4567 359.28 43.5366C360.998 42.6165 362.321 41.3199 363.269 39.6529C364.216 37.9858 364.691 36.0389 364.691 33.8142V19.2214H357.9V33.6571L357.908 33.6652L357.903 33.6672Z",
                                fill: "#4966F2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M384.534 30.8505C383.586 30.2586 382.58 29.7996 381.526 29.4714C380.472 29.1432 379.458 28.8472 378.494 28.5855C377.53 28.3218 376.736 28.0198 376.131 27.6735C375.526 27.3292 375.223 26.8359 375.223 26.2118C375.223 25.6621 375.494 25.2172 376.025 24.9051C376.556 24.593 377.333 24.438 378.338 24.438C379.45 24.438 380.472 24.6434 381.428 25.0622C382.376 25.4809 383.234 26.1534 383.995 27.0896L388.09 22.9763C386.977 21.5146 385.588 20.4234 383.913 19.6926C382.238 18.9617 380.358 18.6013 378.281 18.6013C376.205 18.6013 374.596 18.9295 373.149 19.5959C371.694 20.2523 370.582 21.1804 369.806 22.3542C369.03 23.536 368.638 24.9252 368.638 26.5259C368.638 28.1265 368.94 29.2922 369.545 30.2546C370.151 31.2069 370.934 31.9538 371.908 32.4954C372.872 33.037 373.886 33.4639 374.941 33.8021C375.995 34.1383 377.009 34.4262 377.973 34.688C378.937 34.9517 379.73 35.2718 380.336 35.6483C380.941 36.0268 381.243 36.5684 381.243 37.2651C381.243 37.8892 380.957 38.3563 380.386 38.6684C379.813 38.9804 378.971 39.1355 377.869 39.1355C376.488 39.1355 375.221 38.8979 374.085 38.4046C372.948 37.9194 371.942 37.1885 371.077 36.2121L367.03 40.3253C367.864 41.2938 368.844 42.1233 369.988 42.7977C371.133 43.4702 372.383 44.0057 373.748 44.3903C375.113 44.7688 376.502 44.9661 377.925 44.9661C380.965 44.9661 383.376 44.2433 385.133 42.8058C386.899 41.3683 387.781 39.4153 387.781 36.9429C387.781 35.4148 387.478 34.1585 386.873 33.19C386.268 32.2216 385.492 31.4324 384.544 30.8505H384.528H384.536H384.534Z",
                                fill: "#4966F2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                            id: "clip0_7747_4617",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                width: "400",
                                height: "54",
                                fill: "white"
                            })
                        })
                    })
                ]
            });
        } else {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                width: "119",
                height: "16",
                viewBox: "0 0 400 54",
                role: "img",
                "aria-label": "Powered by revplus",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                        clipPath: "url(#clip0_7747_4657)",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M15.8746 26.4735C14.3635 25.5192 12.67 25.042 10.7982 25.042C9.27105 25.042 7.8822 25.3682 6.62962 26.0185C5.51934 26.5963 4.61148 27.3775 3.88599 28.3419V25.4769H0V54H3.88799V43.2427C4.59945 44.201 5.49128 44.9761 6.58754 45.5479C7.84011 46.1983 9.245 46.5244 10.8002 46.5244C12.672 46.5244 14.3635 46.0553 15.8766 45.1131C17.3877 44.1728 18.5762 42.8923 19.4399 41.2736C20.3037 39.6549 20.7366 37.8308 20.7366 35.8053C20.7366 33.7799 20.3057 31.9578 19.4399 30.3371C18.5762 28.7164 17.3877 27.4298 15.8766 26.4755L15.8746 26.4735ZM15.8967 39.4274C15.3195 40.4844 14.5439 41.3159 13.5639 41.9219C12.5839 42.5299 11.4475 42.8339 10.1509 42.8339C8.8542 42.8339 7.75393 42.5299 6.75989 41.9219C5.76585 41.3139 5.00228 40.4824 4.47119 39.4274C3.93809 38.3724 3.67154 37.1644 3.67154 35.8033C3.67154 34.4423 3.94411 33.186 4.49323 32.1149C5.04036 31.0438 5.80393 30.2123 6.78194 29.6203C7.75995 29.0284 8.89829 28.7304 10.195 28.7304C11.4916 28.7304 12.5839 29.0284 13.5639 29.6203C14.5419 30.2143 15.3195 31.0458 15.8967 32.1149C16.4718 33.186 16.7604 34.4 16.7604 35.759C16.7604 37.1181 16.4718 38.3704 15.8967 39.4254V39.4274Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M39.2867 26.4514C37.6594 25.5112 35.8517 25.04 33.8656 25.04C31.8795 25.04 30.0357 25.5172 28.4224 26.4715C26.8091 27.4259 25.5285 28.7063 24.5785 30.311C23.6286 31.9176 23.1536 33.7176 23.1536 35.7148C23.1536 37.7121 23.6286 39.5704 24.5785 41.2052C25.5285 42.84 26.8091 44.1346 28.4224 45.089C30.0357 46.0433 31.8495 46.5204 33.8656 46.5204C35.8817 46.5204 37.6594 46.0433 39.2867 45.089C40.9141 44.1346 42.2027 42.84 43.1527 41.2052C44.1026 39.5704 44.5776 37.7402 44.5776 35.7148C44.5776 33.6894 44.1026 31.9116 43.1527 30.2908C42.2027 28.6701 40.9141 27.3916 39.2867 26.4514ZM39.6976 39.3409C39.1204 40.3979 38.3288 41.2294 37.3227 41.8354C36.3146 42.4434 35.1623 42.7474 33.8656 42.7474C32.5689 42.7474 31.4186 42.4434 30.4105 41.8354C29.4024 41.2274 28.6108 40.3958 28.0356 39.3409C27.4584 38.2859 27.1718 37.0778 27.1718 35.7168C27.1718 34.3558 27.4604 33.2001 28.0356 32.1592C28.6108 31.1183 29.4024 30.3009 30.4105 29.707C31.4186 29.113 32.5709 28.8171 33.8656 28.8171C35.1603 28.8171 36.3066 29.113 37.3007 29.707C38.2947 30.3009 39.0863 31.1163 39.6775 32.1592C40.2667 33.2001 40.5634 34.388 40.5634 35.7168C40.5634 37.0456 40.2748 38.2859 39.6996 39.3409H39.6976Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M67.3464 39.7535L62.1597 25.4749H59.9131L54.7285 39.7535L49.5037 25.4749H45.4434L53.5641 46.0895H55.8107L61.0555 32.3786L66.2642 46.0895H68.5529L76.6315 25.4749H72.5711L67.3464 39.7535Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M93.1114 26.3426C91.6564 25.4749 89.9789 25.042 88.079 25.042C86.1791 25.042 84.2992 25.5131 82.7 26.4533C81.1007 27.3936 79.8341 28.6741 78.8981 30.2928C77.9622 31.9135 77.4933 33.7356 77.4933 35.7611C77.4933 37.7865 77.9682 39.6529 78.9182 41.2716C79.8681 42.8923 81.1648 44.1728 82.8062 45.111C84.4475 46.0513 86.2913 46.5224 88.3355 46.5224C89.9468 46.5224 91.468 46.2184 92.8929 45.6104C94.3178 45.0023 95.5203 44.1205 96.5003 42.9628L93.9952 40.4018C93.3037 41.2112 92.476 41.8192 91.5121 42.2239C90.5461 42.6286 89.4879 42.8319 88.3375 42.8319C86.9547 42.8319 85.7302 42.536 84.666 41.942C83.5998 41.3501 82.7801 40.5105 82.2029 39.4253C81.8502 38.763 81.6077 38.0321 81.4714 37.2328H97.5384C97.6246 36.7999 97.6827 36.4154 97.7108 36.0832C97.7389 35.751 97.7529 35.4389 97.7529 35.151C97.7529 33.2122 97.342 31.4766 96.5224 29.9445C95.7007 28.4103 94.5643 27.2104 93.1093 26.3426H93.1114ZM84.4936 29.5116C85.5017 28.9338 86.6681 28.6439 87.9928 28.6439C89.3176 28.6439 90.3397 28.9116 91.2335 29.4472C92.1253 29.9827 92.8167 30.7357 93.3057 31.7042C93.6384 32.3645 93.8489 33.1276 93.9551 33.9813H81.4895C81.6217 33.2383 81.8382 32.5538 82.1588 31.9417C82.706 30.9008 83.4836 30.0915 84.4916 29.5116H84.4936Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M113.609 25.5836C112.774 25.2232 111.838 25.042 110.802 25.042C108.527 25.042 106.783 25.8232 105.575 27.3855C105.453 27.5446 105.34 27.7117 105.228 27.8828V25.4769H101.34V46.0895H105.228V34.3296C105.228 32.4491 105.689 31.0458 106.611 30.1197C107.533 29.1935 108.713 28.7304 110.152 28.7304C110.844 28.7304 111.447 28.8331 111.966 29.0345C112.485 29.2378 112.96 29.57 113.391 30.0331L115.94 27.3855C115.221 26.548 114.443 25.946 113.607 25.5856L113.609 25.5836Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M131.643 26.3426C130.188 25.4749 128.51 25.042 126.61 25.042C124.71 25.042 122.83 25.5131 121.231 26.4533C119.632 27.3936 118.365 28.6741 117.429 30.2928C116.493 31.9135 116.024 33.7356 116.024 35.7611C116.024 37.7865 116.499 39.6529 117.449 41.2716C118.399 42.8923 119.696 44.1728 121.337 45.111C122.979 46.0513 124.823 46.5224 126.867 46.5224C128.478 46.5224 129.999 46.2184 131.424 45.6104C132.849 45.0023 134.051 44.1205 135.031 42.9628L132.526 40.4018C131.835 41.2112 131.007 41.8192 130.043 42.2239C129.079 42.6286 128.019 42.8319 126.869 42.8319C125.486 42.8319 124.261 42.536 123.197 41.942C122.131 41.3501 121.311 40.5105 120.734 39.4253C120.381 38.763 120.139 38.0321 120.003 37.2328H136.07C136.156 36.7999 136.214 36.4154 136.242 36.0832C136.27 35.751 136.286 35.4389 136.286 35.151C136.286 33.2122 135.875 31.4766 135.056 29.9445C134.236 28.4103 133.098 27.2104 131.643 26.3426ZM123.025 29.5116C124.033 28.9338 125.199 28.6439 126.524 28.6439C127.849 28.6439 128.871 28.9116 129.765 29.4472C130.656 29.9827 131.348 30.7357 131.839 31.7042C132.172 32.3645 132.382 33.1276 132.488 33.9813H120.023C120.155 33.2383 120.371 32.5538 120.692 31.9417C121.239 30.9008 122.017 30.0915 123.025 29.5116Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M155.423 28.34C154.7 27.3776 153.798 26.5964 152.702 26.0186C151.463 25.3683 150.08 25.0421 148.555 25.0421C146.653 25.0421 144.956 25.5193 143.459 26.4736C141.962 27.4279 140.773 28.7164 139.895 30.3352C139.016 31.9559 138.579 33.778 138.579 35.8034C138.579 37.8289 139.018 39.6509 139.895 41.2717C140.773 42.8924 141.962 44.1729 143.459 45.1111C144.956 46.0514 146.655 46.5225 148.555 46.5225C150.11 46.5225 151.507 46.1963 152.746 45.546C153.83 44.9762 154.714 44.2011 155.423 43.2428V46.0896H159.355V17.5665H155.423V28.3379V28.34ZM152.594 41.922C151.63 42.53 150.499 42.834 149.203 42.834C147.906 42.834 146.762 42.53 145.768 41.922C144.774 41.314 143.996 40.4825 143.435 39.4275C142.874 38.3725 142.593 37.1504 142.593 35.7612C142.593 34.3719 142.874 33.1941 143.435 32.1371C143.996 31.0821 144.765 30.2486 145.745 29.6426C146.724 29.0346 147.862 28.7305 149.159 28.7305C150.455 28.7305 151.585 29.0346 152.549 29.6426C153.513 30.2506 154.277 31.0741 154.838 32.117C155.399 33.1579 155.68 34.388 155.68 35.8054C155.68 37.2228 155.405 38.3725 154.858 39.4295C154.311 40.4865 153.556 41.318 152.59 41.924L152.594 41.922Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M188.578 26.4736C187.064 25.5193 185.373 25.0421 183.501 25.0421C181.974 25.0421 180.585 25.3683 179.333 26.0186C178.222 26.5964 177.314 27.3776 176.589 28.34V17.5665H172.701V46.0876H176.589V43.2407C177.3 44.1991 178.192 44.9742 179.288 45.546C180.541 46.1963 181.944 46.5225 183.499 46.5225C185.371 46.5225 187.062 46.0534 188.576 45.1111C190.087 44.1709 191.275 42.8904 192.139 41.2717C193.003 39.653 193.434 37.8289 193.434 35.8034C193.434 33.778 193.003 31.9559 192.139 30.3352C191.275 28.7144 190.087 27.4279 188.576 26.4736H188.578ZM188.598 39.4275C188.02 40.4845 187.243 41.316 186.265 41.922C185.285 42.53 184.148 42.834 182.852 42.834C181.555 42.834 180.455 42.53 179.461 41.922C178.467 41.314 177.703 40.4825 177.172 39.4275C176.639 38.3725 176.372 37.1645 176.372 35.8034C176.372 34.4424 176.645 33.1861 177.194 32.115C177.741 31.0439 178.505 30.2124 179.483 29.6204C180.461 29.0285 181.599 28.7305 182.896 28.7305C184.193 28.7305 185.285 29.0285 186.265 29.6204C187.243 30.2144 188.02 31.0459 188.598 32.115C189.173 33.1861 189.461 34.4001 189.461 35.7591C189.461 37.1181 189.173 38.3705 188.598 39.4254V39.4275Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M210.757 25.4749L204.512 40.0897L198.576 25.4749H194.257L202.328 44.3299L197.63 53.998H201.931L205.488 46.2627L215.078 25.4749H210.757Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M398.497 0H391.931C391.101 0 390.428 0.676055 390.428 1.51001V8.10574C390.428 8.93969 391.101 9.61575 391.931 9.61575H398.497C399.327 9.61575 400 8.93969 400 8.10574V1.51001C400 0.676055 399.327 0 398.497 0Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M244.146 19.3141C243.182 18.9114 242.086 18.7141 240.877 18.7141C238.081 18.7141 235.931 19.6101 234.444 21.3999C234.428 21.4241 234.412 21.4482 234.396 21.4664V19.2416H227.604V44.4105H234.396V30.5003C234.396 28.6278 234.853 27.2245 235.769 26.3044C236.684 25.3843 237.869 24.9253 239.324 24.9253C240.019 24.9253 240.633 25.032 241.164 25.2374C241.695 25.4427 242.162 25.7628 242.536 26.1736L246.795 21.2791C246.002 20.3751 245.12 19.7268 244.148 19.3242V19.3161L244.146 19.3141Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M265.652 20.2985C263.804 19.2073 261.664 18.6556 259.243 18.6556C256.822 18.6556 254.559 19.2395 252.549 20.3972C250.539 21.5549 248.96 23.1233 247.799 25.0863C246.639 27.0493 246.066 29.2821 246.066 31.7786C246.066 34.2752 246.663 36.5744 247.855 38.5536C249.048 40.5327 250.667 42.085 252.711 43.2185C254.747 44.352 257.084 44.9097 259.716 44.9097C261.752 44.9097 263.648 44.5493 265.397 43.8185C267.147 43.0876 268.618 42.0125 269.837 40.5911L265.848 36.5845C265.089 37.4543 264.189 38.1046 263.151 38.5395C262.113 38.9743 260.952 39.1878 259.678 39.1878C258.255 39.1878 257.012 38.8837 255.942 38.2757C254.872 37.6677 254.046 36.7979 253.481 35.6644C253.252 35.2134 253.072 34.7362 252.942 34.2269L271.251 34.1786C271.39 33.5866 271.488 33.0531 271.538 32.586C271.586 32.1189 271.612 31.6578 271.612 31.2068C271.612 28.809 271.081 26.6667 270.027 24.7682C268.973 22.8716 267.518 21.3777 265.67 20.2844L265.654 20.3005L265.652 20.2985ZM255.711 25.2514C256.718 24.6433 257.894 24.3393 259.235 24.3393C260.575 24.3393 261.598 24.6111 262.479 25.1447C263.361 25.6782 264.033 26.4594 264.498 27.4681C264.726 27.9533 264.898 28.4949 265.029 29.0948L252.898 29.1271C253.02 28.66 253.184 28.215 253.389 27.8043C253.92 26.7131 254.697 25.8574 255.701 25.2514H255.709H255.711Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M285.26 35.1792L279.156 19.2314H271.692L282.735 44.4003H287.615L298.61 19.2314H291.399L285.26 35.1792Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M321.072 20.4315C319.24 19.2899 317.164 18.7061 314.843 18.7061C313.045 18.7061 311.426 19.0846 309.987 19.8476C309.137 20.2986 308.386 20.8503 307.73 21.4905V19.2154H300.938V54H307.682V42.1595C308.336 42.7917 309.097 43.3414 309.963 43.7863C311.418 44.5333 313.045 44.9118 314.835 44.9118C317.148 44.9118 319.224 44.336 321.064 43.1863C322.896 42.0448 324.343 40.4764 325.397 38.4973C326.451 36.5181 326.982 34.2934 326.982 31.8291C326.982 29.3647 326.451 27.0836 325.397 25.1045C324.343 23.1254 322.896 21.565 321.064 20.4154L321.072 20.4315ZM319.232 35.3605C318.693 36.3873 317.941 37.1825 316.975 37.7584C316.011 38.3342 314.899 38.6201 313.657 38.6201C312.414 38.6201 311.31 38.3322 310.362 37.7584C309.414 37.1825 308.67 36.3873 308.131 35.3605C307.592 34.3417 307.33 33.1438 307.33 31.7888C307.33 30.4338 307.6 29.2922 308.131 28.2735C308.662 27.2547 309.422 26.4514 310.388 25.8756C311.352 25.2998 312.448 25.0139 313.657 25.0139C314.865 25.0139 316.011 25.3018 316.975 25.8756C317.939 26.4494 318.693 27.2467 319.232 28.2735C319.763 29.3003 320.034 30.4741 320.034 31.7888C320.034 33.1035 319.763 34.3337 319.232 35.3605Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M337.459 9.61572H330.668V44.4003H337.459V9.61572Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M357.903 33.6672C357.903 35.2276 357.503 36.4517 356.711 37.3134C355.917 38.1831 354.807 38.62 353.392 38.62C352.46 38.62 351.643 38.4308 350.957 38.0442C350.27 37.6577 349.747 37.1 349.404 36.353C349.053 35.6061 348.881 34.7101 348.881 33.6672V19.2315H342.031V33.8242C342.031 36.0168 342.514 37.9375 343.486 39.6046C344.458 41.2716 345.799 42.5763 347.508 43.5125C349.226 44.4487 351.186 44.9158 353.394 44.9158C355.603 44.9158 357.571 44.4567 359.28 43.5366C360.998 42.6165 362.321 41.3199 363.269 39.6529C364.216 37.9858 364.691 36.0389 364.691 33.8142V19.2214H357.9V33.6571L357.908 33.6652L357.903 33.6672Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M384.534 30.8505C383.586 30.2586 382.58 29.7996 381.526 29.4714C380.472 29.1432 379.458 28.8472 378.494 28.5855C377.53 28.3218 376.736 28.0198 376.131 27.6735C375.526 27.3292 375.223 26.8359 375.223 26.2118C375.223 25.6621 375.494 25.2172 376.025 24.9051C376.556 24.593 377.333 24.438 378.338 24.438C379.45 24.438 380.472 24.6434 381.428 25.0622C382.376 25.4809 383.234 26.1534 383.995 27.0896L388.09 22.9763C386.977 21.5146 385.588 20.4234 383.913 19.6926C382.238 18.9617 380.358 18.6013 378.281 18.6013C376.205 18.6013 374.596 18.9295 373.149 19.5959C371.694 20.2523 370.582 21.1804 369.806 22.3542C369.03 23.536 368.638 24.9252 368.638 26.5259C368.638 28.1265 368.94 29.2922 369.545 30.2546C370.151 31.2069 370.934 31.9538 371.908 32.4954C372.872 33.037 373.886 33.4639 374.941 33.8021C375.995 34.1383 377.009 34.4262 377.973 34.688C378.937 34.9517 379.73 35.2718 380.336 35.6483C380.941 36.0268 381.243 36.5684 381.243 37.2651C381.243 37.8892 380.957 38.3563 380.386 38.6684C379.813 38.9804 378.971 39.1355 377.869 39.1355C376.488 39.1355 375.221 38.8979 374.085 38.4046C372.948 37.9194 371.942 37.1885 371.077 36.2121L367.03 40.3253C367.864 41.2938 368.844 42.1233 369.988 42.7977C371.133 43.4702 372.383 44.0057 373.748 44.3903C375.113 44.7688 376.502 44.9661 377.925 44.9661C380.965 44.9661 383.376 44.2433 385.133 42.8058C386.899 41.3683 387.781 39.4153 387.781 36.9429C387.781 35.4148 387.478 34.1585 386.873 33.19C386.268 32.2216 385.492 31.4324 384.544 30.8505H384.528H384.536H384.534Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                            id: "clip0_7747_4657",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                width: "400",
                                height: "54",
                                fill: "white"
                            })
                        })
                    })
                ]
            });
        }
    };
    return logoModeHandler();
}

;// CONCATENATED MODULE: ./components/footer/types/FooterWithApps.tsx







function FooterWithApps(props) {
    var t = (0,i18n/* useT */.NT)();
    var _title;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
        className: "footer mt-auto " + (props.footerPaddingClass != null ? props.footerPaddingClass : ""),
        style: props.fixed ? {
            paddingBottom: "7.625rem"
        } : {},
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "bg-design-color pt-3 pb-3 " + props.footerClass,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "d-flex flex-column col-12 col-lg-6 align-items-center align-items-lg-start text-lg-start",
                                style: {
                                    textAlign: "center"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "row justify-content-center justify-content-lg-start mb-3",
                                        children: [
                                            props.iosApp != null ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "d-flex justify-content-center w-auto h-auto px-1",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: "h-auto w-auto",
                                                    href: props.iosApp,
                                                    title: "iosApp",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        layout: "fixed",
                                                        width: 135,
                                                        height: 40,
                                                        src: Consts/* default.AppleAppSvg */.Z.AppleAppSvg,
                                                        alt: "ios_app",
                                                        placeholder: "blur",
                                                        blurDataURL: "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                                                    })
                                                })
                                            }) : "",
                                            props.androidApp != null ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "d-flex justify-content-center w-auto h-auto px-1",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: "h-auto w-auto",
                                                    href: props.androidApp,
                                                    title: "androidApp",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        layout: "fixed",
                                                        width: 135,
                                                        height: 40,
                                                        src: Consts/* default.AndroidAppSvg */.Z.AndroidAppSvg,
                                                        alt: "android_app",
                                                        placeholder: "blur",
                                                        blurDataURL: "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                                                    })
                                                })
                                            }) : ""
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "row w-100 m-0 mb-2 justify-content-center justify-content-lg-start",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterMenu, {
                                            menu: props.menu,
                                            apps: false
                                        })
                                    }),
                                    props.iosAppText != null ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "fs-11 no-margin",
                                        children: props.iosAppText
                                    }) : "",
                                    props.androidAppText != null ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "fs-11 no-margin",
                                        children: props.androidAppText
                                    }) : "",
                                    props.loggiaBadgeText != null ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "fs-11 no-margin",
                                        children: props.loggiaBadgeText
                                    }) : ""
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                id: "w3c_div",
                                className: "col-12 col-lg-6 justify-content-center justify-content-lg-end text-lg-end py-3 py-lg-0",
                                style: {
                                    textAlign: "center"
                                },
                                children: [
                                    // the license number sits on the line of the app badges, the copyright below it
                                    props.registrationNumberText != null ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "fs-11 d-flex align-items-center justify-content-center justify-content-lg-end mb-3",
                                        style: {
                                            minHeight: 40
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            children: [
                                                t("footer.license"),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "fw-bold",
                                                    children: props.registrationNumber
                                                })
                                            ]
                                        })
                                    }) : "",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "fs-11",
                                        children: t("footer.copyright", {
                                            year: new Date().getFullYear(),
                                            title: (_title = props.title) !== null && _title !== void 0 ? _title : ""
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PolicyNotice, {
                                        hasPrivacyPolicy: props.hasPrivacyPolicy,
                                        hasTermsAndConditions: props.hasTermsAndConditions
                                    })
                                ]
                            })
                        ]
                    }),
                    props.hasLoggiaBadge ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row justify-content-center text-center py-3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "https://revplus.com/",
                            target: "_blank",
                            "aria-label": "Powered by revplus",
                            title: "Powered by revplus",
                            rel: "noreferrer",
                            className: "w-auto",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoggiaSVG, {
                                footerClass: props.footerClass
                            })
                        })
                    }) : ""
                ]
            })
        })
    });
}

;// CONCATENATED MODULE: ./components/footer/types/FooterWithoutApps.tsx





function FooterWithoutApps(props) {
    var t = (0,i18n/* useT */.NT)();
    var _title;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
        className: "footer bg-design-color pb-4 pt-5 xs-p-b-95 mt-auto " + props.footerClass + " " + (props.footerPaddingClass != null ? props.footerPaddingClass : ""),
        style: props.fixed ? {
            paddingBottom: "7.625rem"
        } : {},
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "row",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "col-12 col-lg-6 justify-content-center justify-content-lg-start",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterMenu, {
                                    menu: props.menu
                                }),
                                props.registrationNumberText != null ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "fs-11 w-100 text-left text-lg-start no-margin p-l-5",
                                    style: {
                                        marginTop: "10px"
                                    },
                                    children: [
                                        t("footer.license"),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "fw-bold",
                                            children: props.registrationNumber
                                        })
                                    ]
                                }) : ""
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            id: "w3c_div",
                            className: "col-12 col-lg-6 justify-content-center justify-content-lg-end text-lg-end py-3 py-lg-0",
                            style: {
                                textAlign: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "fs-11",
                                    children: t("footer.copyright", {
                                        year: new Date().getFullYear(),
                                        title: (_title = props.title) !== null && _title !== void 0 ? _title : ""
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PolicyNotice, {
                                    hasPrivacyPolicy: props.hasPrivacyPolicy,
                                    hasTermsAndConditions: props.hasTermsAndConditions
                                })
                            ]
                        })
                    ]
                }),
                props.hasLoggiaBadge ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row justify-content-center text-center pt-3",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "https://revplus.com/",
                        target: "_blank",
                        "aria-label": "Powered by revplus",
                        title: "Powered by revplus",
                        rel: "noreferrer",
                        className: "w-auto",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoggiaSVG, {
                            footerClass: props.footerClass
                        })
                    })
                }) : ""
            ]
        })
    });
}

;// CONCATENATED MODULE: ./components/Footer.tsx




function Footer(props) {
    var footerClass = null;
    if (props.designMode != null) {
        if (props.designMode) footerClass = "dark-mode";
        else footerClass = "light-mode";
    } else {
        footerClass = "light-mode";
    }
    if (props.footerContent.content != undefined) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
                className: "bg-design-color xs-p-b-85 " + (props.footerPaddingClass != undefined ? props.footerPaddingClass : ""),
                dangerouslySetInnerHTML: {
                    __html: props.footerContent.content.app_section_content
                }
            })
        });
    } else return props.iosApp != null || props.androidApp != null ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterWithApps, {
        iosApp: props.iosApp,
        androidApp: props.androidApp,
        iosAppText: props.iosAppText,
        androidAppText: props.androidAppText,
        hasLoggiaBadge: props.hasLoggiaBadge,
        loggiaBadgeText: props.loggiaBadgeText,
        registrationNumber: props.registrationNumber,
        hasPrivacyPolicy: props.hasPrivacyPolicy,
        hasTermsAndConditions: props.hasTermsAndConditions,
        registrationNumberText: props.registrationNumberText,
        footerPaddingClass: props.footerPaddingClass,
        title: props.title,
        footerClass: footerClass,
        menu: props.menu,
        isManager: props.isManager,
        socialLinks: props.socialLinks
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterWithoutApps, {
        title: props.title,
        footerPaddingClass: props.footerPaddingClass,
        footerClass: footerClass,
        hasLoggiaBadge: props.hasLoggiaBadge,
        menu: props.menu,
        registrationNumber: props.registrationNumber,
        hasPrivacyPolicy: props.hasPrivacyPolicy,
        hasTermsAndConditions: props.hasTermsAndConditions,
        registrationNumberText: props.registrationNumberText,
        isManager: props.isManager,
        socialLinks: props.socialLinks
    });
}

// EXTERNAL MODULE: ./components/ViewPort.tsx
var ViewPort = __webpack_require__(39806);
// EXTERNAL MODULE: ./components/templates/index/sections/PartnersSection.tsx
var PartnersSection = __webpack_require__(4788);
// EXTERNAL MODULE: ../../shared/node_modules/react-elfsight-widget/dist/react-elfsight-widget.esm.js
var react_elfsight_widget_esm = __webpack_require__(5269);
// EXTERNAL MODULE: ../../shared/node_modules/@fortawesome/free-brands-svg-icons/index.mjs
var free_brands_svg_icons = __webpack_require__(53331);
// EXTERNAL MODULE: ../../shared/node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(96350);
// EXTERNAL MODULE: ../../shared/node_modules/next/router.js
var next_router = __webpack_require__(34357);
;// CONCATENATED MODULE: ./components/BottomSections.tsx















function BottomSections(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17;
    var t = (0,i18n/* useT */.NT)();
    var contact_section = props.contactSection;
    var contactSeoTitle = props.app.builder.builder_contact_seo_title_cat;
    var footer_section = props.footerSection;
    var contactHtml = props.hasOwnProperty("contactHtml") ? props.contactHtml : null;
    var router = (0,next_router.useRouter)();
    var fullPath = router.asPath;
    var pathname = fullPath.split(/[?#]/)[0]; // removes ?query and #hash
    var pathWithoutSlash = pathname.startsWith("/") ? pathname.slice(1) : pathname;
    var isMobile = (0,es/* useSelector */.v9)(function(state) {
        return state["appSettings"]["isMobile"];
    });
    var isTablet = (0,es/* useSelector */.v9)(function(state) {
        return state["appSettings"]["isTablet"];
    });
    var app_data = props.app_data;
    var head = props.head;
    var app = props.app;
    var locations = props.locations;
    var footer = props.footer;
    var isDesktop = props.isDesktop;
    var captchaSiteKey = props.captchaSiteKey;
    var contactFormInFooter = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_contact_in_different_page") == 1 ? false : true;
    });
    var showChatIconsMobile = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_general_chat_icons_side_show_mobile") == 1 ? true : false;
    });
    var showChatIconsDesktop = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_general_chat_icons_side_show_desktop") == 1 ? true : false;
    });
    var showChatIconWhatapp = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_general_show_chat_icon_whatsapp");
    });
    var showChatIconViber = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_general_show_chat_icon_viber");
    });
    var enableNewsletter = app.enableNewsletter;
    var newsletterAskFirstname = app.newsletterAskFirstname;
    var newsletterAskLastname = app.newsletterAskLastname;
    var newsletterAskPhone = app.newsletterAskPhone;
    var newsletterTitle = app.newsletterTitle;
    var newsletterSubtitle = app.newsletterSubtitle;
    var newsletterDesc = app.newsletterDesc;
    var newsletterBackground = app.newsletterBgColor;
    // the builder setting wins; when it was never set, follow the design mode of the site like the Lodge
    var newsletterDarkMode = app.builder.builder_newsletter_dark_mode != null && app.builder.builder_newsletter_dark_mode !== "" ? app.builder.builder_newsletter_dark_mode : app.designMode === true || app.designMode === "1" || app.designMode === 1 ? "1" : "0";
    var htmlSections = props.htmlSections != null && props.htmlSections.hasOwnProperty("app_sections") ? props.htmlSections.app_sections : null;
    // same choice as the Lodge (newsletter.html.twig): the newsletter image of the site, otherwise the first image
    // of the page for multi-property sites, or the first image of the property for a single property
    var newsletterBackgroundHandler = function() {
        var ref, ref1, ref2, ref3;
        if (Checkers/* default.isValidString */.Z.isValidString(props.app.newsletterImage)) {
            return props.app.newsletterImage;
        }
        // single property site: the API sends the first featured photo of the property (same rule as the Lodge), on every page
        if (Checkers/* default.isValidString */.Z.isValidString(props.app.newsletterPropertyImage)) {
            return props.app.newsletterPropertyImage;
        }
        var firstImage = function(images) {
            var ref;
            return Checkers/* default.isValidArray */.Z.isValidArray(images) && Checkers/* default.isValidString */.Z.isValidString((ref = images[0]) === null || ref === void 0 ? void 0 : ref.image) ? images[0].image : null;
        };
        var isSingleProperty = Checkers/* default.isValidNumber */.Z.isValidNumber((ref = props.content) === null || ref === void 0 ? void 0 : ref.property_id) && !Checkers/* default.valueToBoolean */.Z.valueToBoolean((ref1 = props.content) === null || ref1 === void 0 ? void 0 : ref1.is_chain);
        var propertyImages = ((ref2 = props.content) === null || ref2 === void 0 ? void 0 : ref2.albumIsPageAlbum) === false ? (ref3 = props.content) === null || ref3 === void 0 ? void 0 : ref3.album : null;
        if (isSingleProperty) {
            var ref4, ref5;
            // the Lodge uses the first featured image of the property (sorted), which is the first of propertyAllImages
            return (ref5 = (ref4 = firstImage(props.propertyAllImages)) !== null && ref4 !== void 0 ? ref4 : firstImage(propertyImages)) !== null && ref5 !== void 0 ? ref5 : firstImage(props.app.pageMedia);
        }
        var ref6;
        return (ref6 = firstImage(props.app.pageMedia)) !== null && ref6 !== void 0 ? ref6 : firstImage(propertyImages);
    };
    var contactBlock = contactFormInFooter ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: fullPath !== "/contact/success" && fullPath !== "/contact" && (!contactSeoTitle || pathWithoutSlash !== contactSeoTitle) && contact_section ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Contact/* default */.Z, {
            isDesktop: isDesktop,
            contactFormTitle: app.contactFormTitle,
            locations: locations != null ? locations.hasOwnProperty("page_locations") ? locations.page_locations : null : null,
            captchaSiteKey: captchaSiteKey,
            showContactSection: app.showContactSection,
            showContactForm: app.showContactForm,
            showName: app.contactAskName,
            showEmail: app.contactAskEmail,
            showPhone: app.contactAskPhone,
            showDates: app.contactAskDates,
            showDestination: app.contactAskDestination,
            searchbarRadius: app.searchbarRadius != null ? app.searchbarRadius.length > 0 ? app.searchbarRadius.length : null : null,
            contactPhoneOverride: app.builder.builder_contact_page_phone,
            contactEmailOverride: app.builder.builder_contact_page_email,
            contactTitleOverride: Checkers/* default.isValidString */.Z.isValidString(app.builder.builder_contact_page_title) ? app.builder.builder_contact_page_title : !((ref = props.app_data) === null || ref === void 0 ? void 0 : ref.is_manager) && Checkers/* default.isValidString */.Z.isValidString((ref1 = props.content) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.details) === null || ref2 === void 0 ? void 0 : ref2.title) ? props.content.details.title : null,
            contactHtml: contactHtml,
            isManager: (ref3 = props.app_data) === null || ref3 === void 0 ? void 0 : ref3.is_manager,
            socialLinks: (ref4 = props.content) === null || ref4 === void 0 ? void 0 : ref4.socialLinks,
            managerContact: (ref5 = props.content) === null || ref5 === void 0 ? void 0 : ref5.managerContact,
            propertyLat: (ref6 = props.content) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.details) === null || ref7 === void 0 ? void 0 : ref7.lat,
            propertyLng: (ref8 = props.content) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.details) === null || ref9 === void 0 ? void 0 : ref9.lng,
            propertyBadges: (ref10 = props.content) === null || ref10 === void 0 ? void 0 : ref10.propertyBadges,
            contactEmails: app.contactEmails
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    var newsletterBlock = enableNewsletter ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    var footerCtaSections = !((ref11 = props.app_data) === null || ref11 === void 0 ? void 0 : ref11.is_manager) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            contactBlock,
            newsletterBlock
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            newsletterBlock,
            contactBlock
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            Checkers/* default.valueToBoolean */.Z.valueToBoolean(isMobile) && showChatIconsMobile || Checkers/* default.valueToBoolean */.Z.valueToBoolean(isDesktop) && showChatIconsDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: Checkers/* default.isValidString */.Z.isValidString(showChatIconViber) || Checkers/* default.isValidString */.Z.isValidString(showChatIconWhatapp) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "chat-icons",
                        children: [
                            Checkers/* default.isValidString */.Z.isValidString(showChatIconViber) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "icon viber",
                                    href: showChatIconViber,
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: free_brands_svg_icons/* faViber */.oYh,
                                        className: "",
                                        size: "xl"
                                    })
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                            Checkers/* default.isValidString */.Z.isValidString(showChatIconWhatapp) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "icon whatsapp",
                                    href: showChatIconWhatapp,
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: free_brands_svg_icons/* faWhatsapp */.VHX,
                                        className: "",
                                        size: "xl"
                                    })
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                        ]
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
            fullPath !== "/contact" && fullPath !== "/contact/success" && htmlSections != null && Checkers/* default.isValidArray */.Z.isValidArray(htmlSections) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container-fluid overflow-hidden" + (!((ref12 = props.app_data) === null || ref12 === void 0 ? void 0 : ref12.is_manager) ? " pb-4" : ""),
                    children: (0,MethodHelper/* uniqueElfsightSections */.G)(htmlSections).map(function(section, key) {
                        return section.app_section_content != null ? section.app_section_content.includes("elfsight-app") ? section.app_section_content.split("elfsight-app-")[1] != null ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react_elfsight_widget_esm/* ElfsightWidget */.j, {
                            widgetID: section.app_section_content.split("elfsight-app-")[1].split('"></div>')[0]
                        }, key) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
                    })
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: MethodHelper/* BODY_END_WIDGETS_ID */.XQ,
                className: "container-fluid overflow-hidden"
            }),
            fullPath !== "/contact" && fullPath !== "/contact/success" && !((ref13 = props.app_data) === null || ref13 === void 0 ? void 0 : ref13.is_manager) && /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnersSection/* default */.Z, {
                content: props.content
            }),
            footerCtaSections,
            footer_section ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewPort/* default */.Z, {
                ref: props.footerRef,
                parentClass: "row w-100 m-0",
                skeletonItem: /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterSkeleton, {
                    height: app_data.has_android_app || app_data.has_ios_app ? 250 : 172
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {
                    footerPaddingClass: props.footerPaddingClass,
                    isDesktop: isDesktop,
                    designMode: app.designMode,
                    menu: footer.menu,
                    footerContent: footer,
                    title: !((ref14 = props.app_data) === null || ref14 === void 0 ? void 0 : ref14.is_manager) && Checkers/* default.isValidString */.Z.isValidString((ref15 = props.content) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.details) === null || ref16 === void 0 ? void 0 : ref16.title) ? props.content.details.title : head.data.hasOwnProperty("titleOfficial") && head.data.titleOfficial != null ? head.data.titleOfficial : head.data.hasOwnProperty("title") ? head.data.title : null,
                    fixed: app.enableBooking && app.bookingSearchbarWidth && !app.bookingSearchbarPosition,
                    iosApp: app_data.has_ios_app ? app_data.ios_app_link : null,
                    androidApp: app_data.has_android_app ? app_data.android_app_link : null,
                    iosAppText: app_data.has_ios_app ? app_data.ios_app_text : null,
                    androidAppText: app_data.has_android_app ? app_data.android_app_text : null,
                    hasLoggiaBadge: app_data.has_loggia_badge,
                    loggiaBadgeText: app_data.has_loggia_badge ? app_data.loggia_badge_text : null,
                    registrationNumber: !app_data.is_manager ? app_data.registration_number : null,
                    hasPrivacyPolicy: Checkers/* default.isValidString */.Z.isValidString(app.privacyPolicy),
                    hasTermsAndConditions: Checkers/* default.isValidString */.Z.isValidString(app.termsAndConditions),
                    registrationNumberText: !app_data.is_manager ? app_data.registration_number_text : null,
                    isManager: app_data.is_manager,
                    socialLinks: (ref17 = props.content) === null || ref17 === void 0 ? void 0 : ref17.socialLinks
                })
            }) : ""
        ]
    });
}


/***/ }),

/***/ 46465:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Contact; }
});

// EXTERNAL MODULE: ../../shared/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(14140);
// EXTERNAL MODULE: ../../shared/node_modules/react/index.js
var react = __webpack_require__(89736);
// EXTERNAL MODULE: ./helpers/i18n.ts + 7 modules
var i18n = __webpack_require__(95925);
// EXTERNAL MODULE: ./helpers/class/Checkers.ts
var Checkers = __webpack_require__(83974);
// EXTERNAL MODULE: ../../shared/node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(31969);
// EXTERNAL MODULE: ./helpers/MethodHelper.ts
var MethodHelper = __webpack_require__(23158);
// EXTERNAL MODULE: ../../shared/node_modules/@fortawesome/free-brands-svg-icons/index.mjs
var free_brands_svg_icons = __webpack_require__(53331);
// EXTERNAL MODULE: ../../shared/node_modules/@fortawesome/pro-solid-svg-icons/index.mjs
var pro_solid_svg_icons = __webpack_require__(72976);
// EXTERNAL MODULE: ../../shared/node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(96350);
;// CONCATENATED MODULE: ./components/SocialLinks.tsx









var dynamicSocialIcon = function(iconFa) {
    switch(iconFa){
        case "fa-facebook-f":
        case "fa-facebook":
            return free_brands_svg_icons/* faFacebookF */.AYu;
        case "fa-instagram":
            return free_brands_svg_icons/* faInstagram */.Zzi;
        case "fa-youtube":
            return free_brands_svg_icons/* faYoutube */.opf;
        case "fa-twitter":
        case "fa-x-twitter":
            return free_brands_svg_icons/* faXTwitter */.NCc;
        case "fa-whatsapp":
            return free_brands_svg_icons/* faWhatsapp */.VHX;
        case "fa-linkedin":
        case "fa-linkedin-in":
            return free_brands_svg_icons/* faLinkedinIn */.hwn;
        case "fa-google":
            return free_brands_svg_icons/* faGoogle */.xYR;
        case "fa-tiktok":
            return free_brands_svg_icons/* faTiktok */.ABo;
        case "fa-pinterest":
        case "fa-pinterest-p":
            return free_brands_svg_icons/* faPinterestP */.eGW;
        case "fa-foursquare":
            return free_brands_svg_icons/* faFoursquare */.ppR;
        default:
            return pro_solid_svg_icons/* faLink */.nNP;
    }
};
function SocialLinks(props) {
    var t = (0,i18n/* useT */.NT)();
    var showSocial = (0,es/* useSelector */.v9)(function(state) {
        return Checkers/* default.valueToBoolean */.Z.valueToBoolean((0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_general_show_social"));
    });
    var facebookLink = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_general_show_social_facebook");
    });
    var instagramLink = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_general_show_social_instagram");
    });
    var linkedinLink = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_general_show_social_linkedin");
    });
    var twitterLink = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_general_show_social_twitter");
    });
    var youtubeLink = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_general_show_social_youtube");
    });
    var whatappLink = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_general_show_social_whatsapp");
    });
    var hasBuilderSocialLinks = Checkers/* default.isValidString */.Z.isValidString(facebookLink) || Checkers/* default.isValidString */.Z.isValidString(instagramLink) || Checkers/* default.isValidString */.Z.isValidString(linkedinLink) || Checkers/* default.isValidString */.Z.isValidString(twitterLink) || Checkers/* default.isValidString */.Z.isValidString(youtubeLink) || Checkers/* default.isValidString */.Z.isValidString(whatappLink);
    var showingBuilderSocialLinks = showSocial && hasBuilderSocialLinks;
    var rawDynamicSocialLinks = !props.isManager && !showingBuilderSocialLinks && Checkers/* default.isValidArray */.Z.isValidArray(props.socialLinks) ? props.socialLinks : [];
    var seenLinks = new Set();
    var dynamicSocialLinks = rawDynamicSocialLinks.filter(function(socialLink) {
        if (seenLinks.has(socialLink.link)) return false;
        seenLinks.add(socialLink.link);
        return true;
    });
    var socialIconClass = "social-link-icon fs-20 me-2 mb-2 border d-flex justify-content-center align-items-center rounded-circle";
    if (!showingBuilderSocialLinks && dynamicSocialLinks.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
        className: props.className != null ? props.className : "no-style mt-4 ps-0",
        children: [
            showingBuilderSocialLinks && Checkers/* default.isValidString */.Z.isValidString(facebookLink) && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: "inline no-padding",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    href: facebookLink,
                    target: "_blank",
                    rel: "noreferrer",
                    className: socialIconClass,
                    "aria-label": t("a11y.socialPage", {
                        name: "Facebook"
                    }),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                            icon: free_brands_svg_icons/* faFacebookF */.AYu,
                            className: "fs-20"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "hidden",
                            children: "Facebook"
                        })
                    ]
                })
            }),
            showingBuilderSocialLinks && Checkers/* default.isValidString */.Z.isValidString(instagramLink) && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: "inline no-padding",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    href: instagramLink,
                    target: "_blank",
                    rel: "noreferrer",
                    className: socialIconClass,
                    "aria-label": t("a11y.socialPage", {
                        name: "Instagram"
                    }),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                            icon: free_brands_svg_icons/* faInstagram */.Zzi,
                            className: "fs-20"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "hidden",
                            children: "Instagram"
                        })
                    ]
                })
            }),
            showingBuilderSocialLinks && Checkers/* default.isValidString */.Z.isValidString(youtubeLink) && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: "inline no-padding",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    href: youtubeLink,
                    target: "_blank",
                    rel: "noreferrer",
                    className: socialIconClass,
                    "aria-label": t("a11y.socialPage", {
                        name: "YouTube"
                    }),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                            icon: free_brands_svg_icons/* faYoutube */.opf,
                            className: "fs-20"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "hidden",
                            children: "YouTube"
                        })
                    ]
                })
            }),
            showingBuilderSocialLinks && Checkers/* default.isValidString */.Z.isValidString(twitterLink) && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: "inline no-padding",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    href: twitterLink,
                    target: "_blank",
                    rel: "noreferrer",
                    className: socialIconClass,
                    "aria-label": t("a11y.socialPage", {
                        name: "Twitter"
                    }),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                            icon: free_brands_svg_icons/* faXTwitter */.NCc,
                            className: "fs-20"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "hidden",
                            children: "Twitter"
                        })
                    ]
                })
            }),
            showingBuilderSocialLinks && Checkers/* default.isValidString */.Z.isValidString(whatappLink) && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: "inline no-padding",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    href: whatappLink,
                    target: "_blank",
                    rel: "noreferrer",
                    className: socialIconClass,
                    "aria-label": t("a11y.socialPage", {
                        name: "WhatsApp"
                    }),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                            icon: free_brands_svg_icons/* faWhatsapp */.VHX,
                            className: "fs-20"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "hidden",
                            children: "WhatsApp"
                        })
                    ]
                })
            }),
            showingBuilderSocialLinks && Checkers/* default.isValidString */.Z.isValidString(linkedinLink) && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: "inline no-padding",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    href: linkedinLink,
                    target: "_blank",
                    rel: "noreferrer",
                    className: socialIconClass,
                    "aria-label": t("a11y.socialPage", {
                        name: "LinkedIn"
                    }),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                            icon: free_brands_svg_icons/* faLinkedinIn */.hwn,
                            className: "fs-20"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "hidden",
                            children: "LinkedIn"
                        })
                    ]
                })
            }),
            dynamicSocialLinks.map(function(socialLink) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: "inline no-padding",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: socialLink.link,
                        target: "_blank",
                        rel: "noreferrer",
                        className: socialIconClass,
                        "aria-label": t("a11y.socialPage", {
                            name: socialLink.title
                        }),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                icon: dynamicSocialIcon(socialLink.iconFa),
                                className: "fs-20"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "hidden",
                                children: socialLink.title
                            })
                        ]
                    })
                }, socialLink.id);
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/contact/ContactLocations.tsx







var stripEmbeddedSocialIcons = function(html) {
    if (!Checkers/* default.isValidString */.Z.isValidString(html)) return html;
    return html.replace(/<ul[^>]*>[\s\S]*?data-prefix="fab"[\s\S]*?<\/ul>/gi, "");
};
function ContactLocations(props) {
    var t = (0,i18n/* useT */.NT)();
    var contactOver = props.hasOwnProperty("contactOver") ? props.contactOver : null;
    var isCoordinate = function(value) {
        return value != null && String(value).trim() !== "" && Number.isFinite(Number(value)) && Number(value) !== 0;
    };
    var url = null;
    if (isCoordinate(props.latitude) && isCoordinate(props.longitude)) {
        url = "https://www.google.com/maps/search/?api=1&amp;query=" + props.latitude + "," + props.longitude;
    } else {
        url = null;
    }
    var locations_class = "col-12 col-sm-12 col-md-6 pe-md-5";
    if (!props.showContactForm) {
        locations_class = "col-md-4 offset-md-4 col-sm-12 offset-sm-0";
    }
    var showBranchesLocations = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_contact_show_branches") == "1" ? true : false;
    });
    var contactEmail = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_contact_page_email");
    });
    var contactEmailOverride = Checkers/* default.isValidString */.Z.isValidString(props.contactEmailOverride) ? props.contactEmailOverride : Checkers/* default.isValidString */.Z.isValidString(contactEmail) ? contactEmail : props.contactEmails;
    var contactPhoneBlock = props.hasOwnProperty("contactPhone") ? props.contactPhone : null;
    var hasContactPhoneBlock = contactPhoneBlock != null && contactPhoneBlock.hasOwnProperty("app_section_content") && Checkers/* default.isValidString */.Z.isValidString(contactPhoneBlock.app_section_content);
    var contactEmailBlock = props.hasOwnProperty("contactEmail") ? props.contactEmail : null;
    var hasContactEmailBlock = contactEmailBlock != null && contactEmailBlock.hasOwnProperty("app_section_content") && Checkers/* default.isValidString */.Z.isValidString(contactEmailBlock.app_section_content);
    // useEffect( () => {
    //   console.log("forDebug", "contactEmailOverride", contactEmailOverride)
    //   console.log("forDebug", "showBranchesLocations", showBranchesLocations)
    //   console.log("forDebug", "props.locations", props.locations)
    // })
    var renderLocation = function(location, key) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: props.isManager ? "pe-3" : "pe-3 w-100",
            children: [
                location.location_title != null && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-uppercase letter-sp-normal fw-normal hint-text m-b-0",
                    children: Checkers/* default.isValidString */.Z.isValidString(props.contactTitleOverride) ? props.contactTitleOverride : location.location_title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("address", {
                    className: props.isManager ? "my-2 mb-3" : "my-2",
                    children: [
                        Checkers/* default.isValidString */.Z.isValidString(location.address) ? location.address : "",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        Checkers/* default.isValidString */.Z.isValidString(location.city) ? location.city : "",
                        Checkers/* default.isValidString */.Z.isValidString(location.zip) ? ", " + location.zip : "",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        Checkers/* default.isValidString */.Z.isValidString(location.country) ? location.country : ""
                    ]
                }),
                props.isManager ? // PM: unchanged, exactly as before - always the page-level url.
                url != null ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-uppercase letter-sp-normal fw-bold small-text hint-text no-margin p-r-10",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        target: "_blank",
                        className: "view-map",
                        href: url,
                        rel: "noreferrer",
                        children: t("contact.viewOnMap")
                    })
                }) : "" : // Non-PM: prefer the property's own coordinates (from content.details) over
                // the page/legal-entity location's - matches the old Twig's lat/lon vars.
                function() {
                    var lat = isCoordinate(props.propertyLat) ? props.propertyLat : location.latitude;
                    var lng = isCoordinate(props.propertyLng) ? props.propertyLng : location.longitude;
                    var mapUrl = isCoordinate(lat) && isCoordinate(lng) ? "https://www.google.com/maps/search/?api=1&query=" + lat + "," + lng : url;
                    return Checkers/* default.isValidString */.Z.isValidString(mapUrl) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-uppercase letter-sp-normal fw-bold small-text hint-text no-margin p-r-10",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            target: "_blank",
                            className: "view-map text-design-color text-decoration-none fw-bold",
                            href: mapUrl,
                            rel: "noreferrer",
                            children: t("contact.viewOnMap")
                        })
                    }) : "";
                }(),
                (props.isManager || props.managerContact == null || props.managerContact.showOwnerContactInfo) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        location.hasOwnProperty("items") ? location.items.length > 0 ? location.items.map(function(item, key) {
                            return item.slug.includes("phone") ? item.value != null ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                children: Checkers/* default.isValidString */.Z.isValidString(props.contactPhoneOverride) && !hasContactPhoneBlock ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {}, "location-items-" + key) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: hasContactPhoneBlock ? // the contact_phone section is rendered once, after the items
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "letter-sp-normal fw-bold no-margin p-r-10",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-uppercase letter-sp-normal fw-bold text-master no-margin fs-12 p-r-10",
                                                children: t("contact.tel")
                                            }),
                                            item.phone_prefix != null ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                href: "tel:+" + item.phone_prefix + item.value,
                                                className: "fs-14 fw-bold hint-text text-master text-design-color",
                                                children: [
                                                    "(+",
                                                    item.phone_prefix,
                                                    ") ",
                                                    item.value
                                                ]
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "tel:" + item.value,
                                                className: "fs-14 fw-bold hint-text text-master text-design-color",
                                                children: item.value
                                            })
                                        ]
                                    }, key)
                                })
                            }, "location-items-phone-" + key) : /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {}, "location-items-" + key) : /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                children: hasContactEmailBlock ? // the contact_email section is rendered once, after the items
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: Checkers/* default.isValidString */.Z.isValidString(contactEmailOverride) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {}, "location-items-email-" + key) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: item.slug.includes("email") ? item.value != null ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "letter-sp-normal fw-bold no-margin p-r-10",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "text-uppercase letter-sp-normal fw-bold text-master no-margin fs-12 p-r-10",
                                                    children: t("contact.email")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "mailto:" + item.value,
                                                    className: "fs-14 fw-bold hint-text text-master text-design-color",
                                                    children: item.value
                                                })
                                            ]
                                        }, key) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                    })
                                })
                            }, "location-items-email-" + key);
                        }) : "" : "",
                        hasContactPhoneBlock ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            dangerouslySetInnerHTML: {
                                __html: stripEmbeddedSocialIcons(contactPhoneBlock.app_section_content)
                            }
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                        hasContactEmailBlock ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            dangerouslySetInnerHTML: {
                                __html: stripEmbeddedSocialIcons(contactEmailBlock.app_section_content)
                            }
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                        Checkers/* default.isValidString */.Z.isValidString(props.contactPhoneOverride) && !hasContactPhoneBlock ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "contactPhoneOverride letter-sp-normal fw-bold no-margin p-r-10",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-uppercase letter-sp-normal fw-bold text-master no-margin fs-12 p-r-10",
                                        children: t("contact.tel")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "tel:" + props.contactPhoneOverride,
                                        className: "fs-14 fw-bold hint-text text-master text-design-color",
                                        children: props.contactPhoneOverride
                                    })
                                ]
                            }, key)
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                        Checkers/* default.isValidString */.Z.isValidString(contactEmailOverride) && !hasContactEmailBlock ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "letter-sp-normal fw-bold no-margin p-r-10",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-uppercase letter-sp-normal fw-bold text-master no-margin fs-12 p-r-10",
                                        children: t("contact.email")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "mailto:" + contactEmailOverride,
                                        className: "fs-14 fw-bold hint-text text-master text-design-color",
                                        children: contactEmailOverride
                                    })
                                ]
                            }, key)
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                    ]
                })
            ]
        }, key);
    };
    var locationsList = props.locations != null ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: props.isManager ? "d-flex flex-row flex-wrap w-100 m-0" : "col-12 col-sm-6 d-flex flex-row flex-wrap m-0 ",
        children: props.locations.map(function(location, key) {
            if (key > 0 && !showBranchesLocations) {
                return;
            }
            return renderLocation(location, key);
        })
    }) : "";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: locations_class,
        children: contactOver !== null && contactOver.hasOwnProperty("app_section_content") && Checkers/* default.isValidString */.Z.isValidString(contactOver.app_section_content) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            dangerouslySetInnerHTML: {
                __html: contactOver.app_section_content
            }
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "m-b-20 hidden-xs",
                    children: props.contactFormTitle != null ? props.contactFormTitle : t("contact.howCanWeAssist")
                }),
                props.isManager ? locationsList : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "p-r-40 sm-p-r-0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row m-b-40",
                            children: [
                                locationsList,
                                props.managerContact != null && props.managerContact.showInContact && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "col-12 col-sm-6 mt-4 mt-sm-0",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "fs-12 m-b-10",
                                            children: props.managerContact.showManagerContact ? t("contact.salesQueries") : t("contact.salesManagedBy")
                                        }),
                                        Checkers/* default.isValidString */.Z.isValidString(props.managerContact.logo) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: Checkers/* default.isValidString */.Z.isValidString(props.managerContact.url) ? props.managerContact.url : undefined,
                                            target: Checkers/* default.isValidString */.Z.isValidString(props.managerContact.url) ? "_blank" : undefined,
                                            rel: "noreferrer",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                style: {
                                                    maxWidth: 120
                                                },
                                                src: props.managerContact.logo,
                                                alt: "manager logo",
                                                className: "logo_footer"
                                            })
                                        }) : Checkers/* default.isValidString */.Z.isValidString(props.managerContact.title) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "block-title hint-text m-b-0",
                                            children: props.managerContact.title
                                        }),
                                        Checkers/* default.isValidString */.Z.isValidString(props.managerContact.motto) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "fs-12 font-montserrat all-caps m-b-0",
                                            children: props.managerContact.motto
                                        }),
                                        Checkers/* default.isValidString */.Z.isValidString(props.managerContact.tel) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "hint-text no-margin",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "fs-12 font-montserrat bold all-caps p-r-10",
                                                    children: t("contact.tel")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "tel:" + props.managerContact.tel.replace(/[^\d+]/g, ""),
                                                    className: "fs-14 hint-text text-master text-design-color fw-bold",
                                                    children: props.managerContact.tel
                                                })
                                            ]
                                        }),
                                        // like the Lodge: mobile and fax of the manager after the phone
                                        Checkers/* default.isValidString */.Z.isValidString(props.managerContact.mobile) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "hint-text no-margin",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "fs-12 font-montserrat bold all-caps p-r-10",
                                                    children: t("contact.mob")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "tel:" + props.managerContact.mobile.replace(/[^\d+]/g, ""),
                                                    className: "fs-14 hint-text text-master text-design-color fw-bold",
                                                    children: props.managerContact.mobile
                                                })
                                            ]
                                        }),
                                        Checkers/* default.isValidString */.Z.isValidString(props.managerContact.fax) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "hint-text no-margin",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "fs-12 font-montserrat bold all-caps p-r-10",
                                                    children: t("contact.fax")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "fs-14 hint-text text-master fw-bold",
                                                    children: props.managerContact.fax
                                                })
                                            ]
                                        }),
                                        Checkers/* default.isValidString */.Z.isValidString(props.managerContact.email) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "hint-text no-margin",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "fs-12 font-montserrat bold all-caps p-r-10",
                                                    children: t("contact.email")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "mailto:" + props.managerContact.email,
                                                    className: "fs-14 hint-text text-master text-design-color fw-bold",
                                                    children: props.managerContact.email
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialLinks, {
                            isManager: props.isManager,
                            socialLinks: props.socialLinks
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                    ]
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ../../shared/node_modules/react-loading-skeleton/dist/index.mjs
var dist = __webpack_require__(91932);
;// CONCATENATED MODULE: ./components/Skeletons/ContactSkeleton.tsx



function ContactSkeleton(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "w-100",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                            height: 42,
                            className: "col-12 col-sm-8 b-rad-md mb-1"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                            height: 195,
                            width: 250,
                            className: "b-rad-md mb-1"
                        })
                    ]
                }),
                props.showContactForm && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-100",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "container",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                    height: 25,
                                    className: "w-100 b-rad-md mb-2"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-6",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                        height: 50,
                                        className: "w-100 b-rad-md mb-1"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-6",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                        height: 50,
                                        className: "w-100 b-rad-md mb-1"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                    height: 50,
                                    className: "w-100 b-rad-md mb-1"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                    height: 150,
                                    className: "w-100 b-rad-md mb-1"
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./components/ViewPort.tsx
var ViewPort = __webpack_require__(39806);
// EXTERNAL MODULE: ../../shared/node_modules/@mui/lab/Alert/Alert.js + 7 modules
var Alert = __webpack_require__(62415);
;// CONCATENATED MODULE: ./components/RawEmbedHtml.tsx



/**
 * Renders admin-authored raw HTML that may contain <script> tags (e.g. TripAdvisor/Booking.com
 * widget embeds). React's dangerouslySetInnerHTML never executes injected <script> tags (browsers
 * treat them as inert when set via innerHTML), so widgets like:
 *   <div id="TA_excellent..."></div><script async src="https://www.jscache.com/wejs?...">
 * would render the empty placeholder div but never run the script that fills it in.
 *
 * The initial render still uses dangerouslySetInnerHTML (matched on both server and client) so the
 * markup - including the <script> tag - is part of the page's actual server-rendered HTML. That way
 * the browser's native HTML parser starts fetching the widget's script immediately, in parallel with
 * everything else, instead of waiting for React to hydrate and run an effect first (which noticeably
 * delayed widgets like the TripAdvisor badge). Scripts placed this way by the browser's own parser
 * execute normally; it's only script tags inserted afterwards via the innerHTML DOM API that browsers
 * treat as inert - which is what the effect below re-creates, but only when `props.html` changes after
 * that first render (e.g. a client-side navigation swaps in a different badge).
 */ function RawEmbedHtml(props) {
    var ref = (0,react.useRef)(null);
    var isFirstRun = (0,react.useRef)(true);
    // useLayoutEffect (not useEffect) - runs synchronously right after the DOM
    // mutates and before the browser paints, so the widget's own script starts
    // its network fetch (TripAdvisor/Booking.com widget content) one frame
    // earlier than it otherwise would.
    (0,react.useLayoutEffect)(function() {
        var container = ref.current;
        if (container == null || !Checkers/* default.isValidString */.Z.isValidString(props.html)) {
            return;
        }
        container.style.display = "";
        // Skip re-injecting on the first run: this markup was already rendered via
        // dangerouslySetInnerHTML below (server + initial client render), so its
        // <script> tag already ran as part of the browser's native parse. Re-creating
        // it here would just restart the widget's request.
        if (!isFirstRun.current) {
            container.innerHTML = props.html;
            var scripts = Array.from(container.querySelectorAll("script"));
            scripts.forEach(function(oldScript) {
                var ref;
                var newScript = document.createElement("script");
                Array.from(oldScript.attributes).forEach(function(attr) {
                    newScript.setAttribute(attr.name, attr.value);
                });
                newScript.text = oldScript.textContent || "";
                (ref = oldScript.parentNode) === null || ref === void 0 ? void 0 : ref.replaceChild(newScript, oldScript);
            });
        }
        isFirstRun.current = false;
        // Lazy images (the Lodge site loads them with a lazyload script): the real url is in data-src and
        // src is a 1px placeholder, so show the real image directly.
        Array.from(container.querySelectorAll("img[data-src]")).forEach(function(lazyImage) {
            var dataSrc = lazyImage.getAttribute("data-src");
            if (Checkers/* default.isValidString */.Z.isValidString(dataSrc)) {
                lazyImage.setAttribute("src", dataSrc);
            }
            var dataSrcset = lazyImage.getAttribute("data-srcset");
            if (Checkers/* default.isValidString */.Z.isValidString(dataSrcset)) {
                lazyImage.setAttribute("srcset", dataSrcset);
            }
        });
        // hideIfImageFails: for embeds that are just an <img> (e.g. award/review
        // badges), hide the whole slot - not just the broken-image icon - when
        // there's no image at all, or the image URL is dead.
        // Only embeds that are nothing but images are hidden when the image is missing. An embed with other content
        // (an iframe badge, links with text, ...) is shown.
        var contentWithoutScripts = container.cloneNode(true);
        contentWithoutScripts.querySelectorAll("script, style").forEach(function(node) {
            return node.remove();
        });
        var hasOtherContent = container.querySelector("iframe, video, object, embed, svg") != null || (contentWithoutScripts.textContent || "").replace(/\s+/g, "") !== "";
        if (props.hideIfImageFails && !hasOtherContent) {
            var images = Array.from(container.querySelectorAll("img"));
            if (images.length === 0) {
                container.style.display = "none";
            } else {
                images.forEach(function(img) {
                    if (!Checkers/* default.isValidString */.Z.isValidString(img.getAttribute("src"))) {
                        container.style.display = "none";
                        return;
                    }
                    img.addEventListener("error", function() {
                        container.style.display = "none";
                    });
                });
            }
        }
    }, [
        props.html
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: props.className,
        ref: ref,
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: props.html
        }
    });
}

;// CONCATENATED MODULE: ./components/Contact.tsx









function Contact(props) {
    var ref, ref1, ref2;
    var t = (0,i18n/* useT */.NT)();
    var isSuccess = props.isSuccess != undefined ? props.isSuccess : false;
    var showContactForm = props.showContactForm != undefined ? props.showContactForm : true;
    var contactPhoneOverride = props.contactPhoneOverride != undefined ? props.contactPhoneOverride : null;
    var contactEmailOverride = props.contactEmailOverride != undefined ? props.contactEmailOverride : null;
    var contactTitleOverride = props.contactTitleOverride != undefined ? props.contactTitleOverride : null;
    var contactPhone = props.hasOwnProperty("contactHtml") && ((ref = props.contactHtml) === null || ref === void 0 ? void 0 : ref.hasOwnProperty("contact_phone")) && props.contactHtml.contact_phone != null ? props.contactHtml.contact_phone : null;
    var contactEmail = props.hasOwnProperty("contactHtml") && ((ref1 = props.contactHtml) === null || ref1 === void 0 ? void 0 : ref1.hasOwnProperty("contact_email")) && props.contactHtml.contact_email != null ? props.contactHtml.contact_email : null;
    var contactOver = props.hasOwnProperty("contactHtml") && ((ref2 = props.contactHtml) === null || ref2 === void 0 ? void 0 : ref2.hasOwnProperty("contact_over")) && props.contactHtml.contact_over != null ? props.contactHtml.contact_over : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: props.showContactSection ? /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            id: "contact",
            className: "bg-master-lightest py-5",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewPort/* default */.Z, {
                parentClassName: "container-fluid mb-5",
                skeletonItem: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactSkeleton, {
                    showContactForm: props.showContactForm
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactLocations, {
                                    contactOver: contactOver,
                                    locations: props.locations,
                                    showContactForm: showContactForm,
                                    contactFormTitle: props.contactFormTitle,
                                    contactPhoneOverride: contactPhoneOverride,
                                    contactEmailOverride: contactEmailOverride,
                                    contactTitleOverride: contactTitleOverride,
                                    contactPhone: contactPhone,
                                    contactEmail: contactEmail,
                                    isManager: props.isManager,
                                    managerContact: props.managerContact,
                                    propertyLat: props.propertyLat,
                                    propertyLng: props.propertyLng,
                                    socialLinks: props.socialLinks,
                                    propertyBadges: props.propertyBadges,
                                    contactEmails: props.contactEmails
                                }),
                                isSuccess ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-12 col-sm-12 col-md-6 ps-md-5",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Alert/* default */.Z, {
                                            severity: "success",
                                            sx: {
                                                mb: "20px"
                                            },
                                            children: [
                                                t("contact.thanks"),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                t("contact.received")
                                            ]
                                        })
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                props.contactHtml != undefined ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    dangerouslySetInnerHTML: {
                                        __html: props.contactHtml.contact_html
                                    }
                                }) : ""
                            ]
                        }),
                        !props.isManager && Checkers/* default.isValidArray */.Z.isValidArray(props.propertyBadges) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row mt-5 image-badges",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                                    children: ".image-badges ul, .image-badges li { list-style: none; padding: 0; margin: 0; }"
                                }),
                                props.propertyBadges.map(function(badge) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RawEmbedHtml, {
                                        className: "col-4 col-md-2 mb-4",
                                        html: badge.badgeCode,
                                        hideIfImageFails: true
                                    }, badge.id);
                                })
                            ]
                        })
                    ]
                })
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
    });
}


/***/ }),

/***/ 60314:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Header; }
});

// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(82770);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(4012);
// EXTERNAL MODULE: ../../shared/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(14140);
// EXTERNAL MODULE: ../../shared/node_modules/styled-jsx/style.js
var style = __webpack_require__(17334);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ../../shared/node_modules/react/index.js
var react = __webpack_require__(89736);
// EXTERNAL MODULE: ./helpers/i18n.ts + 7 modules
var i18n = __webpack_require__(95925);
// EXTERNAL MODULE: ../../shared/node_modules/@fortawesome/pro-light-svg-icons/index.mjs
var pro_light_svg_icons = __webpack_require__(76191);
// EXTERNAL MODULE: ../../shared/node_modules/@fortawesome/pro-solid-svg-icons/index.mjs
var pro_solid_svg_icons = __webpack_require__(72976);
// EXTERNAL MODULE: ./helpers/class/Checkers.ts
var Checkers = __webpack_require__(83974);
// EXTERNAL MODULE: ../../shared/node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(96350);
// EXTERNAL MODULE: ../../shared/node_modules/@mui/base/NoSsr/NoSsr.js
var NoSsr = __webpack_require__(38751);
// EXTERNAL MODULE: ../../shared/node_modules/next/dynamic.js
var dynamic = __webpack_require__(18256);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../shared/node_modules/react-bootstrap/esm/Modal.js + 50 modules
var Modal = __webpack_require__(94549);
// EXTERNAL MODULE: ../../shared/node_modules/next/router.js
var next_router = __webpack_require__(34357);
;// CONCATENATED MODULE: ./components/header/partials/HeaderCustomModal.tsx






var CustomModal = function(param) {
    var modalName = param.modalName, className = param.className, modalSize = param.modalSize, closeModal = param.closeModal, showModal = param.showModal, setShowModal = param.setShowModal, children = param.children, modalHeaderClass = param.modalHeaderClass, falTimes = param.falTimes, modalBodyClass = param.modalBodyClass;
    var t = (0,i18n/* useT */.NT)();
    // const [ showModal, setShowModal ] = useState<boolean>( show || false );
    var router = (0,next_router.useRouter)();
    var hasHash = router.asPath.includes("#");
    // true only while this modal has its own #modalName entry in the browser history
    var pushedHistoryRef = (0,react.useRef)(false);
    var openHandler = function() {
        if (!hasHash) {
            router.push({
                hash: modalName + ""
            }, undefined, {
                scroll: false
            });
            pushedHistoryRef.current = true;
        }
        setShowModal(true);
    };
    var closeHandler = function() {
        closeModal();
        setShowModal(false);
        if (pushedHistoryRef.current) {
            // undo only this modal's own #hash entry
            pushedHistoryRef.current = false;
            router.back();
        }
    };
    var clickOutSideHandler = function() {
        closeModal();
        setShowModal(false);
    };
    (0,react.useEffect)(function() {
        if (showModal) openHandler();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        showModal
    ]);
    (0,react.useEffect)(function() {
        if (!hasHash && showModal) clickOutSideHandler();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        hasHash
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
        id: "modal-menu",
        className: className,
        size: modalSize,
        show: showModal,
        onHide: closeHandler,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Header */.Z.Header, {
                className: "Modal__header ".concat(modalHeaderClass),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    type: "button",
                    className: "btn-close btn-no-outline background-none w-auto h-auto",
                    "aria-label": t("a11y.close"),
                    onClick: closeHandler,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                        icon: falTimes,
                        className: "text-black",
                        style: {
                            fontSize: "16px"
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Body */.Z.Body, {
                className: modalBodyClass,
                children: children
            })
        ]
    });
};
/* harmony default export */ var HeaderCustomModal = (/*#__PURE__*/(0,react.memo)(CustomModal));

// EXTERNAL MODULE: ../../shared/node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(31969);
// EXTERNAL MODULE: ./helpers/MethodHelper.ts
var MethodHelper = __webpack_require__(23158);
// EXTERNAL MODULE: ../../shared/node_modules/next/link.js
var next_link = __webpack_require__(75547);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../shared/node_modules/react-select/async-creatable/dist/react-select.esm.js + 1 modules
var react_select_esm = __webpack_require__(7398);
// EXTERNAL MODULE: ../../shared/node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__(96916);
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);
// EXTERNAL MODULE: ./api/client.ts
var client = __webpack_require__(8019);
;// CONCATENATED MODULE: ./components/header/partials/SearchIcon.tsx













// import {ClickAwayListener} from "@mui/material";
function SearchIcon(props) {
    var t = (0,i18n/* useT */.NT)();
    var localeBase = (0,i18n/* useLocalePrefix */._X)();
    var customSearch = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"]["search"];
    });
    // console.log( "pageId", pageId )
    var pageId = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"]["page_id"];
    });
    var ref = (0,react.useState)(null), selectedSearchLocation = ref[0], setSelectedSearchLocation = ref[1];
    var toggleTopSearch = function toggleTopSearch() {
        jquery_default()(".search-wrapper").fadeToggle();
    };
    var router = (0,next_router.useRouter)();
    var handleInputChange = function(input) {
        setSelectedSearchLocation(input);
        var location_slug = input.slug;
        var location_val = input.value;
        var location_data = location_val.split("_");
        var location_type = location_data[0];
        var location_id = location_data[1];
        switch(location_type){
            case "property":
                if (Checkers/* default.isValidString */.Z.isValidString(location_slug)) {
                    toggleTopSearch();
                    router.push(location_slug);
                } else {
                    toggleTopSearch();
                    router.push("/property/" + location_id);
                }
                break;
            case "destination":
                if (Checkers/* default.isValidString */.Z.isValidString(location_slug)) {
                    toggleTopSearch();
                    router.push(location_slug);
                }
                break;
        }
    };
    var ref1 = (0,react.useState)(null), defaultSearchOptions = ref1[0], setDefaultSearchOptions = ref1[1];
    (0,react.useEffect)(function() {
        (0,client/* getSearchDefaultOptionsAction */.cG)(pageId, window.location.pathname).then(function(response) {
            setDefaultSearchOptions(response.options);
            if (response.defaultLocationValue != undefined) {
                setSelectedSearchLocation(response.defaultLocationValue);
            } else {
                var customOption = {
                    value: customSearch,
                    label: customSearch
                };
                if (customOption.value != null) {
                    setSelectedSearchLocation(customOption);
                }
            }
        });
    }, [
        pageId
    ]);
    var loadSearchOptions = function(inputValue, callback) {
        (0,client/* loadSearchOptionsAction */.gV)(pageId, inputValue, callback);
    };
    var topSearch = function(searchLocation) {
        var location_val = searchLocation != null ? searchLocation.value : searchLocation;
        var location_data = location_val != null ? location_val.split("_") : null;
        var location_type = location_data != null ? location_data[0] : null;
        switch(location_type){
            case "destination":
                location.href = window.location.origin + localeBase + searchLocation.slug;
                break;
            case "location":
                location.href = window.location.origin + localeBase + searchLocation.slug;
                break;
            case "property":
                location.href = window.location.origin + localeBase + searchLocation.slug;
                break;
            default:
                location.href = window.location.origin + localeBase + "/properties/search/?search=" + location_val;
                break;
        }
    };
    var topSearchHandler = function(event) {
        event.preventDefault();
        topSearch(selectedSearchLocation);
    };
    // useEffect( () => {
    //   const keyEnter = event => {
    //     if ( event.key === 'Enter' ) {
    //       topSearch( selectedSearchLocation )
    //       // console.log( "enter pressed" )
    //       event.preventDefault()
    //     }
    //   }
    //
    //   document.addEventListener( 'keypress', keyEnter )
    // }, [selectedSearchLocation])
    // const [state, setState] = useState(false)
    var showGuestAreaLink = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_header_menu_guests_area_show") == 1;
    });
    var guestAreaLinkTitle = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_header_menu_guests_area_link_title");
    });
    var showOwnerAreaLink = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_header_menu_owners_area_show") == 1;
    });
    var ownerAreaLinkTitle = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_header_menu_owners_area_link_title");
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            showGuestAreaLink || showOwnerAreaLink ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: "cursor-pointer nav-item me-0 ms-0 position-relative",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                id: "links-icon",
                                href: "#/",
                                className: "dropdown-toggle d-flex align-items-center",
                                "aria-label": t("a11y.links"),
                                title: t("a11y.links"),
                                "data-bs-toggle": "dropdown",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "sr-only",
                                        children: t("a11y.links")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: pro_light_svg_icons/* faRightToBracket */.BEY,
                                        size: "2x"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                className: "dropdown-menu ",
                                style: {
                                    transform: "translate(-50%, 0)",
                                    left: "50%"
                                },
                                children: [
                                    showOwnerAreaLink ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "menu-icon",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                href: "https://owners.loggia.net/en/" + pageId + "/login",
                                                target: "_blank",
                                                rel: "noreferrer",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                        icon: pro_solid_svg_icons/* faUserTie */.Cv1
                                                    }),
                                                    "\xa0",
                                                    Checkers/* default.isValidString */.Z.isValidString(guestAreaLinkTitle) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: guestAreaLinkTitle
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: t("header.ownersArea")
                                                    })
                                                ]
                                            })
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                    showGuestAreaLink ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "menu-icon",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                href: "https://guests.loggia.net/en/" + pageId + "/login",
                                                target: "_blank",
                                                rel: "noreferrer",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                        icon: pro_solid_svg_icons/* faPlane */.wKO
                                                    }),
                                                    "\xa0",
                                                    Checkers/* default.isValidString */.Z.isValidString(guestAreaLinkTitle) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: guestAreaLinkTitle
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: t("header.travellersArea")
                                                    })
                                                ]
                                            })
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                ]
                            })
                        ]
                    })
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: "nav-item me-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    id: "quick_search",
                    onSubmit: function(event) {
                        return topSearchHandler(event);
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "search-wrapper",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "search-container",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_select_esm/* default */.Z, {
                                            noOptionsMessage: function() {
                                                return "nothing found";
                                            },
                                            loadingMessage: function() {
                                                return "searching...";
                                            },
                                            cacheOptions: false,
                                            defaultOptions: defaultSearchOptions,
                                            loadOptions: loadSearchOptions,
                                            onChange: handleInputChange,
                                            // // defaultValue={defaultLocationValue}
                                            value: selectedSearchLocation,
                                            className: "SearchBar-Form__form-group-select",
                                            id: "location_property",
                                            name: "location_property",
                                            inputId: "searchright",
                                            instanceId: "location_property",
                                            isSearchable: true,
                                            formatCreateLabel: function(inputValue) {
                                                return t("search.searchFor", {
                                                    value: inputValue
                                                });
                                            },
                                            options: props.options,
                                            // styles={props.customStyles}
                                            placeholder: t("search.whereAreYouGoing"),
                                            blurInputOnSelect: true,
                                            menuPlacement: "bottom",
                                            components: {
                                                DropdownIndicator: function() {
                                                    return null;
                                                },
                                                IndicatorSeparator: function() {
                                                    return null;
                                                }
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            className: "search-btn pull-right",
                                            form: "quick_search",
                                            onClick: function(event) {
                                                return topSearchHandler(event);
                                            },
                                            "aria-label": t("search.search"),
                                            type: "submit",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                size: "2x",
                                                icon: pro_light_svg_icons/* faMagnifyingGlass */.Y$T
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "search-backdrop",
                                    onClick: toggleTopSearch
                                })
                            ]
                        }),
                        props.showSearch ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                            className: "button searchbutton nav-link d-flex align-items-center search-label",
                            onClick: toggleTopSearch,
                            htmlFor: "searchright",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "sr-only",
                                    children: t("search.search")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    size: "2x",
                                    icon: pro_light_svg_icons/* faMagnifyingGlass */.Y$T
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                    ]
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/header/partials/LanguageSwitcher.tsx
var LanguageSwitcher = __webpack_require__(94795);
;// CONCATENATED MODULE: ./components/header/types/HeaderDefault.tsx














var HeaderLogo = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 41306));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(41306)
            ];
        }
    },
    ssr: true
});
var HeaderNavigation = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 44818));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(44818)
            ];
        }
    },
    ssr: true
});
var ContactIcons = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 38530));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(38530)
            ];
        }
    },
    ssr: true
});
function HeaderDefault(props) {
    var ref;
    var t = (0,i18n/* useT */.NT)();
    var showSearch = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_header_show_menu_search_icon") == 1;
    });
    var ref1 = (0,react.useState)(false), show = ref1[0], setShow = ref1[1];
    var handleShow = function() {
        setShow(true);
    };
    var handleHide = function() {
        setShow(false);
        return false;
    };
    var showMenuItemsInBurger = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_header_menu_items_in_burger");
    });
    var navbarModeClass = props.navbarModeClass;
    var useRedirectUrl = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "useRedirectUrl");
    });
    var homePageUrl = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "logoUrl");
    });
    var homepageUrl = Checkers/* default.isValidString */.Z.isValidString((0,MethodHelper/* getHomepageUrl */.Ir)(props.referer, useRedirectUrl, homePageUrl)) ? (0,MethodHelper/* getHomepageUrl */.Ir)(props.referer, useRedirectUrl, homePageUrl) : "#";
    var personalColor = Checkers/* default.isValidString */.Z.isValidString((ref = props.app) === null || ref === void 0 ? void 0 : ref.designColor) ? props.app.designColor : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                ref: props.setHeaderDiv,
                className: "header Header ".concat(navbarModeClass, " border-0 px-0 mb-0"),
                "data-builder-header": "different",
                style: (0,_object_spread/* default */.Z)({
                    height: "auto",
                    zIndex: props.zIndex > 0 ? props.zIndex : 99999
                }, personalColor ? {
                    backgroundColor: personalColor
                } : {}),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: Checkers/* default.isValidString */.Z.isValidString(props.containerClass) ? props.containerClass : "container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: homepageUrl,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "navbar-brand d-flex flex-row justify-content-start col-auto",
                                title: "logo",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderLogo, {
                                    navbarModeClass: navbarModeClass,
                                    logoProps: props.logoProps,
                                    pageTitle: props.pageTitle
                                })
                            })
                        }),
                        props.hasOwnProperty("contactIcons") && props.contactIcons != null && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            className: "minimized-partials navbar-nav d-flex flex-row justify-content-end ms-auto mb-2 mb-md-0 hidden-xs hidden-sm hidden",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactIcons, {
                                contactIcons: props.contactIcons
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (showMenuItemsInBurger == "1" ? "d-flex navbar-toggle-collapse " : "d-none") + " w-100 ",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: "navbar-nav flex-row justify-content-end align-items-center ms-auto mb-2 mb-md-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactIcons, {
                                    contactIcons: props.contactIcons
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (showMenuItemsInBurger == "1" ? "d-none" : " navbar-toggle-collapse") + "",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: "navbar-nav flex-row justify-content-end align-items-center ms-auto mb-2 mb-md-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderNavigation, {
                                    referer: props.referer,
                                    menu: props.menu,
                                    partials: props.partials,
                                    headerPartialBook: true,
                                    modalDropdownClass: null,
                                    contactIcons: props.hasOwnProperty("contactIcons") ? props.contactIcons : null,
                                    handleHide: handleHide,
                                    hideLanguages: true
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            id: "search-wrapper",
                            className: "d-flex",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                className: "navbar-nav flex-row justify-content-end align-items-center ms-auto mb-2 mb-md-0",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchIcon, {
                                        showSearch: showSearch
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LanguageSwitcher/* default */.Z, {
                                        partials: props.partials,
                                        inHeaderBar: true
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            type: "button",
                            className: "test navbar-toggle collapsed border-0 " + (showMenuItemsInBurger == "1" ? "d-inline-block" : "visible-xs visible-sm"),
                            "aria-expanded": "false",
                            onClick: handleShow,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "sr-only",
                                    children: t("a11y.toggleNavigation")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    icon: props.faGripLines,
                                    size: "2x"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderCustomModal, {
                modalName: "side_menu",
                className: "Modal-Header slide-right",
                modalSize: "lg",
                closeModal: handleHide,
                showModal: show,
                setShowModal: setShow,
                modalBodyClass: "Modal__body navbar-menu d-flex flex-column justify-content-between padding-0",
                falTimes: props.falTimes,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "navbar-nav justify-content-start",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderNavigation, {
                            referer: props.referer,
                            menu: props.menu,
                            partials: props.partials,
                            headerPartialBook: false,
                            modalDropdownClass: "shadow-none position-relative mt-1 ps-2 pe-2 w-100",
                            contactIcons: null,
                            menuItemDisableWrap: true,
                            handleHide: handleHide,
                            hideLanguages: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "minimized-partials navbar-nav justify-content-start d-flex flex-column mb-5",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(NoSsr/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderNavigation, {
                                    referer: props.referer,
                                    menu: props.menu,
                                    partials: props.partials,
                                    modalPartials: true,
                                    contactIcons: null,
                                    menuItemDisableWrap: true,
                                    handleHide: handleHide
                                }),
                                props.hasOwnProperty("contactIcons") && props.contactIcons != null && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: "Contact-Icons mt-1 mb-1 me-0 d-xs-flex d-sm-flex flex-row hidden",
                                    style: {
                                        margin: "5px 25px"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactIcons, {
                                        contactIcons: props.contactIcons,
                                        modalDropdownClass: "shadow position-fixed mb-3 ps-2 pe-2 w-auto",
                                        side: "right"
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/header/logo/HeaderLogo.tsx
var logo_HeaderLogo = __webpack_require__(41306);
// EXTERNAL MODULE: ./components/header/logo/HeaderLogoAltMode.tsx
var HeaderLogoAltMode = __webpack_require__(27515);
// EXTERNAL MODULE: ./components/header/menu/HeaderNavigation.tsx + 2 modules
var menu_HeaderNavigation = __webpack_require__(44818);
// EXTERNAL MODULE: ./components/header/partials/ContactIcons.tsx + 2 modules
var partials_ContactIcons = __webpack_require__(38530);
;// CONCATENATED MODULE: ./components/header/types/HeaderTypeFour.tsx














function HeaderTypeFour(props) {
    var t = (0,i18n/* useT */.NT)();
    // useEffect(() =>{
    //   console.log("props.apps", props.apps)
    // })
    var ref = (0,react.useState)(false), show = ref[0], setShow = ref[1];
    var handleShow = function() {
        setShow(true);
    };
    var handleHide = function() {
        setShow(false);
    };
    var useRedirectUrl = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "useRedirectUrl");
    });
    var homePageUrl = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "logoUrl");
    });
    var homepageUrl = Checkers/* default.isValidString */.Z.isValidString((0,MethodHelper/* getHomepageUrl */.Ir)(props.referer, useRedirectUrl, homePageUrl)) ? (0,MethodHelper/* getHomepageUrl */.Ir)(props.referer, useRedirectUrl, homePageUrl) : "#";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                ref: props.setHeaderDiv,
                className: "header-centered Header Header-Centered ".concat(props.navbarModeClass, " flex-row h-auto"),
                "data-pages": props.resizeClass != "" ? "header" : "",
                "data-builder-header": "centered",
                "data-pages-header": props.resizeClass != "" ? "autoresize" : "",
                "data-pages-resize-class": props.resizeClass,
                style: {
                    zIndex: props.zIndex > 0 ? props.zIndex : 10
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: Checkers/* default.isValidString */.Z.isValidString(props.containerClass) ? props.containerClass : "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row align-items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: "navbar-nav flex-row col-5 justify-content-start invisible h-0",
                                "data-builder-left-nav": true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_HeaderNavigation["default"], {
                                    referer: props.referer,
                                    menu: props.menu,
                                    partials: props.partials,
                                    headerPartials: false,
                                    headerPartialBook: false,
                                    modalDropdownClass: null,
                                    handleHide: handleHide
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "nav flex-row col-12 col-md-2 justify-content-center",
                                "data-builder-center-logo": true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        type: "button",
                                        className: "navbar-toggle collapsed border-0 hidden me-auto ms-4",
                                        "aria-expanded": "false",
                                        onClick: handleShow,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "sr-only",
                                                children: t("a11y.toggleNavigation")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                icon: props.faGripLines,
                                                size: "2x"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: homepageUrl,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "navbar-brand py-1 px-0",
                                            title: "logo",
                                            children: props.bgTransparent == true ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderLogoAltMode["default"], {
                                                app: props.app,
                                                navbarModeClass: props.navbarModeClass,
                                                resizeClass: props.resizeClass,
                                                logoProps: props.logoProps,
                                                pageTitle: props.pageTitle
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(logo_HeaderLogo["default"], {
                                                navbarModeClass: props.navbarModeClass,
                                                resizeClass: props.resizeClass,
                                                logoProps: props.logoProps,
                                                pageTitle: props.pageTitle
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                className: "navbar-nav flex-row col-5 justify-content-end invisible h-0",
                                "data-builder-right-nav": true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_HeaderNavigation["default"], {
                                        referer: props.referer,
                                        menu: null,
                                        partials: props.partials,
                                        headerPartialBook: true,
                                        modalDropdownClass: null,
                                        contactIcons: null,
                                        handleHide: handleHide
                                    }),
                                    props.hasOwnProperty("contactIcons") ? props.contactIcons != null ? /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_ContactIcons["default"], {
                                        contactIcons: props.contactIcons
                                    }) : "" : ""
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderCustomModal, {
                modalName: "side_menu",
                className: "Modal-Header slide-left",
                modalSize: "lg",
                closeModal: handleHide,
                showModal: show,
                setShowModal: setShow,
                modalBodyClass: "Modal__body navbar-menu d-flex flex-column justify-content-between padding-0",
                falTimes: props.falTimes,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "navbar-nav justify-content-start",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_HeaderNavigation["default"], {
                            referer: props.referer,
                            menu: props.menu,
                            partials: props.partials,
                            headerPartialBook: false,
                            modalDropdownClass: "shadow-none position-relative mt-1 ps-2 pe-2 w-100",
                            contactIcons: null,
                            menuItemDisableWrap: true,
                            handleHide: handleHide
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        className: "navbar-nav justify-content-start mb-5",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_HeaderNavigation["default"], {
                                referer: props.referer,
                                menu: null,
                                partials: props.partials,
                                contactIcons: null,
                                menuItemDisableWrap: true,
                                handleHide: handleHide
                            }),
                            props.hasOwnProperty("contactIcons") && props.contactIcons != null && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: "Contact-Icons mt-1 mb-1 ms-0 d-xs-flex d-sm-flex flex-row",
                                style: {
                                    margin: "5px 25px"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_ContactIcons["default"], {
                                    contactIcons: props.contactIcons,
                                    modalDropdownClass: "shadow position-fixed mb-3 ps-2 pe-2 w-auto",
                                    side: "left"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/header/types/HeaderTypeOne.tsx
















function HeaderTypeOne(props) {
    var t = (0,i18n/* useT */.NT)();
    var showSearch = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_header_show_menu_search_icon") == 1;
    });
    var ref = (0,react.useState)(false), show = ref[0], setShow = ref[1];
    var handleShow = function() {
        setShow(true);
    };
    var handleHide = function() {
        setShow(false);
    };
    var showMenuItemsInBurger = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_header_menu_items_in_burger");
    });
    var useRedirectUrl = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "useRedirectUrl");
    });
    var homePageUrl = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "logoUrl");
    });
    var homepageUrl = Checkers/* default.isValidString */.Z.isValidString((0,MethodHelper/* getHomepageUrl */.Ir)(props.referer, useRedirectUrl, homePageUrl)) ? (0,MethodHelper/* getHomepageUrl */.Ir)(props.referer, useRedirectUrl, homePageUrl) : "#";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                ref: props.setHeaderDiv,
                className: "test Header navbar " + props.navbarModeClass + props.textColor + " flex-nowrap border-0 px-0 mb-0",
                "data-pages": props.resizeClass != "" ? "header" : "",
                "data-builder-header": "different",
                "data-pages-header": props.resizeClass != "" ? "autoresize" : "",
                "data-pages-resize-class": props.resizeClass,
                style: {
                    height: "auto",
                    zIndex: props.zIndex > 0 ? props.zIndex : 1023
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    id: "container",
                    className: Checkers/* default.isValidString */.Z.isValidString(props.containerClass) ? props.containerClass : "container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: homepageUrl,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "navbar-brand d-flex flex-row justify-content-start py-0 px-0",
                                title: "logo",
                                children: props.headerProps.builder_header_mode == "transparent" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderLogoAltMode["default"], {
                                        app: props.app,
                                        navbarModeClass: props.navbarModeClass,
                                        resizeClass: props.resizeClass,
                                        logoProps: props.logoProps,
                                        pageTitle: props.pageTitle
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(logo_HeaderLogo["default"], {
                                    navbarModeClass: props.navbarModeClass,
                                    resizeClass: props.resizeClass,
                                    logoProps: props.logoProps,
                                    pageTitle: props.pageTitle
                                })
                            })
                        }),
                        props.hasOwnProperty("contactIcons") ? props.contactIcons != null ? /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            className: "minimized-partials navbar-nav d-flex flex-row justify-content-end ms-auto mb-2 mb-md-0 hidden-xs hidden-sm hidden",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_ContactIcons["default"], {
                                contactIcons: props.contactIcons
                            })
                        }) : "" : "",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (showMenuItemsInBurger == "1" ? "d-flex  navbar-toggle-collapse" : "d-none") + " w-100 ",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: "navbar-nav flex-row justify-content-end align-items-center ms-auto mb-2 mb-md-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_ContactIcons["default"], {
                                    contactIcons: props.contactIcons
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (showMenuItemsInBurger == "1" ? "d-none" : " navbar-toggle-collapse") + " ",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: "navbar-nav flex-row justify-content-end align-items-center ms-auto mb-2 mb-md-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_HeaderNavigation["default"], {
                                    referer: props.referer,
                                    menu: props.menu,
                                    partials: props.partials,
                                    headerPartialBook: true,
                                    modalDropdownClass: null,
                                    contactIcons: props.hasOwnProperty("contactIcons") ? props.contactIcons : null,
                                    handleHide: handleHide,
                                    hideLanguages: true
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "d-flex",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                className: "navbar-nav flex-row justify-content-end align-items-center ms-auto mb-2 mb-md-0",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchIcon, {
                                        showSearch: showSearch
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LanguageSwitcher/* default */.Z, {
                                        partials: props.partials,
                                        inHeaderBar: true
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            type: "button",
                            className: "τεστ-2 navbar-toggle collapsed border-0 " + (showMenuItemsInBurger == "1" ? "d-inline-block" : "visible-xs visible-sm"),
                            "aria-expanded": "false",
                            onClick: handleShow,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "sr-only",
                                    children: t("a11y.toggleNavigation")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    icon: props.faGripLines,
                                    size: "2x"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderCustomModal, {
                modalName: "side_menu",
                className: "Modal-Header slide-right",
                modalSize: "lg",
                closeModal: handleHide,
                showModal: show,
                setShowModal: setShow,
                modalBodyClass: "Modal__body navbar-menu d-flex flex-column justify-content-between padding-0",
                falTimes: props.falTimes,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "navbar-nav justify-content-start",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_HeaderNavigation["default"], {
                            referer: props.referer,
                            menu: props.menu,
                            partials: props.partials,
                            headerPartialBook: false,
                            modalDropdownClass: "shadow-none position-relative mt-1 ps-2 pe-2 w-100",
                            contactIcons: null,
                            menuItemDisableWrap: true,
                            handleHide: handleHide,
                            hideLanguages: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "minimized-partials navbar-nav justify-content-start d-flex flex-column mb-5",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(NoSsr/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_HeaderNavigation["default"], {
                                    referer: props.referer,
                                    menu: props.menu,
                                    partials: props.partials,
                                    modalPartials: true,
                                    contactIcons: null,
                                    menuItemDisableWrap: true,
                                    handleHide: handleHide
                                }),
                                props.hasOwnProperty("contactIcons") && props.contactIcons != null && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: "Contact-Icons mt-1 mb-1 me-0 d-xs-flex d-sm-flex flex-row",
                                    style: {
                                        margin: "5px 25px"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_ContactIcons["default"], {
                                        contactIcons: props.contactIcons,
                                        modalDropdownClass: "shadow position-fixed mb-3 ps-2 pe-2 w-auto",
                                        side: "right"
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/header/types/HeaderTypeThree.tsx











var HeaderTypeThree_HeaderLogo = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 41306));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(41306)
            ];
        }
    },
    ssr: true
});
var HeaderTypeThree_HeaderLogoAltMode = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 27515));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(27515)
            ];
        }
    },
    ssr: true
});
var HeaderTypeThree_HeaderNavigation = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 44818));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(44818)
            ];
        }
    },
    ssr: true
});
var HeaderTypeThree_ContactIcons = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 38530));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(38530)
            ];
        }
    },
    ssr: true
});
function HeaderTypeThree(props) {
    var t = (0,i18n/* useT */.NT)();
    // useEffect(() =>{
    //   console.log("props.apps", props.apps)
    // })
    var ref = (0,react.useState)(false), show = ref[0], setShow = ref[1];
    var handleShow = function() {
        setShow(true);
    };
    var handleHide = function() {
        setShow(false);
    };
    var useRedirectUrl = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "useRedirectUrl");
    });
    var homePageUrl = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "logoUrl");
    });
    var homepageUrl = Checkers/* default.isValidString */.Z.isValidString((0,MethodHelper/* getHomepageUrl */.Ir)(props.referer, useRedirectUrl, homePageUrl)) ? (0,MethodHelper/* getHomepageUrl */.Ir)(props.referer, useRedirectUrl, homePageUrl) : "#";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                ref: props.setHeaderDiv,
                className: "Header ".concat(props.navbarModeClass, " d-flex flex-row align-items-center"),
                "data-pages": props.resizeClass != "" ? "header" : "",
                "data-builder-header": "minimized",
                "data-pages-header": props.resizeClass != "" ? "autoresize" : "",
                "data-pages-resize-class": props.resizeClass,
                style: {
                    height: "auto",
                    zIndex: props.zIndex > 0 ? props.zIndex : 10
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: Checkers/* default.isValidString */.Z.isValidString(props.containerClass) ? props.containerClass : "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "d-flex flex-row-reverse flex-md-row justify-content-between nav w-100",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                type: "button",
                                className: "navbar-toggle collapsed border-0 me-md-auto visible",
                                "aria-expanded": "false",
                                onClick: handleShow,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "sr-only",
                                        children: t("a11y.toggleNavigation")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: props.faGripLines,
                                        size: "2x"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: homepageUrl,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "navbar-brand me-md-auto py-1 px-0",
                                    title: "logo",
                                    children: props.bgTransparent == true ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderTypeThree_HeaderLogoAltMode, {
                                        app: props.app,
                                        navbarModeClass: props.navbarModeClass,
                                        resizeClass: props.resizeClass,
                                        logoProps: props.logoProps,
                                        pageTitle: props.pageTitle
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderTypeThree_HeaderLogo, {
                                        navbarModeClass: props.navbarModeClass,
                                        resizeClass: props.resizeClass,
                                        logoProps: props.logoProps,
                                        pageTitle: props.pageTitle
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderCustomModal, {
                modalName: "side_menu",
                className: "Modal-Header slide-left",
                modalSize: "lg",
                closeModal: handleHide,
                showModal: show,
                setShowModal: setShow,
                modalBodyClass: "Modal__body navbar-menu padding-0 d-flex flex-column justify-content-between",
                falTimes: props.falTimes,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "navbar-nav justify-content-start",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderTypeThree_HeaderNavigation, {
                            referer: props.referer,
                            menu: props.menu,
                            partials: props.partials,
                            headerPartialBook: false,
                            modalDropdownClass: "shadow-none position-relative mt-1 ps-2 pe-2 w-100",
                            contactIcons: null,
                            menuItemDisableWrap: true,
                            handleHide: handleHide
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "navbar-nav justify-content-start mb-5",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(NoSsr/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderTypeThree_HeaderNavigation, {
                                    referer: props.referer,
                                    menu: props.menu,
                                    partials: props.partials,
                                    modalPartials: true,
                                    contactIcons: null,
                                    menuItemDisableWrap: true,
                                    handleHide: handleHide
                                }),
                                props.hasOwnProperty("contactIcons") && props.contactIcons != null && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: "Contact-Icons mt-1 mb-1 ms-0 d-xs-flex d-sm-flex flex-row",
                                    style: {
                                        margin: "5px 25px"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderTypeThree_ContactIcons, {
                                        contactIcons: props.contactIcons,
                                        modalDropdownClass: "shadow position-fixed mb-3 ps-2 pe-2 w-auto",
                                        side: "left"
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/header/types/HeaderTypeTwo.tsx














function HeaderTypeTwo(props) {
    var t = (0,i18n/* useT */.NT)();
    var ref = (0,react.useState)(false), show = ref[0], setShow = ref[1];
    var handleShow = function() {
        setShow(true);
    };
    var handleHide = function() {
        setShow(false);
    };
    var ul_class = props.property ? "nav inner navbar-nav my-2 d-flex flex-row justify-content-end align-items-center my-md-0" : "nav inner navbar-nav my-2 d-flex flex-row justify-content-end align-items-center my-md-0 hidden-xs hidden-sm hidden";
    var li_class = props.property ? " hidden-xs hidden-sm" : "";
    props.logoProps.logoMode = props.navbarModeClass.match("Header-Dark");
    var useRedirectUrl = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "useRedirectUrl");
    });
    var homePageUrl = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "logoUrl");
    });
    var homepageUrl = Checkers/* default.isValidString */.Z.isValidString((0,MethodHelper/* getHomepageUrl */.Ir)(props.referer, useRedirectUrl, homePageUrl)) ? (0,MethodHelper/* getHomepageUrl */.Ir)(props.referer, useRedirectUrl, homePageUrl) : "#";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                className: "header-one Header Header-Double ".concat(props.navbarModeClass, " px-3 py-2 border-bottom"),
                "data-builder-header": "double",
                "data-builder-property": props.property,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: Checkers/* default.isValidString */.Z.isValidString(props.containerClass) ? props.containerClass : "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "d-flex flex-wrap align-items-center justify-content-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: homepageUrl,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "d-flex align-items-center my-1 text-white text-decoration-none",
                                    title: "logo",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(logo_HeaderLogo["default"], {
                                        navbarModeClass: props.navbarModeClass,
                                        resizeClass: props.resizeClass,
                                        logoProps: props.logoProps,
                                        pageTitle: props.pageTitle
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                id: "navbar-toggle",
                                className: "d-flex flex-row justify-content-end align-items-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    type: "button",
                                    className: "navbar-toggle border-0 visible-xs visible-sm",
                                    "aria-expanded": "false",
                                    onClick: handleShow,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "sr-only",
                                            children: t("a11y.toggleNavigation")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                            icon: props.faGripLines,
                                            size: "2x"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                className: ul_class,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "hint-text text-capitalize ".concat(li_class),
                                            href: "https://owners.loggia.gr/en/12/login",
                                            target: "_blank",
                                            rel: "noreferrer",
                                            children: t("header.ownersLogin")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "hint-text text-capitalize b-r p-r-20 ".concat(li_class),
                                            href: "https://guests.loggia.gr/en/12/login",
                                            target: "_blank",
                                            rel: "noreferrer",
                                            children: t("header.travelersLogin")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            href: "tel:".concat(props.phone),
                                            className: "font-montserrat fs-13 ".concat(li_class),
                                            children: [
                                                props.phone,
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                    icon: pro_solid_svg_icons/* faPhone */.j1w,
                                                    className: "m-l-10"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "hidden",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "tel:".concat(props.phone),
                                            className: "font-montserrat fs-13",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                icon: pro_solid_svg_icons/* faPhone */.j1w,
                                                className: "m-l-10 fs-18"
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                className: "header-two Header ".concat(props.navbarTwoModeClass, " Header-Custom-Color Header-Sticky-Top flex-nowrap px-0 py-2 invisible hidden-xs hidden-sm h-0 padding-0"),
                style: {
                    zIndex: props.zIndex > 0 ? props.zIndex : 10
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "".concat(Checkers/* default.isValidString */.Z.isValidString(props.containerClass) ? props.containerClass : "container", " d-flex flex-row justify-content-center align-items-center"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            className: "navbar-nav flex-row col-lg-auto me-lg-auto",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_HeaderNavigation["default"], {
                                referer: props.referer,
                                menu: props.menu,
                                partials: props.partials,
                                headerPartials: false,
                                headerPartialBook: false,
                                modalDropdownClass: null,
                                handleHide: handleHide
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            className: "navbar-nav flex-row justify-content-end",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_HeaderNavigation["default"], {
                                    referer: props.referer,
                                    menu: null,
                                    partials: props.partials,
                                    headerPartialBook: true,
                                    contactIcons: null,
                                    handleHide: handleHide
                                }),
                                props.hasOwnProperty("contactIcons") && props.contactIcons != null && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: "mt-1 mb-1 ms-0 d-xs-flex d-sm-flex flex-row Contact-Icons",
                                    style: {
                                        margin: "5px 25px"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_ContactIcons["default"], {
                                        contactIcons: props.contactIcons
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderCustomModal, {
                modalName: "side_menu",
                className: "Modal-Header Modal-Header-Double slide-right",
                modalSize: "lg",
                closeModal: handleHide,
                showModal: show,
                setShowModal: setShow,
                modalBodyClass: "Modal__body navbar-menu d-flex flex-column justify-content-between padding-0",
                falTimes: props.falTimes,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "navbar-nav justify-content-start",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_HeaderNavigation["default"], {
                            referer: props.referer,
                            menu: props.menu,
                            partials: props.partials,
                            headerPartialBook: false,
                            modalDropdownClass: "shadow-none position-relative mt-1 ps-2 pe-2 w-100",
                            contactIcons: null,
                            menuItemDisableWrap: true,
                            handleHide: handleHide
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        className: "navbar-nav justify-content-start mb-5",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_HeaderNavigation["default"], {
                                referer: props.referer,
                                menu: props.menu,
                                partials: props.partials,
                                modalPartials: true,
                                contactIcons: null,
                                menuItemDisableWrap: true,
                                handleHide: handleHide
                            }),
                            props.hasOwnProperty("contactIcons") && props.contactIcons != null && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: "Contact-Icons mt-1 mb-1 ms-0 d-xs-flex d-sm-flex flex-row",
                                style: {
                                    margin: "5px 25px"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_ContactIcons["default"], {
                                    contactIcons: props.contactIcons,
                                    modalDropdownClass: "shadow position-fixed mb-3 ps-2 pe-2 w-auto"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ../../shared/node_modules/@fortawesome/pro-regular-svg-icons/faBars.js
var faBars = __webpack_require__(21954);
// EXTERNAL MODULE: ./helpers/BookingHelper.ts
var BookingHelper = __webpack_require__(7839);
;// CONCATENATED MODULE: ./components/Header.tsx



















function Header(props) {
    var ref, ref1;
    var menu = props.navigation != undefined && props.navigation.hasOwnProperty("menu") ? props.navigation.menu : null;
    var partials = props.navigation != undefined && props.navigation.hasOwnProperty("partials") ? props.navigation.partials : null;
    var phone = props.head.location[0].phone;
    var containerClass = Checkers/* default.objChildExists */.Z.objChildExists(props, "containerClass") ? props.containerClass : null;
    var pageTitle = props.head.data.title;
    var contactIcons = function() {
        if (props.app.showContactIconsOnMenu) {
            return {
                phoneIcon: props.app.showPhoneIconOnMenu,
                chatIcon: props.app.showChatIconOnMenu,
                mailIcon: props.app.showMailIconOnMenu,
                phoneIconData: props.app.menuPhoneIconData,
                chatIconData: props.app.menuChatIconData,
                mailIconData: props.app.menuMailIconData
            };
        }
        return null;
    };
    var app = props.app;
    var localeBase = (0,i18n/* useLocalePrefix */._X)();
    var ref2 = (0,react.useState)(null), headerDiv = ref2[0], setHeaderDiv = ref2[1];
    // '/' until the origin is known: a null start rendered the server html menu links as "null" + slug (/nullalbum)
    var ref3 = (0,react.useState)("/"), referer = ref3[0], setReferer = ref3[1];
    var ref4 = (0,react.useState)(false), isStuck = ref4[0], setIsStuck = ref4[1];
    var property = props.hasOwnProperty("isHomepage") ? !props.isHomepage : true;
    // full-width searchbar homepage rendering the property-style photo grid
    // should behave like a property page header, not the transparent overlay
    var isHomepagePropertyPhotoGrid = !property && (app.bookingSearchbarWidth === true || app.bookingSearchbarWidth == null) && ((ref = props.content) === null || ref === void 0 ? void 0 : ref.albumIsPageAlbum) === false && !((ref1 = props.content) === null || ref1 === void 0 ? void 0 : ref1.is_chain);
    (0,react.useEffect)(function() {
        if (window !== undefined && document !== undefined) {
            setReferer(window.location.origin + localeBase + "/");
            if (!property && props.app.bookingSearchbarWidth != null && headerDiv && props.builder.builder_header_type != "double") {
                var headerTop = headerDiv.getBoundingClientRect().top;
                var updateStuck = function() {
                    return setIsStuck(window.scrollY > headerTop);
                };
                updateStuck();
                window.addEventListener("scroll", updateStuck);
                window.addEventListener("load", updateStuck);
                return function() {
                    window.removeEventListener("scroll", updateStuck);
                    window.removeEventListener("load", updateStuck);
                };
            }
        }
    }, [
        headerDiv,
        property,
        props.builder.builder_header_type,
        referer,
        localeBase
    ]);
    var router = (0,next_router.useRouter)();
    var propertiesParams = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"];
    });
    // Header "Book" (partial or the Book menu item, see HeaderMenu) goes where the search bar goes by default:
    // the booking engine url if one is set, otherwise the properties search page
    (0,react.useEffect)(function() {
        var bookClickHandler = function(event) {
            var ref;
            var target = event.target;
            if (target == null || target.closest == null || target.closest(".header-book-partial a, a.header-book-link") == null) {
                return;
            }
            event.preventDefault();
            if (!Checkers/* default.valueToBoolean */.Z.valueToBoolean((ref = props.app_data) === null || ref === void 0 ? void 0 : ref.is_manager)) {
                var ref1, ref2, ref3;
                var redirected = (0,BookingHelper/* redirectToWebHotelier */.IW)((ref1 = props.content) === null || ref1 === void 0 ? void 0 : ref1.propertyBookingTypeValue, (ref2 = props.content) === null || ref2 === void 0 ? void 0 : ref2.webHotelierBookUrl, app.bookingTypeValue, (ref3 = props.content) === null || ref3 === void 0 ? void 0 : ref3.webHotelierRoomCodes, propertiesParams.checkin, propertiesParams.checkout, propertiesParams.adults, propertiesParams.kids, propertiesParams.infants, propertiesParams.bedrooms);
                if (redirected) {
                    return;
                }
            }
            router.push("/properties/search/?" + Checkers/* default.serialize */.Z.serialize((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, propertiesParams), {
                offset: 0
            })));
        };
        document.addEventListener("click", bookClickHandler, true);
        return function() {
            return document.removeEventListener("click", bookClickHandler, true);
        };
    }, [
        props.content,
        props.app_data,
        app.bookingTypeValue,
        propertiesParams
    ]);
    var menuIconAlt = (0,es/* useSelector */.v9)(function(state) {
        return Checkers/* default.valueToBoolean */.Z.valueToBoolean((0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_menu_alt_icon"));
    });
    var navbarModeClass = "";
    var navbarTwoModeClass = "";
    var resizeClass = "";
    var faGripLines = null;
    faGripLines = menuIconAlt ? faBars/* faBars */.xi : pro_solid_svg_icons/* faGripLines */.hx$;
    if (app.designMode == true) {
        navbarModeClass = "Header-Dark";
    } else {
        navbarModeClass = "Header-Light";
    }
    // console.log("props.builder.builder_header_type", props.builder.builder_header_type)
    if (props.builder.builder_header_type != "default") {
        if (props.builder.builder_header_mode == "transparent") {
            if (isHomepagePropertyPhotoGrid) {
                navbarModeClass = "Header-Dark";
            } else if (Checkers/* default.valueToBoolean */.Z.valueToBoolean(props.builder.builder_header_first_state_mode)) {
                navbarModeClass = "Header-Dark";
            } else {
                navbarModeClass = "Header-Light";
            }
            if (isHomepagePropertyPhotoGrid || Checkers/* default.valueToBoolean */.Z.valueToBoolean(props.builder.builder_header_second_state_mode)) {
                resizeClass += "Header-Dark border-bottom ";
            } else {
                resizeClass += "Header-Light border-bottom ";
            }
            if (Checkers/* default.isValidString */.Z.isValidString(props.builder.builder_header_color)) {
                resizeClass += " Header-Custom-Color ";
            }
        } else {
            if (Checkers/* default.valueToBoolean */.Z.valueToBoolean(props.builder.builder_header_first_state_mode)) {
                navbarModeClass = "Header-Dark";
            } else {
                navbarModeClass = "Header-Light";
            }
            if (Checkers/* default.isValidString */.Z.isValidString(props.builder.builder_header_color)) {
                navbarModeClass += " Header-Custom-Color ";
            }
        }
        if (props.builder.builder_header_type == "double") {
            if (Checkers/* default.valueToBoolean */.Z.valueToBoolean(props.builder.builder_header_one_mode)) {
                navbarModeClass = "Header-Dark";
            } else {
                navbarModeClass = "Header-Light";
            }
            if (Checkers/* default.valueToBoolean */.Z.valueToBoolean(props.builder.builder_header_two_mode)) {
                navbarTwoModeClass = "Header-Dark";
            } else {
                navbarTwoModeClass = "Header-Light";
            }
            if (Checkers/* default.valueToBoolean */.Z.valueToBoolean(props.builder.builder_header_logo_mode)) {}
        }
        if (!property && props.builder.builder_header_mode == "transparent" && isHomepagePropertyPhotoGrid) {
            if (Checkers/* default.isValidString */.Z.isValidString(resizeClass)) navbarModeClass = resizeClass;
            resizeClass = "";
        } else if (!property && props.builder.builder_header_mode == "transparent") {
            navbarModeClass += props.app.bookingSearchbarWidth != null ? "-Transparent fixed-top " : "-Transparent Header-Absolute ";
        } else {
            if (Checkers/* default.isValidString */.Z.isValidString(resizeClass)) navbarModeClass = resizeClass;
            resizeClass = "";
        }
        if (property) {
            navbarModeClass += " ";
        }
        if (!property && props.app.bookingSearchbarWidth != null && props.builder.builder_header_type != "double") {
            navbarModeClass += isStuck ? " Header-Sticky-Top " : " Header-Sticky-Top-Not ";
        }
    }
    switch(props.builder.builder_header_type){
        case "different":
        case "double":
        case "minimized":
        case "centered":
            if (!Checkers/* default.valueToBoolean */.Z.valueToBoolean(props.builder.builder_header_menu_bold)) {
                navbarModeClass += " no-bold ";
                faGripLines = menuIconAlt ? faBars/* faBars */.xi : pro_solid_svg_icons/* faGripLines */.hx$;
            }
            break;
    }
    var headerProps = {
        builder_header_type: props.builder.builder_header_type,
        builder_header_mode: props.builder.builder_header_mode,
        builder_header_menu_bold: props.builder.builder_header_menu_bold,
        builder_header_one_mode: props.builder.builder_header_one_mode,
        builder_header_first_state_mode: props.builder.builder_header_first_state_mode,
        builder_header_second_state_mode: props.builder.builder_header_second_state_mode,
        builder_header_color: props.builder.builder_header_color,
        builder_header_logo_mode: props.builder.builder_header_logo_mode,
        builder_header_menu_color: props.builder.builder_header_menu_color,
        builder_header_two_mode: props.builder.builder_header_two_mode
    };
    var logoProps = {
        logoLightOriginHeight: app.logoLightOriginHeight,
        logoLightOriginWidth: app.logoLightOriginWidth,
        logoDarkOriginHeight: app.logoDarkOriginHeight,
        logoDarkOriginWidth: app.logoDarkOriginWidth,
        logoLightHeigth: app.logoLightHeigth,
        logoLightHeigthAlt: app.logoLightHeigthAlt,
        logoDarkHeigth: app.logoDarkHeigth,
        logoDarkHeigthAlt: app.logoDarkHeigthAlt,
        logoLight: app.logoLight,
        logoDark: app.logoDark,
        logoMode: Checkers/* default.isValidString */.Z.isValidString(props.builder.builder_header_type) && props.builder.builder_header_type != "default" ? Checkers/* default.valueToBoolean */.Z.valueToBoolean(props.builder.builder_header_logo_mode) : navbarModeClass.match("Header-Dark")
    };
    var stateForModal = props.builder.builder_header_type == "default" ? Checkers/* default.valueToBoolean */.Z.valueToBoolean(app.designMode) : props.builder.builder_header_type == "double" ? Checkers/* default.valueToBoolean */.Z.valueToBoolean(props.builder.builder_header_one_mode) : props.builder.builder_header_mode == "transparent" ? Checkers/* default.valueToBoolean */.Z.valueToBoolean(props.builder.builder_header_second_state_mode) : Checkers/* default.valueToBoolean */.Z.valueToBoolean(props.builder.builder_header_first_state_mode);
    var personalColorForModal = props.builder.builder_header_type == "default" && Checkers/* default.isValidString */.Z.isValidString(app.designColor) ? app.designColor : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            Checkers/* default.isValidString */.Z.isValidString(props.builder.builder_header_color) && (0,jsx_runtime.jsx)((style_default()), {
                id: "7c5fa69cd2904e08",
                dynamic: [
                    props.builder.builder_header_color
                ],
                children: ".Header-Custom-Color{background-color:".concat(props.builder.builder_header_color, "!important}")
            }),
            (0,jsx_runtime.jsx)((style_default()), {
                id: "67c518e46be0fc22",
                dynamic: [
                    props.builder.builder_header_type == "default" ? 400 : Checkers/* default.valueToBoolean */.Z.valueToBoolean(props.builder.builder_header_menu_bold) ? 600 : 400,
                    Checkers/* default.isValidString */.Z.isValidString(props.builder.builder_header_menu_color) ? "color: " + props.builder.builder_header_menu_color + "!important" : "",
                    Checkers/* default.valueToBoolean */.Z.valueToBoolean(props.builder.builder_header_menu_bold) ? 600 : 400,
                    props.builder.builder_header_type == "default" ? 600 : Checkers/* default.valueToBoolean */.Z.valueToBoolean(props.builder.builder_header_menu_bold) ? 600 : 400,
                    Checkers/* default.isValidString */.Z.isValidString(props.builder.builder_header_menu_color) ? "background-color: transparent" : "",
                    Checkers/* default.isValidString */.Z.isValidString(props.builder.builder_header_menu_color) ? "color: " + props.builder.builder_header_menu_color + "!important" : "",
                    Checkers/* default.isValidString */.Z.isValidString(props.builder.builder_header_menu_color) ? "border-color: " + props.builder.builder_header_menu_color + "!important" : ""
                ],
                children: ".Header.Header-Dark svg,.Header.Header-Light svg,.Header.Header-Dark .navbar-nav .nav-link,.Header.Header-Light .navbar-nav .nav-link,.Header.minimized.Header-Dark .navbar-nav .nav-link,.Header.minimized.Header-Light .navbar-nav .nav-link,.Header.minimized.Header-Light .navbar-nav .nav-link svg{font-weight:".concat(props.builder.builder_header_type == "default" ? 400 : Checkers/* default.valueToBoolean */.Z.valueToBoolean(props.builder.builder_header_menu_bold) ? 600 : 400, "!important;").concat(Checkers/* default.isValidString */.Z.isValidString(props.builder.builder_header_menu_color) ? "color: " + props.builder.builder_header_menu_color + "!important" : "", ";}.Header .dropdown-menu>li>a{font-weight:").concat(Checkers/* default.valueToBoolean */.Z.valueToBoolean(props.builder.builder_header_menu_bold) ? 600 : 400, "!important}.Header.Header-Dark .btn,.Header.Header-Light .btn,.Header.Header-Dark .btn:hover:not(.active),.Header.Header-Light .btn:hover:not(.active),.Header.minimized.Header-Dark .btn,.Header.minimized.Header-Light .btn,.Header.minimized.Header-Dark .btn:hover:not(.active),.Header.minimized.Header-Light .btn:hover:not(.active){font-weight:").concat(props.builder.builder_header_type == "default" ? 600 : Checkers/* default.valueToBoolean */.Z.valueToBoolean(props.builder.builder_header_menu_bold) ? 600 : 400, "!important;").concat(Checkers/* default.isValidString */.Z.isValidString(props.builder.builder_header_menu_color) ? "background-color: transparent" : "", ";").concat(Checkers/* default.isValidString */.Z.isValidString(props.builder.builder_header_menu_color) ? "color: " + props.builder.builder_header_menu_color + "!important" : "", ";").concat(Checkers/* default.isValidString */.Z.isValidString(props.builder.builder_header_menu_color) ? "border-color: " + props.builder.builder_header_menu_color + "!important" : "", ";}.Header.Header-Double.Header-Dark svg,.Header.Header-Double.Header-Dark .navbar-nav .nav-link{color:rgb(255,255,255)!important}.Header.Header-Double.Header-Light svg,.Header.Header-Double.Header-Light .navbar-nav .nav-link{color:rgb(0,0,0)!important}.Header.Header-Double.Header-Dark .btn,.Header.Header-Double.Header-Dark .btn:hover:not(.active){color:rgb(255,255,255)!important;border-color:rgb(255,255,255)!important}.Header.Header-Double.Header-Light .btn,.Header.Header-Double.Header-Light .btn:hover:not(.active){color:rgb(0,0,0)!important;border-color:rgb(0,0,0)!important}")
            }),
            (0,jsx_runtime.jsx)((style_default()), {
                id: "1d2e940f9cd0930c",
                dynamic: [
                    props.builder.builder_header_type == "default" ? 600 : Checkers/* default.valueToBoolean */.Z.valueToBoolean(props.builder.builder_header_menu_bold) ? 600 : 400,
                    Checkers/* default.isValidString */.Z.isValidString(props.builder.builder_header_color) ? props.builder.builder_header_color : personalColorForModal ? personalColorForModal : stateForModal ? "rgba(0,0,0)" : "rgba(255,255,255)",
                    Checkers/* default.isValidString */.Z.isValidString(props.builder.builder_header_color) ? props.builder.builder_header_color : personalColorForModal ? personalColorForModal : stateForModal ? "rgba(0,0,0)" : "rgba(255,255,255)",
                    props.builder.builder_header_type == "default" ? 600 : Checkers/* default.valueToBoolean */.Z.valueToBoolean(props.builder.builder_header_menu_bold) ? 600 : 400,
                    Checkers/* default.isValidString */.Z.isValidString(props.builder.builder_header_menu_color) || !!stateForModal ? "background-color: transparent" : "",
                    Checkers/* default.isValidString */.Z.isValidString(props.builder.builder_header_menu_color) ? props.builder.builder_header_menu_color : stateForModal ? "rgba(255,255,255)" : "rgba(0,0,0)",
                    Checkers/* default.isValidString */.Z.isValidString(props.builder.builder_header_menu_color) ? props.builder.builder_header_menu_color : stateForModal ? "rgba(255,255,255)" : "rgba(0,0,0)",
                    stateForModal ? "rgba(0,0,0)" : "rgba(255,255,255)",
                    stateForModal ? "rgba(0,0,0)" : "rgba(255,255,255)",
                    props.builder.builder_header_type == "default" ? 600 : Checkers/* default.valueToBoolean */.Z.valueToBoolean(props.builder.builder_header_menu_bold) ? 600 : 400,
                    Checkers/* default.isValidString */.Z.isValidString(props.builder.builder_header_menu_color) ? props.builder.builder_header_menu_color : stateForModal ? "rgba(255,255,255)" : "rgba(0,0,0)",
                    stateForModal ? "rgba(255,255,255)" : "rgba(0,0,0)"
                ],
                children: ".Modal-Header .modal-dialog .modal-content,.Modal-Header .modal-dialog .modal-content .Modal__body,.Modal-Header .modal-dialog .modal-content .Modal__body ul li ul.dropdown-menu{font-weight:".concat(props.builder.builder_header_type == "default" ? 600 : Checkers/* default.valueToBoolean */.Z.valueToBoolean(props.builder.builder_header_menu_bold) ? 600 : 400, "!important;background:").concat(Checkers/* default.isValidString */.Z.isValidString(props.builder.builder_header_color) ? props.builder.builder_header_color : personalColorForModal ? personalColorForModal : stateForModal ? "rgba(0,0,0)" : "rgba(255,255,255)", "!important;background-color:").concat(Checkers/* default.isValidString */.Z.isValidString(props.builder.builder_header_color) ? props.builder.builder_header_color : personalColorForModal ? personalColorForModal : stateForModal ? "rgba(0,0,0)" : "rgba(255,255,255)", "!important}.Modal-Header .modal-dialog .modal-content .Modal__body .btn,.Modal-Header .modal-dialog .modal-content .Modal__body .btn:hover:not(.active){font-weight:").concat(props.builder.builder_header_type == "default" ? 600 : Checkers/* default.valueToBoolean */.Z.valueToBoolean(props.builder.builder_header_menu_bold) ? 600 : 400, "!important;").concat(Checkers/* default.isValidString */.Z.isValidString(props.builder.builder_header_menu_color) || !!stateForModal ? "background-color: transparent" : "", ";color:").concat(Checkers/* default.isValidString */.Z.isValidString(props.builder.builder_header_menu_color) ? props.builder.builder_header_menu_color : stateForModal ? "rgba(255,255,255)" : "rgba(0,0,0)", "!important;border-color:").concat(Checkers/* default.isValidString */.Z.isValidString(props.builder.builder_header_menu_color) ? props.builder.builder_header_menu_color : stateForModal ? "rgba(255,255,255)" : "rgba(0,0,0)", "!important}.Modal-Header-Double .modal-dialog .modal-content,.Modal-Header-Double .modal-dialog .modal-content .Modal__body,.Modal-Header-Double .modal-dialog .modal-content .Modal__body ul li ul.dropdown-menu{background:").concat(stateForModal ? "rgba(0,0,0)" : "rgba(255,255,255)", "!important;background-color:").concat(stateForModal ? "rgba(0,0,0)" : "rgba(255,255,255)", "!important}.Modal-Header .modal-dialog .modal-content .Modal__header a,.Modal-Header .modal-dialog .modal-content .Modal__header button,.Modal-Header .modal-dialog .modal-content .Modal__header button svg,.Modal-Header .modal-dialog .modal-content .Modal__body ul li a,.Modal-Header .modal-dialog .modal-content .Modal__body ul li a.nav-link,.Modal-Header .modal-dialog .modal-content .Modal__body ul li svg,.Modal-Header .modal-dialog .modal-content .Modal__body ul li a svg{font-weight:").concat(props.builder.builder_header_type == "default" ? 600 : Checkers/* default.valueToBoolean */.Z.valueToBoolean(props.builder.builder_header_menu_bold) ? 600 : 400, "!important;color:").concat(Checkers/* default.isValidString */.Z.isValidString(props.builder.builder_header_menu_color) ? props.builder.builder_header_menu_color : stateForModal ? "rgba(255,255,255)" : "rgba(0,0,0)", "!important}.Modal-Header-Double .modal-dialog .modal-content .Modal__header a,.Modal-Header-Double .modal-dialog .modal-content .Modal__header button,.Modal-Header-Double .modal-dialog .modal-content .Modal__header button svg,.Modal-Header-Double .modal-dialog .modal-content .Modal__body ul li a,.Modal-Header-Double .modal-dialog .modal-content .Modal__body ul li a.nav-link,.Modal-Header-Double .modal-dialog .modal-content .Modal__body ul li svg,.Modal-Header-Double .modal-dialog .modal-content .Modal__body ul li a svg{color:").concat(stateForModal ? "rgba(255,255,255)" : "rgba(0,0,0)", "!important}.Modal-Header .modal-dialog .modal-content .Modal__body .Contact-Icons ul.Contact-Icons__dropdown{-webkit-box-shadow:0 0 3px#ccc!important;-moz-box-shadow:0 0 3px#ccc!important;box-shadow:0 0 3px#ccc!important}")
            }),
            props.property && /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                children: "\n          .Header.Header-Double,\n          .Header.Header-Sticky-Top{\n            position: initial !important;\n          }\n        "
            }),
            props.builder.builder_header_type == "different" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderTypeOne, {
                app: app,
                containerClass: containerClass,
                falTimes: pro_light_svg_icons/* faTimes */.NBC,
                faGripLines: faGripLines,
                designMode: app.designMode,
                headerProps: headerProps,
                logoProps: logoProps,
                navbarModeClass: navbarModeClass,
                resizeClass: resizeClass,
                menu: menu,
                partials: partials,
                showBookButtonMenu: app.showBookButtonMenu,
                contactIcons: contactIcons(),
                referer: referer,
                zIndex: Checkers/* default.objChildExists */.Z.objChildExists(props, "zIndex") ? props.zIndex : 0,
                pageTitle: pageTitle,
                headerDiv: headerDiv,
                setHeaderDiv: setHeaderDiv
            }) : props.builder.builder_header_type == "double" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderTypeTwo, {
                app: app,
                containerClass: containerClass,
                falTimes: pro_light_svg_icons/* faTimes */.NBC,
                faGripLines: faGripLines,
                designMode: props.designMode,
                headerProps: app,
                logoProps: logoProps,
                navbarModeClass: navbarModeClass,
                navbarTwoModeClass: navbarTwoModeClass,
                resizeClass: resizeClass,
                menu: menu,
                partials: partials,
                showBookButtonMenu: app.showBookButtonMenu,
                contactIcons: contactIcons(),
                phone: phone,
                property: property,
                referer: referer,
                zIndex: Checkers/* default.objChildExists */.Z.objChildExists(props, "zIndex") ? props.zIndex : 0,
                pageTitle: pageTitle
            }) : props.builder.builder_header_type == "minimized" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderTypeThree, {
                app: app,
                containerClass: containerClass,
                falTimes: pro_light_svg_icons/* faTimes */.NBC,
                faGripLines: faGripLines,
                designMode: app.designMode,
                headerProps: headerProps,
                logoProps: logoProps,
                navbarModeClass: navbarModeClass,
                resizeClass: resizeClass,
                menu: menu,
                partials: partials,
                showBookButtonMenu: app.showBookButtonMenu,
                contactIcons: contactIcons(),
                referer: referer,
                zIndex: Checkers/* default.objChildExists */.Z.objChildExists(props, "zIndex") ? props.zIndex : 0,
                pageTitle: pageTitle,
                setHeaderDiv: setHeaderDiv
            }) : props.builder.builder_header_type == "centered" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderTypeFour, {
                app: app,
                containerClass: containerClass,
                falTimes: pro_light_svg_icons/* faTimes */.NBC,
                faGripLines: faGripLines,
                designMode: app.designMode,
                headerProps: headerProps,
                logoProps: logoProps,
                navbarModeClass: navbarModeClass,
                resizeClass: resizeClass,
                menu: menu,
                partials: partials,
                showBookButtonMenu: app.showBookButtonMenu,
                contactIcons: contactIcons(),
                referer: referer,
                zIndex: Checkers/* default.objChildExists */.Z.objChildExists(props, "zIndex") ? props.zIndex : 0,
                pageTitle: pageTitle,
                setHeaderDiv: setHeaderDiv
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderDefault, {
                app: app,
                containerClass: containerClass,
                falTimes: pro_light_svg_icons/* faTimes */.NBC,
                faGripLines: faGripLines,
                designMode: app.designMode,
                headerProps: headerProps,
                logoProps: logoProps,
                navbarModeClass: navbarModeClass,
                resizeClass: resizeClass,
                menu: menu,
                partials: partials,
                showBookButtonMenu: app.showBookButtonMenu,
                contactIcons: contactIcons(),
                referer: referer,
                zIndex: Checkers/* default.objChildExists */.Z.objChildExists(props, "zIndex") ? props.zIndex : 0,
                pageTitle: pageTitle,
                setHeaderDiv: setHeaderDiv
            })
        ]
    });
}


/***/ }),

/***/ 39806:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ViewPort; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89736);


function ViewPort(props) {
    var myRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)((props === null || props === void 0 ? void 0 : props.viewPort) ? props.viewPort : false), inViewPort = ref[0], setInViewPort = ref[1];
    // CHECK IF WHOLE ELEMENT IS IN VIEWPORT
    // const inWholeViewPortUpdate = useCallback( ( myRef, windowWidth, windowHeight ) => {
    //   let refDiv;
    //   if ( myRef.current ) {
    //     refDiv = myRef.current.getBoundingClientRect();
    //     if ( refDiv.top >= 0 && refDiv.left >= 0 && refDiv.right <= windowWidth && refDiv.bottom <= ( windowHeight - refDiv.bottom ) ) {
    //       setInViewPort( true );
    //     } else {
    //       setInViewPort( false );
    //     }
    //   }
    // }, []);
    // CHECK IF ANY PART OF THE ELEMENT IS IN VIEWPORT
    var inAnyViewPortUpdate = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(myRef, windowWidth, windowHeight, windowPageXOffset, windowPageYOffset) {
        var refDiv;
        if (myRef.current) {
            refDiv = myRef.current;
            var top = refDiv.offsetTop;
            var left = refDiv.offsetLeft;
            var width = refDiv.offsetWidth;
            var height = refDiv.offsetHeight;
            while(refDiv.offsetParent){
                refDiv = refDiv.offsetParent;
                top += refDiv.offsetTop;
                left += refDiv.offsetLeft;
            }
            if (top < windowPageYOffset + windowHeight && left < windowPageXOffset + windowWidth && top + height > windowPageYOffset && left + width > windowPageXOffset) {
                setInViewPort(true);
            } else {
                setTimeout(function() {
                    setInViewPort(true);
                }, 200);
            }
        }
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (document !== undefined && window !== undefined) {
            inAnyViewPortUpdate(myRef, window.innerWidth, window.innerHeight, window.pageXOffset, window.pageYOffset);
            window.addEventListener("scroll", function() {
                inAnyViewPortUpdate(myRef, this.innerWidth, this.innerHeight, this.pageXOffset, this.pageYOffset);
            });
        }
    }, [
        inAnyViewPortUpdate
    ]);
    if (!inViewPort) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            id: props.id ? props.id : "",
            ref: myRef,
            className: props === null || props === void 0 ? void 0 : props.parentClassName,
            children: props === null || props === void 0 ? void 0 : props.skeletonItem
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: props.children
    });
}


/***/ }),

/***/ 41306:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ HeaderLogo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53429);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83974);



function HeaderLogo(props) {
    var height = 0;
    var factor = 1;
    var logoProps = props.logoProps;
    if (logoProps.logoMode) {
        factor = logoProps.logoDarkOriginWidth / logoProps.logoDarkOriginHeight;
        if (logoProps.logoDarkHeigth != null && logoProps.logoDarkHeigth > 0) {
            height = logoProps.logoDarkHeigth;
        } else {
            height = 30;
        }
    } else {
        factor = logoProps.logoLightOriginWidth / logoProps.logoLightOriginHeight;
        if (logoProps.logoLightHeigth != null && logoProps.logoLightHeigth > 0) {
            height = logoProps.logoLightHeigth;
        } else {
            height = 30;
        }
    }
    var logoUrl = logoProps.logoMode ? logoProps.logoDark : logoProps.logoLight;
    var widthInit = height * factor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_2__/* ["default"].isValidString */ .Z.isValidString(logoUrl) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
            loading: "eager",
            layout: "intrinsic",
            width: widthInit,
            height: height,
            className: "logo",
            src: logoUrl,
            alt: "logo_header",
            blurDataURL: "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
            className: logoProps.logoMode ? "text-white" : "text-black",
            children: props.pageTitle
        })
    });
}


/***/ }),

/***/ 27515:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ HeaderLogoAltMode; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83974);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31969);



function HeaderLogoAltMode(props) {
    var logo_height = 30;
    var logo_alt_height = 30;
    var logo_factor = 1;
    var logo_alt_factor = 1;
    var logoProps = props.logoProps;
    if (props.navbarModeClass.match("Header-Dark-Transparent")) {
        logo_factor = logoProps.logoDarkOriginWidth / logoProps.logoDarkOriginHeight;
        if (logoProps.logoDarkHeigth != null && logoProps.logoDarkHeigth > 0) {
            logo_height = logoProps.logoDarkHeigth;
        }
    } else {
        logo_factor = logoProps.logoLightOriginWidth / logoProps.logoLightOriginHeight;
        if (logoProps.logoLightHeigth != null && logoProps.logoLightHeigth > 0) {
            logo_height = logoProps.logoLightHeigth;
        }
    }
    if (logoProps.logoMode) {
        logo_alt_factor = logoProps.logoDarkOriginWidth / logoProps.logoDarkOriginHeight;
        if (logoProps.logoDarkHeigthAlt != null && logoProps.logoDarkHeigthAlt > 0) logo_alt_height = logoProps.logoDarkHeigthAlt;
    } else {
        logo_alt_factor = logoProps.logoLightOriginWidth / logoProps.logoLightOriginHeight;
        if (logoProps.logoLightHeigthAlt != null && logoProps.logoLightHeigthAlt > 0) logo_alt_height = logoProps.logoLightHeigthAlt;
    }
    var logo_widthInit = logo_height * logo_factor;
    var logo_alt_widthInit = logo_alt_height * logo_alt_factor;
    var logoUrl = function() {
        if (props.app.builder.builder_header_logo_mode_sticky == "0") {
            return logoProps.logoLight;
        }
        if (props.app.builder.builder_header_logo_mode_sticky == "1") {
            return logoProps.logoDark;
        }
        return props.navbarModeClass.match("Header-Dark-Transparent") ? logoProps.logoDark : logoProps.logoLight;
    };
    var logoAltUrl = logoProps.logoMode ? logoProps.logoDark : logoProps.logoLight;
    var isHomePage = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state["appSettings"]["isHomepage"];
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            isHomePage == 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_1__/* ["default"].isValidString */ .Z.isValidString(logoUrl()) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        width: logo_widthInit,
                        height: logo_height,
                        src: logoUrl(),
                        alt: "logo_alt_header",
                        className: "logo_header logo",
                        loading: "lazy"
                    })
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}),
            _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_1__/* ["default"].isValidString */ .Z.isValidString(logoAltUrl) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                width: logo_alt_widthInit,
                height: logo_alt_height,
                src: logoAltUrl,
                alt: "logo_alt_header",
                className: "logo_header  " + (isHomePage ? "alt logo" : "logo"),
                loading: "lazy"
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}),
            !_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_1__/* ["default"].isValidString */ .Z.isValidString(logoAltUrl) && !_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_1__/* ["default"].isValidString */ .Z.isValidString(logoUrl()) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: logoProps.logoMode ? "text-white" : "text-black",
                    children: props.pageTitle
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
        ]
    });
}


/***/ }),

/***/ 44818:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ HeaderNavigation; }
});

// EXTERNAL MODULE: ../../shared/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(14140);
// EXTERNAL MODULE: ../../shared/node_modules/@fortawesome/fontawesome-svg-core/index.mjs
var fontawesome_svg_core = __webpack_require__(95623);
// EXTERNAL MODULE: ../../shared/node_modules/@fortawesome/fontawesome-svg-core/styles.css
var styles = __webpack_require__(54197);
// EXTERNAL MODULE: ../../shared/node_modules/react/index.js
var react = __webpack_require__(89736);
// EXTERNAL MODULE: ../../shared/node_modules/@fortawesome/pro-solid-svg-icons/index.mjs
var pro_solid_svg_icons = __webpack_require__(72976);
// EXTERNAL MODULE: ../../shared/node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(96350);
// EXTERNAL MODULE: ./helpers/class/Checkers.ts
var Checkers = __webpack_require__(83974);
// EXTERNAL MODULE: ./components/header/partials/ContactIcons.tsx + 2 modules
var ContactIcons = __webpack_require__(38530);
// EXTERNAL MODULE: ./components/header/partials/DropdownArrow.tsx
var DropdownArrow = __webpack_require__(75203);
// EXTERNAL MODULE: ../../shared/node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(31969);
// EXTERNAL MODULE: ./helpers/MethodHelper.ts
var MethodHelper = __webpack_require__(23158);
// EXTERNAL MODULE: ../../shared/node_modules/next/link.js
var next_link = __webpack_require__(75547);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/header/partials/LanguageSwitcher.tsx
var LanguageSwitcher = __webpack_require__(94795);
;// CONCATENATED MODULE: ./components/header/menu/HeaderMenu.tsx



fontawesome_svg_core/* config.autoAddCss */.vc.autoAddCss = false;










function HeaderMenu(props) {
    var menuItemDisableWrap = props.hasOwnProperty("menuItemDisableWrap") ? props.menuItemDisableWrap : false;
    var handleHide = props.hasOwnProperty("handleHide") ? props.handleHide : false;
    var textWrapClass = menuItemDisableWrap ? "" : "text-nowrap";
    var showMenuItems = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_header_show_menu_items");
    });
    var ref = (0,react.useState)(null), expandedKey = ref[0], setExpandedKey = ref[1];
    var elRefs = (0,react.useRef)([]);
    (0,react.useEffect)(function() {
        if (document !== undefined && elRefs !== undefined) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = elRefs.current[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var elRef = _step.value;
                    elRef !== undefined && elRef.addEventListener("mouseenter", function() {
                        this.children[0].classList.add("show");
                        this.children[0].setAttribute("aria-extended", "true");
                        this.children[1].classList.add("show");
                    });
                    elRef !== undefined && elRef.addEventListener("mouseleave", function() {
                        this.children[0].classList.remove("show");
                        this.children[0].setAttribute("aria-extended", "false");
                        this.children[1].classList.remove("show");
                    });
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }, [
        elRefs
    ]);
    var topLevelHref = function(menu, loggiaUrl) {
        if (menu.hasOwnProperty("redirectUrl")) {
            return menu.redirectUrl;
        }
        // A category that is shown on the home page (its url slug is an anchor) links to its section, like on the Lodge
        // site (/#category121), instead of opening the category page.
        if (typeof menu.urlSlug === "string" && menu.urlSlug.startsWith("#") && typeof loggiaUrl === "string" && loggiaUrl.startsWith("category/")) {
            var anchor = menu.urlSlug.length > 1 ? menu.urlSlug : "#category" + loggiaUrl.split("/")[1];
            return props.referer + anchor;
        }
        return loggiaUrl != null ? props.referer + loggiaUrl : menu.urlSlug != null ? props.referer + menu.urlSlug : "#";
    };
    var topLevelHrefBlank = function(menu, loggiaUrl) {
        if (menu.hasOwnProperty("redirectUrl")) {
            return true;
        }
        return false;
    };
    var handleMenuLinkClick = function(href) {
        return function(e) {
            if (!Checkers/* default.isValidString */.Z.isValidString(href)) {
                if (handleHide != undefined) handleHide();
                return;
            }
            var hashIndex = href.indexOf("#");
            if (hashIndex === -1) {
                if (handleHide != undefined) handleHide();
                return;
            }
            var hash = href.slice(hashIndex + 1);
            if (hash.length === 0) {
                if (handleHide != undefined) handleHide();
                return;
            }
            var path = href.slice(0, hashIndex);
            var stripTrailingSlash = function(u) {
                return u.replace(/\/+$/, "");
            };
            var isSamePage =  true && (path === "" || stripTrailingSlash(path) === stripTrailingSlash(window.location.pathname) || stripTrailingSlash(path) === stripTrailingSlash(window.location.origin + window.location.pathname));
            if (!isSamePage) {
                if (handleHide != undefined) handleHide();
                return;
            }
            e.preventDefault();
            if (handleHide != undefined) {
                handleHide();
                var attempts = 0;
                var tryScroll = function() {
                    if (document.body.style.overflow === "hidden" && attempts < 40) {
                        attempts += 1;
                        requestAnimationFrame(tryScroll);
                        return;
                    }
                    (0,MethodHelper/* scrollToAnchor */.dP)(hash, "auto");
                };
                requestAnimationFrame(tryScroll);
            } else {
                (0,MethodHelper/* scrollToAnchor */.dP)(hash);
            }
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            showMenuItems == "1" && Checkers/* default.isValidArray */.Z.isValidArray(props.menu) && props.menu.map(function(menu, key) {
                var loggiaUrl = menu.loggiaUrl;
                if (Checkers/* default.isValidString */.Z.isValidString(loggiaUrl) && loggiaUrl.startsWith("/")) {
                    loggiaUrl = loggiaUrl.substring(1);
                }
                var special_class = "";
                if (menu.special_class != undefined && menu.special_class.length > 0) {
                    special_class = menu.special_class;
                }
                // The "Book" menu item follows the search bar destination (click handler in Header). Its title is
                // translated (Book / Κράτηση / Buchen...), so it is recognised by what it is instead: a menu item
                // styled as a button that links to the properties list or to a booking engine. "Properties" also
                // links to /properties/all but is not a button. An English "Book..." title still counts.
                var menuLinks = [
                    menu.urlSlug,
                    menu.loggiaUrl,
                    menu.redirectUrl
                ].filter(function(link) {
                    return Checkers/* default.isValidString */.Z.isValidString(link);
                });
                var isBookItem = !Checkers/* default.isValidArray */.Z.isValidArray(menu.entries) && (Checkers/* default.isValidString */.Z.isValidString(menu.title) && /^\s*book/i.test(menu.title) || /(^|\s)btn(\s|$)/.test(special_class) && menuLinks.some(function(link) {
                    return /properties\/all|reserve-online\.net/.test(link);
                }));
                if (isBookItem) {
                    special_class += " header-book-link";
                }
                return menu.title != null ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                    ref: Checkers/* default.isValidArray */.Z.isValidArray(menu.entries) ? function(el) {
                        elRefs.current[key] = el;
                    } : undefined,
                    className: menu.entries != null ? "nav-item dropdown cursor-pointer" : "nav-item",
                    children: [
                        menu.hasOwnProperty("force_reload") && menu.force_reload ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                "aria-current": "page",
                                href: topLevelHref(menu, loggiaUrl),
                                className: special_class + " " + (menu.entries != null ? "d-flex nav-link dropdown-toggle " + textWrapClass : "nav-link test-111 " + textWrapClass),
                                children: [
                                    menu.title,
                                    Checkers/* default.isValidArray */.Z.isValidArray(menu.entries) && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: pro_solid_svg_icons/* faChevronDown */.ptq,
                                        className: "m-l-5 align-self-center",
                                        style: {
                                            fontSize: "10.5px"
                                        }
                                    })
                                ]
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: topLevelHrefBlank(menu, loggiaUrl) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    target: "_blank",
                                    href: topLevelHref(menu, loggiaUrl),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        className: special_class + " " + (menu.entries != null ? "d-flex nav-link dropdown-toggle " + textWrapClass : "nav-link test-222 " + textWrapClass),
                                        "aria-current": "page",
                                        onClick: handleMenuLinkClick(topLevelHref(menu, loggiaUrl)),
                                        rel: "noreferrer noopener",
                                        children: [
                                            menu.title,
                                            Checkers/* default.isValidArray */.Z.isValidArray(menu.entries) && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                icon: pro_solid_svg_icons/* faChevronDown */.ptq,
                                                className: "m-l-5 align-self-center",
                                                style: {
                                                    fontSize: "10.5px"
                                                }
                                            })
                                        ]
                                    })
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: topLevelHref(menu, loggiaUrl),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        "aria-current": "page",
                                        onClick: handleMenuLinkClick(topLevelHref(menu, loggiaUrl)),
                                        className: special_class + " " + (menu.entries != null ? "d-flex nav-link dropdown-toggle " + textWrapClass : "nav-link test-44444 " + textWrapClass),
                                        children: [
                                            menu.title,
                                            Checkers/* default.isValidArray */.Z.isValidArray(menu.entries) && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                icon: pro_solid_svg_icons/* faChevronDown */.ptq,
                                                className: "m-l-5 align-self-center",
                                                style: {
                                                    fontSize: "10.5px"
                                                },
                                                onClick: props.modalDropdownClass != null ? function(e) {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    setExpandedKey(expandedKey === key ? null : key);
                                                } : undefined
                                            })
                                        ]
                                    })
                                })
                            })
                        }),
                        Checkers/* default.isValidArray */.Z.isValidArray(menu.entries) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            className: (props.modalDropdownClass != null ? "dropdown-menu dropdown-article-menu " + props.modalDropdownClass : "dropdown-menu dropdown-article-menu shadow " + (menu.entries.length > 10 ? "megamenu" : "")) + (expandedKey === key ? " show" : ""),
                            children: [
                                props.modalDropdownClass == null && /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownArrow/* default */.Z, {}),
                                menu.entries.map(function(entry, key) {
                                    var loggiaUrl = entry.loggiaUrl;
                                    if (Checkers/* default.isValidString */.Z.isValidString(loggiaUrl) && loggiaUrl.startsWith("/")) {
                                        loggiaUrl = loggiaUrl.substring(1);
                                    }
                                    var entryHref = Checkers/* default.isValidString */.Z.isValidString(entry.redirectUrl) ? entry.redirectUrl : loggiaUrl != null ? props.referer + loggiaUrl : entry.urlSlug != null ? props.referer + entry.urlSlug : "#";
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: key == 0 ? "dropdown-ul-item mt-20px" : "dropdown-ul-item mt-3",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: entryHref,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "dropdown-item text-wrap ",
                                                onClick: handleMenuLinkClick(entryHref),
                                                children: entry.title
                                            })
                                        })
                                    }, key);
                                })
                            ]
                        })
                    ]
                }, key) : "";
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactIcons["default"], {
                contactIcons: props.contactIcons
            }),
            props.partials !== null && props.partials.hasOwnProperty("book") === true ? props.partials.book != null && props.headerPartialBook == true ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: "nav-item header-book-partial",
                dangerouslySetInnerHTML: {
                    __html: props.partials.book.title
                }
            }) : "" : "",
            // header types with a slot next to the search icon render the languages there (hideLanguages),
            // so they stay outside the burger menu
            !props.hideLanguages && /*#__PURE__*/ (0,jsx_runtime.jsx)(LanguageSwitcher/* default */.Z, {
                partials: props.partials,
                modalDropdownClass: props.modalDropdownClass,
                handleHide: handleHide
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/header/menu/HeaderPartials.tsx

function HeaderPartials(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: props.partials !== null && props.partials.hasOwnProperty("book") === true ? // eslint-disable-next-line react/jsx-key
        props.partials.book != undefined ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
            className: "nav-item header-book-partial",
            dangerouslySetInnerHTML: {
                __html: props.partials.book.title
            }
        }) : "" : ""
    });
}

;// CONCATENATED MODULE: ./components/header/menu/HeaderNavigation.tsx



function HeaderNavigation(props) {
    var menuItemDisableWrap = props.hasOwnProperty("menuItemDisableWrap") ? props.menuItemDisableWrap : false;
    var handleHide = props.hasOwnProperty("handleHide") ? props.handleHide : undefined;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: props.modalPartials == true || props.headerPartials == true ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderPartials, {
            partials: props.partials
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMenu, {
            referer: props.referer,
            menu: props.menu,
            partials: props.partials,
            headerPartialBook: props.headerPartialBook,
            modalDropdownClass: props.modalDropdownClass,
            contactIcons: props.hasOwnProperty("contactIcons") ? props.contactIcons : null,
            menuItemDisableWrap: menuItemDisableWrap,
            handleHide: handleHide,
            hideLanguages: props.hideLanguages
        })
    });
}


/***/ }),

/***/ 38530:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ContactIcons; }
});

// EXTERNAL MODULE: ../../shared/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(14140);
// EXTERNAL MODULE: ../../shared/node_modules/react/index.js
var react = __webpack_require__(89736);
// EXTERNAL MODULE: ./helpers/i18n.ts + 7 modules
var i18n = __webpack_require__(95925);
// EXTERNAL MODULE: ../../shared/node_modules/@fortawesome/pro-light-svg-icons/index.mjs
var pro_light_svg_icons = __webpack_require__(76191);
// EXTERNAL MODULE: ../../shared/node_modules/@fortawesome/pro-solid-svg-icons/index.mjs
var pro_solid_svg_icons = __webpack_require__(72976);
// EXTERNAL MODULE: ../../shared/node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(96350);
;// CONCATENATED MODULE: ./components/header/partials/ContactPhones.tsx

function ContactPhones(props) {
    return props.phoneIconData.split(",").map(function(phone, key) {
        return(// eslint-disable-next-line react/jsx-key
        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
            className: key == 0 ? "dropdown-ul-item mt-20px" : "dropdown-ul-item mt-3",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: "dropdown-item text-wrap",
                href: phone.split(":").length > 1 ? "tel:" + phone.split(":")[1].replace(/\s+/g, "") : "tel:" + phone.replace(/\s+/g, ""),
                children: phone.split(":").length > 1 ? phone.split(":")[0].replace(/\s+/g, "") : phone.replace(/\s+/g, "")
            })
        }, key));
    });
}

;// CONCATENATED MODULE: ./components/header/partials/ContactWhatsApp.tsx

function ContactWhatsApp(props) {
    return props.phoneIconData.split(",").map(function(phone, key) {
        return(// eslint-disable-next-line react/jsx-key
        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
            className: key == 0 ? "dropdown-ul-item mt-20px" : "dropdown-ul-item mt-3",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: "dropdown-item text-wrap",
                href: phone.split(":").length > 1 ? "https://wa.me/" + phone.split(":")[1].replace(/\s+/g, "").replace(/\+/g, "") : "https://wa.me/" + phone.replace(/\s+/g, "").replace(/\+/g, ""),
                children: phone.split(":").length > 1 ? phone.split(":")[0].replace(/\s+/g, "") : phone.replace(/\s+/g, "")
            })
        }, key));
    });
}

// EXTERNAL MODULE: ./components/header/partials/DropdownArrow.tsx
var DropdownArrow = __webpack_require__(75203);
// EXTERNAL MODULE: ../../shared/node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(31969);
// EXTERNAL MODULE: ./helpers/MethodHelper.ts
var MethodHelper = __webpack_require__(23158);
// EXTERNAL MODULE: ./helpers/class/Checkers.ts
var Checkers = __webpack_require__(83974);
;// CONCATENATED MODULE: ./components/header/partials/ContactIcons.tsx












function ContactIcons(props) {
    var t = (0,i18n/* useT */.NT)();
    var phoneRef = (0,react.useRef)();
    var chatRef = (0,react.useRef)();
    var mailRef = (0,react.useRef)();
    var addEventListeners = function(element) {
        if (element.children.length > 1) {
            element.addEventListener("mouseenter", function() {
                this.children[0].classList.add("show");
                this.children[0].setAttribute("aria-extended", "true");
                this.children[1].classList.add("show");
            });
            element.addEventListener("mouseleave", function() {
                this.children[0].classList.remove("show");
                this.children[0].setAttribute("aria-extended", "false");
                this.children[1].classList.remove("show");
            });
        }
    };
    (0,react.useEffect)(function() {
        if (document !== undefined) {
            if (phoneRef.current) {
                addEventListeners(phoneRef.current);
            }
            if (chatRef.current) {
                addEventListeners(chatRef.current);
            }
            if (mailRef.current) {
                addEventListeners(mailRef.current);
            }
        }
    }, []);
    var menuLabel = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_menu_label_start");
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            props.contactIcons != null && Checkers/* default.isValidString */.Z.isValidString(menuLabel) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: "nav-label nav-item",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "p-r-10 fs-16 bold nav-link pointer",
                        children: menuLabel
                    })
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
            props.contactIcons != null ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    props.contactIcons.phoneIcon == true && props.contactIcons.phoneIconData != null && /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        ref: phoneRef,
                        className: props.contactIcons.phoneIconData != null ? props.contactIcons.phoneIconData.split(",").length > 1 ? "nav-item dropdown cursor-pointer me-0" : "nav-item me-0" : "nav-item me-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                target: "_blank",
                                id: props.hasOwnProperty("modalDropdownClass") ? props.modalDropdownClass != null ? "modal-phone-icon" : "phone-icon" : "phone-icon",
                                href: props.contactIcons.phoneIconData != null ? props.contactIcons.phoneIconData.split(",").length > 1 ? "#" : "tel:" + props.contactIcons.phoneIconData.replace(/\s+/g, "") : "#",
                                className: "nav-link d-flex align-items-center",
                                "aria-label": t("a11y.phone"),
                                title: t("a11y.phone"),
                                rel: "noreferrer",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "sr-only",
                                        children: t("a11y.phone")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: pro_light_svg_icons/* faPhone */.j1w,
                                        size: "2x"
                                    })
                                ]
                            }),
                            props.contactIcons.phoneIconData != null && props.contactIcons.phoneIconData.split(",").length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                className: "Contact-Icons__dropdown \n                          ".concat(props.hasOwnProperty("modalDropdownClass") && props.modalDropdownClass != null ? "dropdown-menu dropdown-article-menu " + props.modalDropdownClass : "", " dropdown-menu dropdown-article-menu shadow\n                        "),
                                "aria-labelledby": props.hasOwnProperty("modalDropdownClass") ? props.modalDropdownClass != null ? "modal-phone-icon" : "phone-icon" : "phone-icon",
                                style: props.hasOwnProperty("modalDropdownClass") && props.modalDropdownClass != null ? {
                                    bottom: "80px",
                                    boxShadow: "0 0 10px #ccc!important"
                                } : undefined,
                                children: [
                                    props.hasOwnProperty("modalDropdownClass") && props.modalDropdownClass != null ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        style: props.side == "right" ? {
                                            position: "fixed",
                                            bottom: "77.2px",
                                            left: "calc(25% - 16px)"
                                        } : {
                                            position: "fixed",
                                            bottom: "77.2px",
                                            right: "calc(78% - 25px)"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                            icon: pro_solid_svg_icons/* faSortUp */.foy
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownArrow/* default */.Z, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactPhones, {
                                        phoneIconData: props.contactIcons.phoneIconData
                                    })
                                ]
                            })
                        ]
                    }),
                    props.contactIcons.chatIcon == true ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        ref: chatRef,
                        className: props.contactIcons.chatIconData != null ? props.contactIcons.chatIconData.split(",").length > 1 ? "nav-item dropdown cursor-pointer me-0" : "nav-item me-0" : "nav-item me-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                target: "_blank",
                                id: props.hasOwnProperty("modalDropdownClass") ? props.modalDropdownClass != null ? "modal-chat-icon" : "chat-icon" : "chat-icon",
                                href: props.contactIcons.chatIconData != null ? props.contactIcons.chatIconData.split(",").length > 1 ? "#" : "https://wa.me/" + props.contactIcons.chatIconData.replace(/\s+/g, "").replace(/\+/g, "") : "#",
                                className: "nav-link d-flex align-items-center",
                                "aria-label": t("a11y.chat"),
                                title: t("a11y.chat"),
                                rel: "noreferrer",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "sr-only",
                                        children: t("a11y.chat")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: pro_light_svg_icons/* faComments */.lXL,
                                        size: "2x"
                                    })
                                ]
                            }),
                            props.contactIcons.chatIconData != null ? props.contactIcons.chatIconData.split(",").length > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                className: "Contact-Icons__dropdown \n                          ".concat(props.hasOwnProperty("modalDropdownClass") && props.modalDropdownClass != null ? "dropdown-menu dropdown-article-menu " + props.modalDropdownClass : "", " dropdown-menu dropdown-article-menu shadow\n                        "),
                                "aria-labelledby": props.hasOwnProperty("modalDropdownClass") ? props.modalDropdownClass != null ? "modal-chat-icon" : "chat-icon" : "chat-icon",
                                style: props.hasOwnProperty("modalDropdownClass") && props.modalDropdownClass != null ? {
                                    bottom: "80px",
                                    left: "20%",
                                    boxShadow: "0 0 3px #ccc"
                                } : undefined,
                                children: [
                                    props.hasOwnProperty("modalDropdownClass") && props.modalDropdownClass != null ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        style: props.side == "right" ? {
                                            position: "fixed",
                                            bottom: "77.2px",
                                            right: "calc(40% - 16px)"
                                        } : {
                                            position: "fixed",
                                            bottom: "77.2px",
                                            right: "calc(50% - 18px)"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                            icon: pro_solid_svg_icons/* faSortUp */.foy
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownArrow/* default */.Z, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactWhatsApp, {
                                        phoneIconData: props.contactIcons.chatIconData
                                    })
                                ]
                            }) : "" : ""
                        ]
                    }) : "",
                    props.contactIcons.mailIcon == true ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        ref: mailRef,
                        className: props.contactIcons.mailIconData != null ? props.contactIcons.mailIconData.split(",").length > 1 ? "nav-item dropdown cursor-pointer me-0" : "nav-item me-0" : "nav-item me-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                target: "_blank",
                                id: props.hasOwnProperty("modalDropdownClass") ? props.modalDropdownClass != null ? "modal-mail-icon" : "mail-icon" : "mail-icon",
                                href: props.contactIcons.mailIconData != null ? props.contactIcons.mailIconData.split(",").length > 1 ? "#" : "mailto:" + props.contactIcons.mailIconData.replace(/\s+/g, "") : "#",
                                className: "nav-link d-flex align-items-center",
                                "aria-label": t("a11y.mail"),
                                title: t("a11y.mail"),
                                rel: "noreferrer",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "sr-only",
                                        children: t("a11y.mail")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: pro_light_svg_icons/* faEnvelope */.FU$,
                                        size: "2x"
                                    })
                                ]
                            }),
                            props.contactIcons.mailIconData != null ? props.contactIcons.mailIconData.split(",").length > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                className: "Contact-Icons__dropdown \n                          ".concat(props.hasOwnProperty("modalDropdownClass") && props.modalDropdownClass != null ? "dropdown-menu dropdown-article-menu " + props.modalDropdownClass : "", " dropdown-menu dropdown-article-menu shadow\n                        "),
                                "aria-labelledby": props.hasOwnProperty("modalDropdownClass") ? props.modalDropdownClass != null ? "modal-mail-icon" : "mail-icon" : "mail-icon",
                                style: props.hasOwnProperty("modalDropdownClass") && props.modalDropdownClass != null ? {
                                    bottom: "80px",
                                    left: "25%",
                                    boxShadow: "0 0 10px #ccc!important"
                                } : undefined,
                                children: [
                                    props.hasOwnProperty("modalDropdownClass") && props.modalDropdownClass != null ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        style: props.side == "right" ? {
                                            position: "fixed",
                                            bottom: "77.2px",
                                            right: "32px"
                                        } : {
                                            position: "fixed",
                                            bottom: "77.2px",
                                            right: "calc(23% - 7.2px)"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                            icon: pro_solid_svg_icons/* faSortUp */.foy
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownArrow/* default */.Z, {}),
                                    props.contactIcons.mailIconData.split(",").map(function(mail, key) {
                                        return(// eslint-disable-next-line react/jsx-key
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: key == 0 ? "dropdown-ul-item mt-20px" : "dropdown-ul-item mt-3",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "dropdown-item text-wrap",
                                                target: "_blank",
                                                href: mail.split(":").length > 1 ? "mailto:" + mail.split(":")[1].replace(/\s+/g, "") : "mailto:" + mail.replace(/\s+/g, ""),
                                                rel: "noreferrer",
                                                children: mail.split(":").length > 1 ? mail.split(":")[0].replace(/\s+/g, "") : mail.replace(/\s+/g, "")
                                            })
                                        }, key));
                                    })
                                ]
                            }) : "" : ""
                        ]
                    }) : ""
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
        ]
    });
}


/***/ }),

/***/ 75203:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ DropdownArrow; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);

function DropdownArrow() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
        className: "arrow",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            className: "position-absolute",
            version: "1.1",
            xmlns: "http://www.w3.org/2000/svg",
            x: "0px",
            y: "0px",
            width: "14px",
            height: "7px",
            viewBox: "0 0 14 7",
            enableBackground: "new 0 0 14 7",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                    fill: "#FFFFFF",
                    points: "0,0 7,7 14,0 14,7 0,7 "
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polyline", {
                    opacity: "0.1",
                    fill: "none",
                    stroke: "#231F20",
                    strokeMiterlimit: "10",
                    points: "0,0 7,7 14,0 "
                })
            ]
        })
    });
}


/***/ }),

/***/ 94795:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LanguageSwitcher; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(82770);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4012);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89736);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34357);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _fortawesome_pro_regular_svg_icons__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(87091);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96350);
/* harmony import */ var _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83974);
/* harmony import */ var _helpers_class_RequestLocale__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(81071);
/* harmony import */ var _helpers_i18n__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(95925);
/* harmony import */ var _DropdownArrow__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(75203);











// TEMP: language switcher hidden while checking things; set back to false to show it again
var HIDE_LANGUAGE_SWITCHER = true;
// Globe icon with the site's languages. Rendered next to the search icon in the header bar (so it stays
// outside the burger menu), or inside the menu for header types that have no such slot.
function LanguageSwitcher(param) {
    var partials = param.partials, _modalDropdownClass = param.modalDropdownClass, modalDropdownClass = _modalDropdownClass === void 0 ? null : _modalDropdownClass, handleHide = param.handleHide, _inHeaderBar = param.inHeaderBar, inHeaderBar = _inHeaderBar === void 0 ? false : _inHeaderBar;
    var ref;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var t = (0,_helpers_i18n__WEBPACK_IMPORTED_MODULE_6__/* .useT */ .NT)();
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), langOpen = ref1[0], setLangOpen = ref1[1];
    // languages the site offers (backend list, codes like 'EL') that this frontend can also serve
    var languageEntries = (_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidArray */ .Z.isValidArray(partials === null || partials === void 0 ? void 0 : (ref = partials.lang) === null || ref === void 0 ? void 0 : ref.entries) ? partials.lang.entries : []).map(function(entry) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, entry), {
            locale: (0,_helpers_class_RequestLocale__WEBPACK_IMPORTED_MODULE_5__/* .fromBackendLocale */ .Mx)(entry.code)
        });
    }).filter(function(entry) {
        return _helpers_class_RequestLocale__WEBPACK_IMPORTED_MODULE_5__/* .SUPPORTED_LOCALES.includes */ .RF.includes(entry.locale);
    });
    if (HIDE_LANGUAGE_SWITCHER || languageEntries.length < 2) {
        return null;
    }
    var inModal = modalDropdownClass != null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
        className: "nav-item dropdown cursor-pointer" + (inHeaderBar ? " lang-switcher-bar" : ""),
        // opens on hover, like the other menu dropdowns
        onMouseEnter: function() {
            return setLangOpen(true);
        },
        onMouseLeave: function() {
            return setLangOpen(false);
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                href: "#",
                role: "button",
                id: inModal ? "modal-lang" : "lang",
                className: "d-flex nav-link lang-toggle" + (langOpen ? " show" : ""),
                "aria-label": t("a11y.language"),
                title: t("a11y.language"),
                "aria-haspopup": "true",
                "aria-expanded": langOpen ? "true" : "false",
                onClick: function(e) {
                    e.preventDefault();
                    // a mouse/touch click only opens: on touch screens the tap fires mouseenter first, so
                    // toggling would close it again at once. Keyboard (Enter, e.detail === 0) toggles.
                    setLangOpen(e.detail === 0 ? !langOpen : true);
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__/* .FontAwesomeIcon */ .G, {
                    icon: _fortawesome_pro_regular_svg_icons__WEBPACK_IMPORTED_MODULE_10__/* .faGlobe */ .g4A,
                    size: "2x"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                className: (inModal ? "dropdown-menu dropdown-lang-menu " + modalDropdownClass : "dropdown-menu dropdown-lang-menu shadow") + (langOpen ? " show" : ""),
                "aria-labelledby": inModal ? "modal-lang" : "lang",
                children: [
                    !inModal && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_DropdownArrow__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {}),
                    languageEntries.map(function(entry, key) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            className: key == 0 ? "dropdown-ul-item mt-20px" : "dropdown-ul-item mt-3",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                className: "dropdown-item" + (entry.locale === router.locale ? " fw-bold" : ""),
                                href: (0,_helpers_i18n__WEBPACK_IMPORTED_MODULE_6__/* .localePrefix */ .ck)(entry.locale) + (router.asPath === "/" ? "" : router.asPath) || "/",
                                lang: entry.locale,
                                hrefLang: entry.locale,
                                "aria-current": entry.locale === router.locale ? "true" : undefined,
                                onClick: function() {
                                    setLangOpen(false);
                                    if (typeof handleHide === "function") {
                                        handleHide();
                                    }
                                },
                                children: entry.name
                            })
                        }, "lang-" + entry.locale);
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 4788:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PartnersSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89736);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53429);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83974);




function widthClassesForCount(count) {
    if (count <= 4) {
        var md = Math.round(12 / count);
        var sm = Math.round(12 / count * 2);
        var cls = "col-md-".concat(md, " col-sm-").concat(sm, " col-xs-12");
        return {
            master: cls,
            prePrePreLast: cls,
            prePreLast: cls,
            preLast: cls,
            last: cls
        };
    }
    if (count % 5 === 0) {
        return {
            master: "col-md-4 col-sm-6 col-xs-12",
            prePrePreLast: "col-md-4 col-sm-6 col-xs-12",
            prePreLast: "col-md-4 col-sm-6 col-xs-12",
            preLast: "col-md-6 col-sm-6 col-xs-12",
            last: "col-md-6 col-sm-6 col-xs-12"
        };
    }
    if (count % 6 === 0) {
        var cls1 = "col-md-4 col-sm-6 col-xs-12";
        return {
            master: cls1,
            prePrePreLast: cls1,
            prePreLast: cls1,
            preLast: cls1,
            last: cls1
        };
    }
    if (count % 4 === 0) {
        var cls2 = "col-md-3 col-sm-6 col-xs-12";
        return {
            master: cls2,
            prePrePreLast: cls2,
            prePreLast: cls2,
            preLast: cls2,
            last: cls2
        };
    }
    if (count === 7 || count === 11) {
        return {
            master: "col-md-3 col-sm-12 col-xs-12",
            prePrePreLast: "col-md-3 col-sm-12 col-xs-12",
            prePreLast: "col-md-4 col-sm-12 col-xs-12",
            preLast: "col-md-4 col-sm-12 col-xs-12",
            last: "col-md-4 col-sm-12 col-xs-12"
        };
    }
    if (count === 9) {
        return {
            master: "col-md-2 col-sm-4 col-xs-12",
            prePrePreLast: "col-md-2 col-sm-4 col-xs-12",
            prePreLast: "col-md-4 col-sm-4 col-xs-12",
            preLast: "col-md-4 col-sm-4 col-xs-12",
            last: "col-md-4 col-sm-4 col-xs-12"
        };
    }
    var cls3 = "col-md-4 col-sm-6 col-xs-12";
    return {
        master: cls3,
        prePrePreLast: cls3,
        prePreLast: cls3,
        preLast: cls3,
        last: cls3
    };
}
function widthClassForIndex(index, count, classes) {
    var revindex = count - index;
    if (revindex === 1) return classes.last;
    if (revindex === 2) return classes.preLast;
    if (revindex === 3) return classes.prePreLast;
    if (revindex === 4) return classes.prePrePreLast;
    return classes.master;
}
var CHANNEL_LOGO_HEIGHT = {
    12: 95,
    2: 45,
    32: 45,
    5: 35,
    11: 35,
    20: 35,
    33: 35,
    3: 20,
    26: 35,
    22: 37
};
function logoHeightForChannel(systemChannelId) {
    return CHANNEL_LOGO_HEIGHT[systemChannelId] != undefined ? CHANNEL_LOGO_HEIGHT[systemChannelId] : 25;
}
var ROW_HEIGHT = 95;
function PartnersSection(props) {
    var ref;
    var partnerLinks = _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_3__/* ["default"].isValidArray */ .Z.isValidArray((ref = props.content) === null || ref === void 0 ? void 0 : ref.partnerLinks) ? props.content.partnerLinks : [];
    if (partnerLinks.length === 0) {
        return null;
    }
    var classes = widthClassesForCount(partnerLinks.length);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "p-t-10 p-b-10 text-center",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "container",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "md-p-l-20 xs-no-padding clearfix",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "row row-eq-height",
                    children: partnerLinks.map(function(partnerLink, index) {
                        var widthClass = widthClassForIndex(index, partnerLinks.length, classes);
                        var height = logoHeightForChannel(partnerLink.systemChannelId);
                        var marginTop = Math.floor((ROW_HEIGHT - height) / 2);
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: widthClass + " no-padding",
                            style: {
                                height: ROW_HEIGHT
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                href: partnerLink.link,
                                target: "_blank",
                                rel: "noreferrer",
                                style: {
                                    color: "#626262"
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "p-r-40 md-pr-30 xs-no-padding clearfix",
                                        style: {
                                            marginTop: marginTop
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "position-relative mx-auto",
                                            style: {
                                                height: height,
                                                maxWidth: 200
                                            },
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                src: "/assets/img/partners/" + partnerLink.systemChannelId + ".jpg",
                                                alt: partnerLink.title || "partner",
                                                layout: "fill",
                                                sizes: "200px",
                                                objectFit: "contain",
                                                style: {
                                                    mixBlendMode: "multiply"
                                                }
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "d-md-none",
                                        style: {
                                            borderBottom: "1px solid #e5e5e5",
                                            width: "80%",
                                            margin: "24px auto 0"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "hidden",
                                        children: partnerLink.title
                                    })
                                ]
                            })
                        }, partnerLink.id);
                    })
                })
            })
        })
    });
}


/***/ }),

/***/ 7839:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IW": function() { return /* binding */ redirectToWebHotelier; }
/* harmony export */ });
/* unused harmony exports buildWebHotelierUrl, resolveBookingMode */
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62286);
/* harmony import */ var _class_Checkers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83974);


function buildWebHotelierUrl(propertyBookingTypeValue, webHotelierBookUrl, bookingTypeValue, roomCodes, checkin, checkout, adults, kids, infants, rooms) {
    var source = _class_Checkers__WEBPACK_IMPORTED_MODULE_0__/* ["default"].isValidString */ .Z.isValidString(bookingTypeValue) ? bookingTypeValue : _class_Checkers__WEBPACK_IMPORTED_MODULE_0__/* ["default"].isValidString */ .Z.isValidString(webHotelierBookUrl) ? webHotelierBookUrl : propertyBookingTypeValue;
    var isWebHotelierSource = _class_Checkers__WEBPACK_IMPORTED_MODULE_0__/* ["default"].isValidString */ .Z.isValidString(webHotelierBookUrl) && source === webHotelierBookUrl;
    if (!_class_Checkers__WEBPACK_IMPORTED_MODULE_0__/* ["default"].isValidString */ .Z.isValidString(source)) {
        return null;
    }
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(source.split("?"), 2), base = ref[0], query = ref[1];
    if (!_class_Checkers__WEBPACK_IMPORTED_MODULE_0__/* ["default"].isValidString */ .Z.isValidString(base)) {
        return null;
    }
    var params = new URLSearchParams(query || "");
    if (_class_Checkers__WEBPACK_IMPORTED_MODULE_0__/* ["default"].isValidString */ .Z.isValidString(checkin)) {
        params.set("checkin", checkin);
    }
    if (_class_Checkers__WEBPACK_IMPORTED_MODULE_0__/* ["default"].isValidString */ .Z.isValidString(checkout)) {
        params.set("checkout", checkout);
    }
    if (adults != null) {
        params.set("adults", String(adults));
    }
    if (kids != null) {
        params.set("children", String(kids));
    }
    if (infants != null) {
        params.set("infants", String(infants));
    }
    if (rooms != null && Number(rooms) > 0) {
        params.set("rooms", String(rooms));
    }
    var validRoomCodes = _class_Checkers__WEBPACK_IMPORTED_MODULE_0__/* ["default"].isValidArray */ .Z.isValidArray(roomCodes) ? roomCodes.filter(function(code) {
        return _class_Checkers__WEBPACK_IMPORTED_MODULE_0__/* ["default"].isValidString */ .Z.isValidString(code);
    }) : [];
    if (validRoomCodes.length > 0 && (isWebHotelierSource || params.has("room"))) {
        params.set("room", validRoomCodes.join(","));
        params.set("exclusive", "1");
    }
    var queryString = params.toString();
    return queryString.length > 0 ? base + "?" + queryString : base;
}
function redirectToWebHotelier(propertyBookingTypeValue, webHotelierBookUrl, bookingTypeValue, roomCodes, checkin, checkout, adults, kids, infants, rooms) {
    var url = buildWebHotelierUrl(propertyBookingTypeValue, webHotelierBookUrl, bookingTypeValue, roomCodes, checkin, checkout, adults, kids, infants, rooms);
    if (url == null) {
        return false;
    }
    window.open(url, "_blank");
    return true;
}
// Same decision as the Lodge site: the booking type of the site (app) wins when it is set, otherwise the type of the
// property decides. A stored booking value only counts for the type it belongs to, so a leftover WebHotelier url on a
// property that books through Loggia is ignored.
function resolveBookingMode(appTypeId, appTypeValue, propertyTypeId, propertyTypeValue) {
    var byType = function(typeId, value) {
        var hasValue = Checkers.isValidString(value);
        switch(Number(typeId)){
            case 1:
                return {
                    mode: "loggia",
                    value: null
                };
            case 2:
                return hasValue ? {
                    mode: "button",
                    value: value
                } : {
                    mode: "none",
                    value: null
                };
            case 3:
                return hasValue ? {
                    mode: "webhotelier",
                    value: value
                } : {
                    mode: "none",
                    value: null
                };
            case 4:
                return hasValue ? {
                    mode: "other",
                    value: value
                } : {
                    mode: "none",
                    value: null
                };
            default:
                return {
                    mode: "none",
                    value: null
                };
        }
    };
    if (appTypeId != null && appTypeId !== "") {
        // on the site level only the types with a value work (the Lodge shows nothing for the others)
        var result = byType(appTypeId, appTypeValue);
        return result.mode === "loggia" ? {
            mode: "none",
            value: null
        } : result;
    }
    if (propertyTypeId != null && propertyTypeId !== "") {
        return byType(propertyTypeId, propertyTypeValue);
    }
    return {
        mode: "none",
        value: null
    };
}


/***/ }),

/***/ 92288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76710);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27305);


var Consts = /*#__PURE__*/ function() {
    "use strict";
    function Consts() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, Consts);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(Consts, null, [
        {
            key: "S3",
            get: function get() {
                return "https://loggia-cdn.s3.eu-central-1.amazonaws.com/";
            }
        },
        {
            key: "S3Folder",
            get: function get() {
                return "shared/";
            }
        },
        {
            key: "AppleAppSvg",
            get: function get() {
                return this.S3 + this.S3Folder + "ios_en.svg";
            }
        },
        {
            key: "AndroidAppSvg",
            get: function get() {
                return this.S3 + this.S3Folder + "android_en.svg";
            }
        },
        {
            key: "W3cValidatorSvg",
            get: function get() {
                return this.S3 + this.S3Folder + "w3c_xhtml_2.0.svg";
            }
        },
        {
            key: "WcagValidatorSvg",
            get: function get() {
                return this.S3 + this.S3Folder + "w3c_wcag_1.0.svg";
            }
        },
        {
            key: "JumbotronCarouselImage",
            get: function get() {
                return 486;
            }
        },
        {
            key: "JumbotronGridImage",
            get: function get() {
                return 573;
            }
        },
        {
            key: "JumbotronStaticImage",
            get: function get() {
                return 487;
            }
        }
    ]);
    return Consts;
}();
/* harmony default export */ __webpack_exports__["Z"] = (Consts);


/***/ }),

/***/ 56947:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ useApiGet; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8158);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27307);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89736);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31969);
/* harmony import */ var _helpers_i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95925);





var useApiGet = function(action, queryParameters, showPageLoader) {
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0), status = ref[0], setStatus = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(""), statusText = ref1[0], setStatusText = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(), data = ref2[0], setData = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(), error = ref3[0], setError = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), loading = ref4[0], setLoading = ref4[1];
    if (queryParameters != undefined) {
        action = action + "?" + queryParameters;
    }
    var getAPIData = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
            var requestOptions, apiResponse, json, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoading(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        requestOptions = {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify({
                                action: action
                            })
                        };
                        return [
                            4,
                            fetch((0,_helpers_i18n__WEBPACK_IMPORTED_MODULE_2__/* .withProxyLocale */ .O0)("/apiloggia"), requestOptions)
                        ];
                    case 2:
                        apiResponse = _state.sent();
                        return [
                            4,
                            apiResponse.json()
                        ];
                    case 3:
                        json = _state.sent();
                        setStatus(apiResponse.status);
                        setStatusText(apiResponse.statusText);
                        setData(json);
                        return [
                            3,
                            5
                        ];
                    case 4:
                        error = _state.sent();
                        setError(error);
                        return [
                            3,
                            5
                        ];
                    case 5:
                        setLoading(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function getAPIData() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        getAPIData();
    }, [
        action
    ]);
    return {
        status: status,
        statusText: statusText,
        data: data,
        error: error,
        loading: loading
    };
};


/***/ }),

/***/ 66638:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ MainLayout; }
});

// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(82770);
// EXTERNAL MODULE: ../../shared/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(14140);
// EXTERNAL MODULE: ./components/Header.tsx + 7 modules
var Header = __webpack_require__(60314);
// EXTERNAL MODULE: ../../shared/node_modules/react/index.js
var react = __webpack_require__(89736);
// EXTERNAL MODULE: ../../shared/node_modules/@fancyapps/ui/dist/fancybox.esm.js
var fancybox_esm = __webpack_require__(46797);
// EXTERNAL MODULE: ../../shared/node_modules/@mui/material/LinearProgress/LinearProgress.js + 1 modules
var LinearProgress = __webpack_require__(91779);
// EXTERNAL MODULE: ../../shared/node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(31969);
// EXTERNAL MODULE: ./helpers/MethodHelper.ts
var MethodHelper = __webpack_require__(23158);
;// CONCATENATED MODULE: ./components/header/types/HeaderPacer.tsx





var HeaderPacer = function() {
    var mainPacer = (0,es/* useSelector */.v9)(function(state) {
        return state["uiData"]["mainPacer"];
    });
    var rgbDesignColor = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "designColor");
    });
    var scrollToTop = function() {
        if (window != undefined) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: "instant"
            });
        }
    };
    (0,react.useEffect)(function() {
        if (mainPacer) {
            scrollToTop();
        }
    }, [
        scrollToTop,
        mainPacer
    ]);
    return mainPacer ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "pacer",
        style: {
            color: rgbDesignColor
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinearProgress/* default */.Z, {
            sx: {
                backgroundColor: "white"
            },
            color: "inherit"
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};

// EXTERNAL MODULE: ./components/BottomSections.tsx + 7 modules
var BottomSections = __webpack_require__(54180);
// EXTERNAL MODULE: ../../shared/node_modules/next/dynamic.js
var dynamic = __webpack_require__(18256);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./components/FooterWrapper.tsx




var Scripts = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7452), __webpack_require__.e(9764), __webpack_require__.e(5419)]).then(__webpack_require__.bind(__webpack_require__, 85419));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(85419)
            ];
        }
    },
    ssr: false
});
var FooterWrapper = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomSections["default"], {
                footerPaddingClass: !props.isDesktop ? "search-xs-p-b-70" : "",
                isDesktop: props.isDesktop,
                contactSection: props.app.showContactSection,
                footerSection: true,
                app_data: props.app_data,
                app: props.app,
                head: props.head,
                locations: props.locations,
                footer: props.footer,
                htmlSections: props.hasOwnProperty("html_sections") ? props.html_sections : null,
                contactHtml: props.hasOwnProperty("contactHtml") ? props.contactHtml : null,
                content: props.hasOwnProperty("content") ? props.content : null,
                propertyAllImages: props.hasOwnProperty("propertyAllImages") ? props.propertyAllImages : null
            }, "bottom_section"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Scripts, {})
        ]
    });
};

// EXTERNAL MODULE: ../../shared/node_modules/next/router.js
var next_router = __webpack_require__(34357);
// EXTERNAL MODULE: ./redux/actions.js
var actions = __webpack_require__(46093);
;// CONCATENATED MODULE: ./components/header/types/LoaderComponent.tsx





var LoaderComponent = function() {
    var router = (0,next_router.useRouter)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var mainPacerHandler = function(value) {
        dispatch((0,actions/* updateMainPacer */.P9)(value));
    };
    (0,react.useEffect)(function() {
        // Shallow route changes (e.g. a component updating just the URL/query
        // without re-running data fetching) shouldn't trigger the full-page
        // loading skeleton - only real navigations should.
        var handleStart = function(url) {
            var shallow = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).shallow;
            return !shallow && url !== router.asPath && mainPacerHandler(true);
        };
        var handleComplete = function(url) {
            var shallow = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).shallow;
            return !shallow && url === router.asPath && mainPacerHandler(false);
        };
        router.events.on("routeChangeStart", handleStart);
        router.events.on("routeChangeComplete", handleComplete);
        router.events.on("routeChangeError", handleComplete);
        return function() {
            router.events.off("routeChangeStart", handleStart);
            router.events.off("routeChangeComplete", handleComplete);
            router.events.off("routeChangeError", handleComplete);
        };
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};

// EXTERNAL MODULE: ../../shared/node_modules/react-loading-skeleton/dist/index.mjs
var dist = __webpack_require__(91932);
;// CONCATENATED MODULE: ./components/header/types/MainLayoutSkeleton.tsx



var MainLayoutSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: " no-padding no-overflow h-100 p-b-40",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                        height: 400,
                        width: "100%"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-md-8",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                        height: 60,
                                        width: "100%",
                                        className: "m-b-20"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                        height: 27,
                                        width: "100%",
                                        className: "m-b-20"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                        height: 27,
                                        width: "100%",
                                        className: "m-b-20"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                        height: 27,
                                        width: "100%",
                                        className: "m-b-20"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                        height: 150,
                                        width: "100%",
                                        className: "m-b-20"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                        height: 27,
                                        width: "100%",
                                        className: "m-b-20"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                        height: 27,
                                        width: "100%",
                                        className: "m-b-20"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-md-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                        height: 150,
                                        width: "100%",
                                        className: "m-b-20"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                        height: 250,
                                        width: "100%",
                                        className: "m-b-20"
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ../../shared/node_modules/react-dom/index.js
var react_dom = __webpack_require__(93592);
// EXTERNAL MODULE: ./hooks/useApiHook.tsx
var useApiHook = __webpack_require__(56947);
// EXTERNAL MODULE: ./helpers/class/Checkers.ts
var Checkers = __webpack_require__(83974);
;// CONCATENATED MODULE: ./components/BodyEndSectionsWrapper.tsx







var BodyEndSectionsWrapper = function() {
    var pageId = (0,es/* useSelector */.v9)(function(state) {
        return state["builderSettingsData"]["settings"]["page_id"];
    });
    var sections = (0,useApiHook/* useApiGet */.g)("/api/lodge/frontend/get/app-sections/".concat(pageId), "position=end_body&type=HTML", false);
    var loadedRef = (0,react.useRef)(false);
    // These end_body sections are also part of the page's html_sections, whose Elfsight widgets
    // <BottomSections> already renders (server side, so they are in the DOM by now). Rendering them here too
    // would show every widget twice (closing the popup reveals a second one). Computed once per response,
    // so this component's own widgets are not mistaken for duplicates on later renders.
    var bodyEndSections = (0,react.useMemo)(function() {
        var ref;
        if (sections.status != 200 || !Checkers/* default.isValidArray */.Z.isValidArray((ref = sections.data) === null || ref === void 0 ? void 0 : ref.app_sections)) return [];
        return (0,MethodHelper/* uniqueElfsightSections */.G)(sections.data.app_sections).filter(function(section) {
            var match = typeof section.app_section_content === "string" ? section.app_section_content.match(/elfsight-app-([\w-]+)/) : null;
            return match == null || typeof document === "undefined" || document.querySelector(".elfsight-app-" + match[1]) == null;
        });
    }, [
        sections.status,
        sections.data
    ]);
    var showAccessYes = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_general_accessyes_enable") == 1 ? true : false;
    });
    var accessYesIdentifier = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_general_accessyes_identifier");
    });
    (0,react.useEffect)(function() {
        // μόνο client-side
        if (false) {}
        // feature flag off
        if (!showAccessYes) return;
        // αν δεν έχεις identifier, δεν το φορτώνουμε
        if (!accessYesIdentifier) return;
        // avoid double inject
        if (loadedRef.current) return;
        // avoid duplicate if script already exists (σε route changes)
        var existing = document.querySelector('script[data-cookieyes-a11y="1"]');
        if (existing) {
            loadedRef.current = true;
            return;
        }
        loadedRef.current = true;
        // config πριν το load
        window._cyA11yConfig = {
            iconId: "default",
            position: {
                mobile: "bottom-right",
                desktop: "bottom-right"
            },
            language: {
                default: "en",
                selected: []
            }
        };
        var script = document.createElement("script");
        script.async = true;
        script.src = "https://cdn-cookieyes.com/widgets/accessibility.js?id=".concat(encodeURIComponent(accessYesIdentifier));
        script.setAttribute("data-cookieyes-a11y", "1");
        document.body.appendChild(script);
    // optional: cleanup αν θες να αφαιρείται σε unmount
    // return () => { script.remove() }
    }, [
        showAccessYes,
        accessYesIdentifier
    ]);
    // Elfsight widgets go to the mount point above the footer (BottomSections), so an inline widget such as
    // the reviews is not shown under the footer; popups and chat float, so their position does not matter.
    // Other end_body HTML stays here, at the end of the page. Without the mount point (pages without
    // BottomSections) everything is rendered here as before.
    // BottomSections loads lazily and can remount (skeleton -> content), replacing the mount point, so the
    // current element is tracked instead of read once.
    var ref = (0,react.useState)(null), widgetsTarget = ref[0], setWidgetsTarget = ref[1];
    var ref1 = (0,react.useState)(false), noWidgetsTarget = ref1[0], setNoWidgetsTarget = ref1[1];
    (0,react.useEffect)(function() {
        var update = function() {
            var element = document.getElementById(MethodHelper/* BODY_END_WIDGETS_ID */.XQ);
            setWidgetsTarget(function(current) {
                return current === element ? current : element;
            });
        };
        update();
        var observer = new MutationObserver(update);
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
        // pages without BottomSections never get the mount point: after a while render the widgets here instead
        var fallbackTimer = window.setTimeout(function() {
            return setNoWidgetsTarget(document.getElementById(MethodHelper/* BODY_END_WIDGETS_ID */.XQ) == null);
        }, 5000);
        return function() {
            observer.disconnect();
            window.clearTimeout(fallbackTimer);
        };
    }, []);
    var isElfsight = function(section) {
        return typeof section.app_section_content === "string" && section.app_section_content.includes("elfsight-app-");
    };
    // Elfsight widgets are created once, where they will stay: in the mount point, or here when the page has
    // none. Rendering them here first and moving them later leaves an empty widget (Elfsight initialises a
    // widget id once), so until the mount point is found they wait.
    var elfsightSections = widgetsTarget != null ? bodyEndSections.filter(isElfsight) : [];
    var inPlaceSections = widgetsTarget == null && noWidgetsTarget ? bodyEndSections : bodyEndSections.filter(function(section) {
        return !isElfsight(section);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            inPlaceSections.map(function(section, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: section.app_section_content
                    }
                }, "end-body-" + index);
            }),
            elfsightSections.length > 0 && widgetsTarget != null && /*#__PURE__*/ (0,react_dom.createPortal)(elfsightSections.map(function(section, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: section.app_section_content
                    }
                }, "end-body-widget-" + index);
            }), widgetsTarget)
        ]
    });
};
/* harmony default export */ var components_BodyEndSectionsWrapper = (BodyEndSectionsWrapper);

;// CONCATENATED MODULE: ./components/templates/index/partials/InlineStyles.tsx





var InlineStyles = function(props) {
    var builderSettingsData = (0,es/* useSelector */.v9)(function(state) {
        return state["builderSettingsData"]["settings"];
    });
    var servicesHomepageRadious = props.app.servicesRadius;
    var servicesHomepageShadow = props.app.servicesShadow;
    var menuFontColor = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_header_menu_color_sticky");
    });
    var headerMenuColor = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_header_menu_color");
    });
    var disableUiControls = (0,es/* useSelector */.v9)(function(state) {
        return Checkers/* default.valueToBoolean */.Z.valueToBoolean((0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_propertylist_map_disable_controls"));
    });
    var customStyles = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_custom_css");
    });
    var menuIconBorder = (0,es/* useSelector */.v9)(function(state) {
        return Checkers/* default.valueToBoolean */.Z.valueToBoolean((0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_menu_icon_border"));
    });
    var builderPropertiesBorder = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_properties_border");
    });
    var builderPropertiesShadow = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_properties_shadow");
    });
    var builderPropertiesRadius = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_properties_radius");
    });
    var builderEstatesBorder = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_properties_estates_border");
    });
    var builderEstatesShadow = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_properties_estates_shadow");
    });
    var builderEstatesRadius = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_properties_estates_radius");
    });
    var builderBookingBoxBorder = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_booking_box_border");
    });
    var builderBookingBoxShadow = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_booking_box_shadow");
    });
    var builderBookingBoxRadius = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_booking_box_radius");
    });
    var builderPropertiesViewServicesBorder = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_propertyview_services_border");
    });
    var builderPropertiesViewServicesRadius = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_propertyview_services_radius");
    });
    var builderPropertiesViewServicesShadow = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_propertyview_services_shadow");
    });
    var builderDestinationsShadow = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_homepage_destinations_shadow");
    });
    var builderDestinationsBorder = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_homepage_destinations_border");
    });
    var builderDestinationsRadius = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_homepage_destinations_radius");
    });
    var builderCollectionsShadow = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_homepage_collections_shadow");
    });
    var builderCollectionsBorder = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_homepage_collections_border");
    });
    var builderCollectionsRadius = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_homepage_collections_radius");
    });
    var builderExperiencesBorder = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_homepage_experiences_border");
    });
    var builderExperiencesRadious = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_homepage_experiences_radius");
    });
    var builderExperiencesShadow = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_homepage_experiences_shadow");
    });
    var builderDestinationsThemeColor = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_homepage_destinations_theme_color");
    });
    var builderMenuSpacing = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_header_menu_spacing");
    });
    // const builderPropertiesBgColor = useSelector(state => fetchBuilderSettingByKey(state['builderSettingsData'], 'builder_properties_bg_color'));
    // useEffect( () => {
    //     console.log("forDebug", "boxSetting[border]", builderPropertiesBorder)
    //     console.log("forDebug", "boxSetting[shadow]", builderPropertiesShadow)
    //     console.log("forDebug", "boxSetting[radius]", builderPropertiesRadius)
    //     console.log("forDebug", "boxSetting[bg-color]", builderPropertiesBgColor)
    // }, [])
    var getBuilderSettingByKey = function(key) {
        if (builderSettingsData == null || builderSettingsData == undefined) {
            return "#ffffff";
        }
        if (builderSettingsData.builder == undefined || builderSettingsData.builder == null) {
            return "#ffffff";
        }
        if (builderSettingsData.builder[key] == undefined || builderSettingsData.builder[key] == null) {
            return "#ffffff";
        }
        return builderSettingsData.builder[key];
    };
    // const propertiesTextColor = builderSettingsData!=undefined && builderSettingsData.builder.builder_properties_text_color!=undefined && builderSettingsData.builder.builder_properties_text_color.length>0 ? builderSettingsData.builder.builder_properties_text_color : null
    // const builder_properties_border = builderSettingsData.builder!=undefined && builderSettingsData.builder.builder_properties_border!=undefined && builderSettingsData.builder.builder_properties_border.length>0 ? builderSettingsData.builder.builder_properties_border : null
    // useEffect( () => {
    //     console.log("forDebug", "propertiesBackgroundColor", getBuilderSettingByKey('builder_properties_bg_color'))
    //     console.log("forDebug", "propertiesTextColor", getBuilderSettingByKey('builder_properties_text_color'))
    //     console.log("forDebug", "builder_properties_border", getBuilderSettingByKey('builder_properties_border'))
    //     console.log("forDebug", "builder_properties_shadow", getBuilderSettingByKey('builder_properties_shadow'))
    //     console.log("forDebug", "builder_properties_radius", getBuilderSettingByKey('builder_properties_radius'))
    // }, [builderSettingsData])
    var app = props.app;
    var rgbDesignColor = props.rgbDesignColor;
    var rgbSearchbarColor = props.rgbSearchbarColor;
    // Only use the explicit searchbar color here - FlexibleSearchBar.tsx already handles its own
    // card/button designColor fallback in JS; falling back to designColor in this global,
    // !important-ed CSS class would override that per-element logic and blend the button into the card.
    var effectiveSearchbarColor = Checkers/* default.isValidString */.Z.isValidString(app.searchbarBgColor) ? app.searchbarBgColor : null;
    var effectiveRgbSearchbarColor = Checkers/* default.isValidString */.Z.isValidString(app.searchbarBgColor) ? rgbSearchbarColor : null;
    var initialiazeStyle = function() {
        // const head = document.getElementsByTagName('head')[0];
        // const style = document.createElement('style');
        // const link = document.createElement('link');
        // link.rel = 'stylesheet';
        // link.type = 'text/css';
        var style = {
            innerText: ""
        };
        // style.innerText = '';
        if (Checkers/* default.isHexColor */.Z.isHexColor(menuFontColor)) {
            style.innerText += ".Header.Header-Light-Transparent.Header-Sticky-Top-Not .navbar-nav .nav-link { color: ".concat(menuFontColor, " }");
            style.innerText += ".Header.Header-Light-Transparent.Header-Sticky-Top-Not .navbar-nav .nav-link svg { color: ".concat(menuFontColor, " }");
            style.innerText += ".Header.Header-Light-Transparent.Header-Sticky-Top-Not svg { color: ".concat(menuFontColor, " }");
        }
        if (app.designColor != null && app.designColor != "") {
            style.innerText += ".navbar-design-color{background-color: ".concat(app.designColor, "!important}") + ".navbar-design-color.border-bottom{border-bottom: ".concat(app.designColor, "!important}") + ".main-design-color{color: ".concat(app.designColor, "!important}") + "div.cs-skin-slide > span:after, div.cs-skin-slide.cs-active > span:after{color: ".concat(app.designColor, "!important}") + ".nav-tab-dropdown .cs-select .cs-placeholder{color: ".concat(app.designColor, "!important;font-size: 13px; border-bottom: 1px solid ").concat(app.designColor, "; }") + ".nav-tabs-simple > li > a:after{background-color: ".concat(app.designColor, "!important}") + ".btn-design-color{background-color: ".concat(app.designColor, "!important;border: 1px solid ").concat(app.designColor, "!important;border-color: ").concat(app.designColor, "!important;").concat(app.designMode ? "color: #fff" : "color: #000", "!important;}") + ".bg-design-color{background-color: ".concat(app.designColor, "!important;border-color: ").concat(app.designColor, "!important}") + ".text-design-color{color: ".concat(app.designColor, "!important}") + ".design_color{background-color: ".concat(app.designColor, "!important}") + ".custom_font_color, .design_custom_font_color{color: ".concat(app.designColor, "!important}") + ".btn-bordered-design-color > *{".concat(app.designMode ? "color: #fff!important;" : "color: #000!important;", "}") + ".btn-bordered-design-color:hover > *{color: ".concat(app.designColor, "!important;}") + ".btn-bordered-design-color{background: transparent!important;background-color: transparent!important; ".concat(app.designMode ? "color: #fff!important;" : "color: #000!important;", " ").concat(app.designMode ? "border: 2px solid #fff!important;" : "border: 2px solid #000!important;", "}") + ".btn-bordered-design-color:hover{".concat(app.designMode ? "background: #fff!important;background-color: #fff!important;" : "background: #000!important;background-color: #000!important;", " color: ").concat(app.designColor, "!important; ").concat(app.designMode ? "border: 2px solid #fff!important;" : "border: 2px solid #000!important;", "}");
        }
        if (rgbDesignColor != "bad_hex") {
            style.innerText += ".btn-design-color:hover {background-color: rgba(".concat(rgbDesignColor, ", .85)!important;border-color: ").concat(app.designColor, "!important;").concat(app.designMode ? "color: #fff" : "color: #000", "}") + ".btn-map.btn-design-color:hover{background-color: ".concat(app.designColor, "!important;border: 1px solid ").concat(app.designColor, "!important;border-color: ").concat(app.designColor, "!important;").concat(app.designMode ? "color: #fff" : "color: #000", "}") + ".MuiDateRangePickerDay-rangeIntervalDayHighlight{background-color: rgba(".concat(rgbDesignColor, ", .5) !important}") + ".MuiPickersDay-root.Mui-selected{background-color: rgba(".concat(rgbDesignColor, ") !important;text-shadow: 0px 0px 2px #000}") + ".form-group-default.focused{color: #212529!important;box-shadow: 0 0 0 0.25rem rgba(".concat(rgbDesignColor, ",.25)!important}");
        } else {
            style.innerText += ".btn-design-color:hover {background-color: ".concat(app.designColor, "!important;border-color: ").concat(app.designColor, "!important}");
        }
        if (app.designHeaderBgColor != null && app.designHeaderBgColor != "") {
            style.innerText += ".navbar-custom-color{background-color: ".concat(app.designHeaderBgColor, "!important}") + ".navbar-custom-color.border-bottom{border-bottom: ".concat(app.designHeaderBgColor, "!important}");
        }
        if (app.builder.builder_header_color != null && app.builder.builder_header_color != "") {
            style.innerText += ".Header-Custom-Color{background-color: ".concat(app.builder.builder_header_color, "!important}") + ".Header-Custom-Color.border-bottom{border-bottom: ".concat(app.builder.builder_header_color, "!important}");
        }
        if (app.designFontColor != null && app.designFontColor != "") {
            style.innerText += ".navbar-text-custom-color{color: ".concat(app.designFontColor, "!important}") + '.navbar-text-custom-color [class^="fa"]{color: '.concat(app.designFontColor, "!important}") + '.navbar-text-custom-color [class*="fa-"]{color: '.concat(app.designFontColor, "!important}") + ".navbar-text-custom-color .nav-item .nav-link{color: ".concat(app.designFontColor, "!important}") + '.navbar-text-custom-color .nav-item .nav-link [class^="fa"]{color: '.concat(app.designFontColor, "!important}") + '.navbar-text-custom-color .nav-item .nav-link [class*="fa-"]{color: '.concat(app.designFontColor, "!important}") + ".navbar-text-custom-color .nav-item .nav-link.btn{color: ".concat(app.designFontColor, "!important;background-color: transparent!important;border-color: ").concat(app.designFontColor, "!important}") + ".b-transparent-white.navbar-text-custom-color{color: ".concat(app.designFontColor, "!important;background-color: transparent!important;border-color: ").concat(app.designFontColor, "!important}");
        }
        if (app.designHeaderBgColor != null && app.designHeaderBgColor != "") {
            style.innerText += ".navbar-design-color{color: ".concat(app.designHeaderBgColor, "!important}");
        }
        if (effectiveSearchbarColor != null) {
            style.innerText += ".searchbar-bg-color{background-color: ".concat(effectiveSearchbarColor, "!important}") + ".btn-search-color{background-color: ".concat(effectiveSearchbarColor, "!important;border-color: ").concat(effectiveSearchbarColor, "!important}");
        }
        if (effectiveRgbSearchbarColor != "bad_hex" && effectiveRgbSearchbarColor != null) {
            style.innerText += ".btn-search-color:hover{background-color: rgba(".concat(effectiveRgbSearchbarColor, ", .85) !important;border-color: ").concat(effectiveSearchbarColor, "!important}") + ".MuiDateRangePickerDay-rangeIntervalDayHighlight{background-color: rgba(".concat(effectiveRgbSearchbarColor, ", .5) !important}") + ".MuiPickersDay-root.Mui-selected{background-color: rgba(".concat(effectiveRgbSearchbarColor, ") !important;text-shadow: 0px 0px 2px #000}");
        } else {
            style.innerText += ".btn-search-color:hover{background-color: ".concat(effectiveSearchbarColor, "!important;border-color: ").concat(effectiveSearchbarColor, "!important}");
        }
        if (builderPropertiesBorder != null || builderPropertiesRadius != null || builderPropertiesShadow != null) {
            style.innerText += ".design-box {";
            style.innerText += "overflow: hidden !important;";
            if (builderPropertiesRadius != null) {
                style.innerText += "border-radius: ".concat(builderPropertiesRadius, "px !important;");
                style.innerText += "-webkit-border-radius: ".concat(builderPropertiesRadius, "px !important;");
                style.innerText += "-khtml-border-radius: ".concat(builderPropertiesRadius, "px !important;");
                style.innerText += "-moz-border-radius: ".concat(builderPropertiesRadius, "px !important;");
                style.innerText += "border-top-left-radius: ".concat(builderPropertiesRadius, "px !important;");
                style.innerText += "-moz-border-top-left-radius: ".concat(builderPropertiesRadius, "px !important;");
                style.innerText += "-moz-border-top-right-radius: ".concat(builderPropertiesRadius, "px !important;");
                style.innerText += "border-top-right-radius: ".concat(builderPropertiesRadius, "px !important;");
                style.innerText += "-moz-border-right-left-radius: ".concat(builderPropertiesRadius, "px !important;");
                style.innerText += "-moz-border-right-right-radius: ".concat(builderPropertiesRadius, "px !important;");
            } else {
                style.innerText += "border-radius: 0px;";
            }
            if (builderPropertiesShadow == 1) {
                style.innerText += "box-shadow: 0 0 15px rgba(0, 0, 0, 0.25);-webkit-box-shadow: 0 0 15px rgba(0, 0, 0, 0.25);-moz-box-shadow: 0 0 15px rgba(0, 0, 0, 0.25);";
            } else {
                style.innerText += "box-shadow: none;-webkit-box-shadow: none;-moz-box-shadow: none;";
            }
            if (builderPropertiesBorder == 1) {
                style.innerText += "border: 1px solid #eeeeee;";
            } else {
                style.innerText += "border: none;";
            }
            style.innerText += "}";
            style.innerText += ".Properties.Properties-Thumb.Properties-Border.Properties-Shadow .Properties__gallery,\n                .Properties.Properties-Thumb.Properties-Border.Properties-Shadow .Properties__gallery > div {";
            style.innerText += "overflow: hidden !important;";
            if (builderPropertiesRadius != null) {
                style.innerText += "border-top-left-radius: ".concat(builderPropertiesRadius, "px !important;");
                style.innerText += "-moz-border-top-left-radius: ".concat(builderPropertiesRadius, "px !important;");
                style.innerText += "-moz-border-top-right-radius: ".concat(builderPropertiesRadius, "px !important;");
                style.innerText += "border-top-right-radius: ".concat(builderPropertiesRadius, "px !important;");
                style.innerText += "-moz-border-right-left-radius: ".concat(builderPropertiesRadius, "px !important;");
                style.innerText += "-moz-border-right-right-radius: ".concat(builderPropertiesRadius, "px !important;");
            } else {
                style.innerText += "border-radius: 0px;";
            }
            style.innerText += "}";
        // border-radius: ${builderPropertiesRadius}px;box-shadow: ${builderPropertiesShadow};border: ${builderPropertiesBorder}px solid #eeeeee`
        }
        if (builderEstatesBorder != null || builderEstatesRadius != null || builderEstatesShadow != null) {
            style.innerText += ".design-box-estates {";
            style.innerText += "overflow: hidden !important;";
            if (builderEstatesRadius != null) {
                style.innerText += "border-radius: ".concat(builderEstatesRadius, "px !important;");
                style.innerText += "-webkit-border-radius: ".concat(builderEstatesRadius, "px !important;");
                style.innerText += "-khtml-border-radius: ".concat(builderEstatesRadius, "px !important;");
                style.innerText += "-moz-border-radius: ".concat(builderEstatesRadius, "px !important;");
                style.innerText += "border-top-left-radius: ".concat(builderEstatesRadius, "px !important;");
                style.innerText += "-moz-border-top-left-radius: ".concat(builderEstatesRadius, "px !important;");
                style.innerText += "-moz-border-top-right-radius: ".concat(builderEstatesRadius, "px !important;");
                style.innerText += "border-top-right-radius: ".concat(builderEstatesRadius, "px !important;");
                style.innerText += "-moz-border-right-left-radius: ".concat(builderEstatesRadius, "px !important;");
                style.innerText += "-moz-border-right-right-radius: ".concat(builderEstatesRadius, "px !important;");
            } else {
                style.innerText += "border-radius: 0px;";
            }
            if (builderEstatesShadow == 1) {
                style.innerText += "box-shadow: 0 0 15px rgba(0, 0, 0, 0.25);-webkit-box-shadow: 0 0 15px rgba(0, 0, 0, 0.25);-moz-box-shadow: 0 0 15px rgba(0, 0, 0, 0.25);";
            } else {
                style.innerText += "box-shadow: none;-webkit-box-shadow: none;-moz-box-shadow: none;";
            }
            if (builderEstatesBorder == 1) {
                style.innerText += "border: 1px solid #eeeeee;";
            } else {
                style.innerText += "border: none;";
            }
            style.innerText += "}";
            style.innerText += ".Properties.Properties-Thumb.Properties-Border.Properties-Shadow .Properties__gallery,\n                .Properties.Properties-Thumb.Properties-Border.Properties-Shadow .Properties__gallery > div {";
            style.innerText += "overflow: hidden !important;";
            if (builderEstatesRadius != null) {
                style.innerText += "border-top-left-radius: ".concat(builderEstatesRadius, "px !important;");
                style.innerText += "-moz-border-top-left-radius: ".concat(builderEstatesRadius, "px !important;");
                style.innerText += "-moz-border-top-right-radius: ".concat(builderEstatesRadius, "px !important;");
                style.innerText += "border-top-right-radius: ".concat(builderEstatesRadius, "px !important;");
                style.innerText += "-moz-border-right-left-radius: ".concat(builderEstatesRadius, "px !important;");
                style.innerText += "-moz-border-right-right-radius: ".concat(builderEstatesRadius, "px !important;");
            } else {
                style.innerText += "border-radius: 0px;";
            }
            style.innerText += "}";
        // border-radius: ${builderEstatesRadius}px;box-shadow: ${builderEstatesShadow};border: ${builderEstatesBorder}px solid #eeeeee`
        }
        if (builderBookingBoxBorder != null || builderBookingBoxRadius != null || builderBookingBoxShadow != null) {
            style.innerText += ".booking-orders-design-box {";
            if (builderBookingBoxRadius != null) {
                style.innerText += "border-radius: ".concat(builderBookingBoxRadius, "px;");
            } else {
                style.innerText += "border-radius: 0px;";
            }
            if (builderBookingBoxShadow == 1) {
                style.innerText += "box-shadow: 0 0 15px rgba(0, 0, 0, 0.25);-webkit-box-shadow: 0 0 15px rgba(0, 0, 0, 0.25);-moz-box-shadow: 0 0 15px rgba(0, 0, 0, 0.25);";
            } else {
                style.innerText += "box-shadow: none;-webkit-box-shadow: none;-moz-box-shadow: none;";
            }
            if (builderBookingBoxBorder == 1) {
                style.innerText += "border: 1px solid #eeeeee;";
            } else {
                style.innerText += "border: none;";
            }
            style.innerText += "}";
        // border-radius: ${builderPropertiesRadius}px;box-shadow: ${builderPropertiesShadow};border: ${builderPropertiesBorder}px solid #eeeeee`
        }
        if (builderPropertiesViewServicesBorder != null || builderPropertiesViewServicesRadius != null || builderPropertiesViewServicesShadow != null) {
            style.innerText += ".service-item-design-box {";
            if (builderPropertiesViewServicesRadius != null) {
                style.innerText += "border-radius: ".concat(builderPropertiesViewServicesRadius, "px;");
            } else {
                style.innerText += "border-radius: 0px;";
            }
            if (Checkers/* default.isValidPositiveNumber */.Z.isValidPositiveNumber(builderPropertiesViewServicesShadow)) {
                style.innerText += "box-shadow: 0 0 " + builderPropertiesViewServicesShadow + "px rgba(0, 0, 0, 0.25);-webkit-box-shadow: 0 0 " + builderPropertiesViewServicesShadow + "px rgba(0, 0, 0, 0.25);-moz-box-shadow: 0 0 " + builderPropertiesViewServicesShadow + "px rgba(0, 0, 0, 0.25);";
            } else {
                style.innerText += "box-shadow: none;-webkit-box-shadow: none;-moz-box-shadow: none;";
            }
            if (builderPropertiesViewServicesBorder == 1) {
                style.innerText += "border: 1px solid #eeeeee;";
            } else {
                style.innerText += "border: none;";
            }
            style.innerText += "overflow: hidden;";
            style.innerText += "}";
        // border-radius: ${builderPropertiesRadius}px;box-shadow: ${builderPropertiesShadow};border: ${builderPropertiesBorder}px solid #eeeeee`
        }
        if (builderPropertiesBorder != null || builderPropertiesRadius != null || builderPropertiesShadow != null) {
            style.innerText += ".design-box-service {";
            if (builderPropertiesRadius != null) {
                style.innerText += "border-radius: ".concat(builderPropertiesRadius, "px;");
            } else {
                style.innerText += "border-radius: 0px;";
            }
            if (builderPropertiesShadow == 1) {
                style.innerText += "box-shadow: 0px 0px 15px -5px rgba(0, 0, 0, 0.25);-webkit-box-shadow: 0px 0px 15px -5px rgba(0, 0, 0, 0.25);-moz-box-shadow: 0px 0px 15px -5px rgba(0, 0, 0, 0.25);";
            } else {
                style.innerText += "box-shadow: none;-webkit-box-shadow: none;-moz-box-shadow: none;";
            }
            if (builderPropertiesBorder == 1) {
                style.innerText += "border: 1px solid #eeeeee;";
            } else {
                style.innerText += "border: none;";
            }
            style.innerText += "}";
        // border-radius: ${builderPropertiesRadius}px;box-shadow: ${builderPropertiesShadow};border: ${builderPropertiesBorder}px solid #eeeeee`
        }
        if (builderDestinationsRadius != null || builderDestinationsBorder != null || builderDestinationsShadow != null) {
            style.innerText += ".design-box-destination {";
            if (builderDestinationsRadius != null) {
                style.innerText += "border-radius: ".concat(builderDestinationsRadius, "px;");
            } else {
                style.innerText += "border-radius: 0px;";
            }
            if (builderDestinationsShadow == 1) {
                style.innerText += "box-shadow: 0px 0px 15px -5px rgba(0, 0, 0, 0.25);-webkit-box-shadow: 0px 0px 15px -5px rgba(0, 0, 0, 0.25);-moz-box-shadow: 0px 0px 15px -5px rgba(0, 0, 0, 0.25);";
            } else {
                style.innerText += "box-shadow: none;-webkit-box-shadow: none;-moz-box-shadow: none;";
            }
            if (builderDestinationsBorder == 1) {
                style.innerText += "border: ".concat(builderDestinationsThemeColor == 1 ? "1px solid rgba(0,0,0,0.2)" : "1px solid rgba(255,255,255,0.2)", "!important;");
            } else {
                style.innerText += "border: none;";
            }
            style.innerText += "}";
        // border-radius: ${builderPropertiesRadius}px;box-shadow: ${builderPropertiesShadow};border: ${builderPropertiesBorder}px solid #eeeeee`
        }
        if (builderCollectionsShadow != null || builderCollectionsBorder != null || builderCollectionsRadius != null) {
            style.innerText += ".design-box-collection, .design-box-collection .card { overflow: hidden; ";
            if (builderCollectionsRadius != null) {
                style.innerText += "border-radius: ".concat(builderCollectionsRadius, "px;");
            } else {
                style.innerText += "border-radius: 0px;";
            }
            if (builderCollectionsShadow == 1) {
                style.innerText += "box-shadow: 0px 0px 15px -5px rgba(0, 0, 0, 0.25);-webkit-box-shadow: 0px 0px 15px -5px rgba(0, 0, 0, 0.25);-moz-box-shadow: 0px 0px 15px -5px rgba(0, 0, 0, 0.25);";
            } else {
                style.innerText += "box-shadow: none;-webkit-box-shadow: none;-moz-box-shadow: none;";
            }
            if (builderCollectionsBorder == 1) {
                style.innerText += "border: 1px solid #eeeeee;";
            } else {
                style.innerText += "border: none;";
            }
            style.innerText += "}";
        // border-radius: ${builderPropertiesRadius}px;box-shadow: ${builderPropertiesShadow};border: ${builderPropertiesBorder}px solid #eeeeee`
        }
        if (builderExperiencesRadious != null || builderExperiencesShadow != null || builderExperiencesBorder != null) {
            style.innerText += ".experience-design-box { overflow: hidden; ";
            if (builderExperiencesRadious != null) {
                style.innerText += "border-radius: ".concat(builderExperiencesRadious, "px;");
            } else {
                style.innerText += "border-radius: 0px;";
            }
            if (Checkers/* default.isValidPositiveNumber */.Z.isValidPositiveNumber(builderExperiencesShadow)) {
                style.innerText += "box-shadow: 0px 0px " + builderExperiencesShadow + "px -5px rgba(0, 0, 0, 0.25) !important;";
                style.innerText += "-webkit-box-shadow: 0px 0px " + builderExperiencesShadow + "px -5px rgba(0, 0, 0, 0.25) !important;";
                style.innerText += "-moz-box-shadow: 0px 0px " + builderExperiencesShadow + "px -5px rgba(0, 0, 0, 0.25) !important;";
            } else {
                style.innerText += "box-shadow: none;-webkit-box-shadow: none;-moz-box-shadow: none;";
            }
            if (builderExperiencesBorder == 1) {
                style.innerText += "border: 1px solid #eeeeee;";
            } else {
                style.innerText += "border: none;";
            }
            style.innerText += "}";
        // border-radius: ${builderPropertiesRadius}px;box-shadow: ${builderPropertiesShadow};border: ${builderPropertiesBorder}px solid #eeeeee`
        }
        // builderMenuSpacing
        style.innerText += ".navbar-nav > li > a { ";
        if (builderMenuSpacing == "default") {
            style.innerText += "padding: 10px 12px ";
        } else if (builderMenuSpacing == "comfortable") {
            style.innerText += "padding: 10px 15px ";
        } else if (builderMenuSpacing == "compact") {
            style.innerText += "padding: 10px 9px ";
        }
        style.innerText += "}";
        style.innerText += ".service-item-homepage {";
        style.innerText += "box-shadow: 0px 0px " + servicesHomepageShadow + "px -5px rgba(0, 0, 0, 0.25);-webkit-box-shadow: 0px 0px " + servicesHomepageShadow + "px -5px rgba(0, 0, 0, 0.25);-moz-box-shadow: 0px 0px " + servicesHomepageShadow + "px -5px rgba(0, 0, 0, 0.25);";
        style.innerText += "border-radius: ".concat(servicesHomepageRadious, "px !important;");
        style.innerText += "overflow: hidden;";
        style.innerText += "}";
        style.innerText += ".nav-tabs-fillup > li > a:after { background-color: rgb(" + rgbDesignColor + "); border: none; }";
        style.innerText += ".nav-tabs-fillup > li > a.active > span.main-design-color { color: rgb(255, 255, 255) !important; }";
        if (disableUiControls) {
            style.innerText += "#map .gm-style { pointer-events: none !important; }";
        }
        if (menuIconBorder) {
            style.innerText += ".Header.Header-Dark-Transparent .navbar-toggle { border: 2px solid #ffffff !important; }";
            style.innerText += ".Header.Header-Dark-Transparent .navbar-toggle svg { margin-top: 2px; }";
            style.innerText += ".Header.Header-Light .navbar-toggle svg { margin-top: 2px; }";
            style.innerText += ".Header.Header-Light .navbar-toggle { border: 2px solid " + headerMenuColor + " !important; }";
        }
        style.innerText += customStyles;
        // head.appendChild(style);
        // console.log("style.innerText", style.innerText)
        return style.innerText;
    };
    // useEffect(() => {
    //     initialiazeStyle()
    // });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
            dangerouslySetInnerHTML: {
                __html: initialiazeStyle()
            }
        })
    });
};
/* harmony default export */ var partials_InlineStyles = (InlineStyles);

;// CONCATENATED MODULE: ./layouts/MainLayout.tsx












function MainLayout(props) {
    var ref = (0,react.useState)(null), urlHref = ref[0], setUrlHref = ref[1];
    var app = props.app;
    var rgbDesignColor = props.rgbDesignColor;
    var rgbSearchbarColor = props.rgbSearchbarColor;
    react.useEffect(function() {
        fancybox_esm/* Fancybox.bind */.KR.bind("[data-fancybox]", {
            Image: {
                zoom: false
            },
            Hash: false
        });
        if (window !== undefined) {
            setUrlHref(window.location.href + "/");
        }
    }, [
        urlHref
    ]);
    var mainPacer = (0,es/* useSelector */.v9)(function(state) {
        return state["uiData"]["mainPacer"];
    });
    var disablePacer = false;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_InlineStyles, {
                app: app,
                rgbDesignColor: rgbDesignColor,
                rgbSearchbarColor: rgbSearchbarColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header["default"], (0,_object_spread/* default */.Z)({
                referer: urlHref
            }, props)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderPacer, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoaderComponent, {}),
            !mainPacer || disablePacer ? props.children : /*#__PURE__*/ (0,jsx_runtime.jsx)(MainLayoutSkeleton, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterWrapper, (0,_object_spread/* default */.Z)({}, props)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BodyEndSectionsWrapper, {})
        ]
    });
}


/***/ })

}]);